<template>
  <f7-page name="mi-trabajo-hoy" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Mi trabajo de hoy</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="cargar" icon-f7="arrow_2_circlepath" style="color:#c8d3e5"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · se lee en directo de la consulta de Facturas, sin caché, y aquí con más motivo: es la
         pantalla desde la que se llama, y llamar sobre una foto vieja es llamar a quien ya ha
         llamado otro. -->
    <div class="sello-datos-bar" v-if="hayDatos"><sello-datos estado="vivo" /></div>
    <f7-page-content style="padding-top:0">

      <f7-block v-if="cargando" class="text-align-center"><f7-preloader></f7-preloader></f7-block>

      <f7-block v-if="error" class="aviso-error">{{ error }}</f7-block>

      <!-- EL RESULTADO DE LA ÚLTIMA ESCRITURA · FUERA del `v-if` del `dto`, igual que en la bandeja
           de #188 y por el mismo motivo: después de escribir se recarga la lista, y si esa recarga
           falla el `dto` se queda en null. Ahí dentro, el aviso de «no se sabe si se ha guardado» se
           quedaría oculto justo en el caso para el que se escribió —una caída de red tumba las dos
           peticiones— y la persona solo vería el error genérico de carga. -->
      <div class="bloque bloque-escritura" v-if="ultimaEscritura"
        :class="{'bloque-escritura-mal': ultimaEscritura.mal}">
        <p class="bloque-titulo">
          Lo último que has hecho
          <button type="button" class="boton-ocultar" @click="ultimaEscritura = null">
            Ocultar
          </button>
        </p>
        <p class="escritura-resumen" :class="{'escritura-resumen-mal': ultimaEscritura.mal}">
          {{ ultimaEscritura.resumen }}
        </p>
        <p class="escritura-aviso" v-for="(aviso, i) in ultimaEscritura.avisos" :key="i">
          {{ aviso }}
        </p>
        <!-- Y cuando lo único que se puede hacer es mirar el historial de esa factura, el control
             está AQUÍ, al lado de la frase que lo dice. Lo decide el servidor (`revisaElHistorial`):
             es la condición con la que dirección aceptó el 10/10/2026 que dos llamadas a la misma
             factura en el mismo minuto se tomen por «ya estaba hecha». Un aviso que manda revisar el
             historial sin un botón para abrirlo es el mismo defecto que un botón mudo. -->
        <f7-button small outline class="boton-comprobar" v-if="ultimaEscritura.verHistorialDe"
          @click="abrirHistorial(ultimaEscritura.verHistorialDe)">
          Ver el historial de {{ texto(ultimaEscritura.verHistorialDe.codigo) }}
        </f7-button>
      </div>

      <!-- LAS ESCRITURAS DE LAS QUE NO SE SABE SI QUEDARON GUARDADAS · un bloque propio y FUERA de
           «Lo último que has hecho», que se puede ocultar: una duda no es una noticia pasada, es una
           pregunta abierta, y cada una lleva su propio control para resolverla. Antes el único
           control vivía DENTRO del formulario de la promesa, así que el aviso de una gestión mandaba
           pulsar un botón que no se dibujaba (revisión CODEX, ronda 9, hallazgo `:1496`). -->
      <div class="bloque bloque-escritura bloque-escritura-mal" v-if="dudasPendientes.length">
        <p class="bloque-titulo">
          {{ dudasPendientes.length === 1
            ? 'Hay una anotación de la que no se sabe si quedó guardada'
            : 'Hay anotaciones de las que no se sabe si quedaron guardadas' }}
        </p>
        <!-- La `key` es la LLAVE DE LA OPERACIÓN, la misma con la que la duda vive en el mapa: dos
             pestañas pueden dejar dos dudas del mismo tipo sobre la misma factura —se conservan a
             propósito, cada una con su referencia— y con `tipo + idFactura` las dos filas tenían la
             misma clave, así que Vue podía reutilizar el subárbol de una para la otra y el botón
             «Comprobar si se guardó» quedaba apuntando a la operación equivocada. -->
        <div v-for="duda in dudasPendientes"
          :key="llaveDeOperacion(duda.tipo, duda.idFactura, duda.clave)">
          <!-- El porqué cambia según de dónde venga la duda, y se dice el que es: de una anotación
               que salió desde OTRA pestaña de esta misma persona no consta que su petición se
               cortara —puede estar guardándose ahí ahora mismo—, y contarlo como un corte sería
               afirmar algo que no se sabe. Lo que no cambia es lo que se puede hacer. -->
          <p class="escritura-resumen escritura-resumen-mal">
            No se sabe si {{ loQueSeEscribia(duda.tipo) }} de la factura
            {{ texto(duda.codigoFactura) }} se guardó:
            <template v-if="duda.deOtraPestana">salió desde otra pestaña tuya y desde aquí no se ve
            en qué ha quedado.</template>
            <template v-else>la petición se cortó sin respuesta y el servidor puede haberla
            escrito.</template>
            No se repite sola, y repetirla a mano con esta pantalla no la duplica: lleva la misma
            referencia.
          </p>
          <f7-button small outline class="boton-comprobar" :disabled="duda.comprobando"
            @click="reconciliarEscrituraEnDuda(duda)">
            {{ duda.comprobando ? 'Comprobando…' : 'Comprobar si se guardó' }}
          </f7-button>
          <!-- Y el historial, cuando el servidor ha dicho que no ha podido comprobarlo: ahí
               comprobar otra vez no va a contestar nada distinto, y lo que esta persona sí puede
               hacer es mirar las gestiones de esa factura. -->
          <template v-if="duda.revisaElHistorial">
            <f7-button small outline class="boton-comprobar"
              @click="abrirHistorial({ id: duda.idFactura, codigo: duda.codigoFactura })">
              Ver el historial de {{ texto(duda.codigoFactura) }}
            </f7-button>
            <!-- Y LA SALIDA, que es la otra mitad de no quedarse mudo: mientras esta duda esté
                 puesta, la referencia sigue reservada en el servidor, así que volver a pulsar en
                 esa factura contesta «se está escribiendo ahora mismo» y no escribe nada. Eso no
                 lo puede decidir la pantalla sola —si lo decidiera, podría escribirse dos veces—,
                 así que lo decide quien ha mirado el historial: dice qué pasa, quién lo desbloquea
                 (ella) y dónde (este botón), que es lo que pide la regla de dirección. -->
            <p class="escritura-resumen escritura-resumen-mal">
              Si en ese historial no aparece, puedes volver a empezar con esta factura: el servidor
              no puede descartarlo él solo, así que lo confirmas tú aquí.
            </p>
            <f7-button small outline class="boton-comprobar"
              @click="descartarDudaTrasElHistorial(duda)">
              He mirado el historial y no está: empezar de nuevo
            </f7-button>
          </template>
        </div>
      </div>

      <template v-if="dto && !cargando">

        <!-- D-COB-5 · qué parte de la cartera se está viendo y de quién es esta lista. Las dos las
             dice el servidor, que es quien aplica el recorte y quien decide de quién es la lista: si
             lo escribiera la pantalla, podría estar enseñando una lista y creer que es otra. -->
        <div class="linea-alcance">
          <f7-icon f7="person_crop_circle" class="linea-alcance-icono"></f7-icon>
          <span>{{ dto.deQuienEsLaLista }}</span>
        </div>
        <div class="linea-alcance linea-alcance-tenue">
          <f7-icon f7="eye" class="linea-alcance-icono"></f7-icon>
          <span>{{ dto.alcance }}</span>
        </div>

        <!-- LA CABECERA · LA BANDEJA DE #188, mientras queden facturas sin gestor. Cuando no quedan
             ninguna, este bloque NO se dibuja: no hay nada que repartir y un cero ahí sería ruido. -->
        <div class="bloque bloque-bandeja" v-if="dto.hayBandeja">
          <p class="bloque-titulo">
            <f7-icon f7="person_badge_plus" class="bloque-titulo-icono"></f7-icon>
            Antes de llamar: hay cartera sin dueño
          </p>
          <p class="bandeja-cifra">
            {{ numero(dto.facturasSinGestor) }}
            {{ dto.facturasSinGestor === 1 ? 'factura' : 'facturas' }}
            sin gestor de cobro · {{ formatEuros(dto.importeSinGestor) }} € de saldo pendiente
          </p>
          <p class="bandeja-nota">{{ dto.notaBandeja }}</p>
          <!-- El enlace solo para quien puede repartir (criterio 5 de #188). Quien no puede ve el
               recuento igual —saber cuánto hay sin dueño es información— y en vez del botón lee a
               quién pedírselo: un botón que lleva a un sitio donde no se puede hacer nada es peor
               que no tener botón. -->
          <f7-button v-if="dto.puedeAsignar" fill small class="boton-bandeja"
            href="/dashboard/cobros/asignacion/">
            Repartirlas en la bandeja de asignación
          </f7-button>
          <p class="bandeja-solo-lectura" v-else>{{ dto.motivoSoloLectura }}</p>
        </div>

        <!-- EL SELECTOR DE GESTOR · solo para quien ve toda la cartera (criterio 10). -->
        <div class="bloque" v-if="dto.puedeElegirGestor">
          <p class="bloque-titulo">¿De quién es la lista?</p>
          <select v-model="deQuien" class="selector-gestor" @change="cargar">
            <option value="">Toda la cartera</option>
            <option value="__SIN_GESTOR__">Solo las que no tienen gestor asignado</option>
            <option v-for="opcion in gestoresConCartera" :key="opcion.clave" :value="opcion.clave">
              {{ opcion.etiqueta }} ({{ opcion.documentos }})
            </option>
          </select>
          <p class="ayuda" v-if="!gestoresConCartera.length">
            Todavía no hay ninguna factura con gestor de cobro asignado, así que no hay ninguna
            lista por gestor que mirar. Se asignan en la bandeja de asignación.
          </p>
          <p class="ayuda" v-if="gestorElegidoYaNoTieneCartera">
            {{ deQuien }} ya no tiene ninguna factura abierta asignada. La lista sale vacía: no es
            un fallo, es que no le queda cartera.
          </p>
        </div>

        <!-- POR QUÉ ESTÁN EN ESTE ORDEN · la fórmula, escrita. Criterio 3: quien usa la pantalla
             tiene que poder entender por qué una factura está la primera; si no, no se fía y vuelve
             a su lista de siempre. Los textos los manda la API porque son las decisiones de
             dirección sobre el cálculo, no frases de pantalla. -->
        <div class="bloque bloque-formula">
          <p class="bloque-titulo">Por qué están en este orden</p>
          <p class="formula">{{ dto.formula }}</p>
          <p class="formula-nota">{{ dto.notaProbabilidad }}</p>
          <p class="formula-nota">{{ dto.notaSilencio }}</p>
          <p class="formula-nota">{{ dto.notaSoloVencidas }}</p>
          <p class="formula-nota">{{ dto.notaSaldoPendiente }}</p>
          <p class="formula-nota">{{ dto.notaGestionada }}</p>
          <p class="formula-nota">{{ dto.notaPromesa }}</p>
        </div>

        <!-- EL RESUMEN DE LA COLA · el contraste del criterio 13 y lo que se queda fuera. -->
        <div class="bloque">
          <p class="bloque-titulo">La cola completa</p>
          <p class="cola-cifra">
            {{ numero(dto.candidatas) }}
            {{ dto.candidatas === 1 ? 'factura vencida' : 'facturas vencidas' }}
            · {{ formatEuros(dto.importeCandidatas) }} € de saldo pendiente
          </p>
          <!-- Una suma de saldos tiene que decir cuántas facturas no aportan euros: sin esto, una
               de la que no se sabe cuánto debe se suma como cero y la cifra parece completa. Lo
               cuenta el servidor y la frase la escribe él, igual que en la cartera. -->
          <p class="ayuda ayuda-ojo" v-if="dto.notaCandidatasSinSaldo">
            {{ dto.notaCandidatasSinSaldo }}
          </p>
          <p class="ayuda" v-if="dto.fichasOmitidas">
            Se trabajan las {{ dto.tope }} de más prioridad. Las otras
            {{ numero(dto.fichasOmitidas) }} siguen en la cola: en cuanto gestiones éstas, recarga y
            suben las siguientes.
          </p>
          <!-- Y qué es el tramo del final: las que ya se han gestionado hoy no son trabajo
               pendiente pero siguen en la lista, que es lo que permite volver a ver lo que se
               acaba de anotar en cada una (criterios 6 y 9). La frase la escribe el servidor, que
               es quien decide el recorte, igual que las demás notas de esta pantalla. -->
          <p class="ayuda" v-if="dto.notaGestionadasHoy">{{ dto.notaGestionadasHoy }}</p>
          <p class="ayuda">
            Fuera de la lista: {{ numero(dto.enPlazoExcluidos) }} en plazo,
            {{ numero(dto.abonosExcluidos) }} abonos abiertos<template
              v-if="dto.sinVencimientoExcluidos">,
              {{ numero(dto.sinVencimientoExcluidos) }} sin fecha de vencimiento —de ésas no se
              puede decir si están vencidas—</template><template v-if="dto.sinTipoExcluidos">,
              {{ numero(dto.sinTipoExcluidos) }} que no dicen si son factura o abono</template>.
          </p>
        </div>

        <!-- LAS DIEZ DE HOY -->
        <p class="bloque-vacio" v-if="!fichas.length">{{ dto.textoListaVacia }}</p>

        <div class="ficha" v-for="ficha in fichas" :key="ficha.id"
          :class="{'ficha-apagada': ficha.motivoCodigo === 'GESTIONADA_HOY'
            || ficha.motivoCodigo === 'GESTION_PLANIFICADA'
            || ficha.motivoCodigo === 'SIN_SALDO'}">

          <!-- CABECERA DE LA FICHA · quién y qué factura -->
          <div class="ficha-cabecera">
            <span class="ficha-puesto">{{ ficha.puesto }}</span>
            <div class="ficha-identidad">
              <p class="ficha-cliente">{{ texto(ficha.cliente) }}</p>
              <p class="ficha-factura">
                <button type="button" class="enlace-factura" v-if="ficha.id"
                  :title="'Abrir la ficha de ' + texto(ficha.codigo) + ' en una pestaña nueva'"
                  @click="abrirFicha(ficha)">{{ texto(ficha.codigo) }}</button>
                <span v-else>{{ texto(ficha.codigo) }}</span>
                <span class="ficha-forma-pago" :class="{'celda-falta': !ficha.formaPago}">
                  · {{ texto(ficha.formaPago) }}
                </span>
              </p>
            </div>
          </div>

          <!-- LOS TRES FACTORES EN CLARO · criterio 3. El producto NO se pinta: la API no lo manda
               y esta pantalla no lo calcula. -->
          <p class="ficha-factores">
            <!-- Un saldo que NO HA LLEGADO no se pinta como un importe: «— €» se lee como cero
                 euros y esta factura puede deber miles. Lo dice con palabras y el motivo de abajo
                 explica dónde se arregla (D-COB-8). -->
            <span class="factor factor-sin-dato" v-if="ficha.saldoDesconocido">
              saldo sin dato
            </span>
            <span class="factor factor-importe" v-else>{{ formatEuros(ficha.saldoPendiente) }} €</span>
            <span class="factor">{{ ficha.diasVencida }}
              {{ ficha.diasVencida === 1 ? 'día vencida' : 'días vencida' }}</span>
            <span class="factor">{{ ficha.diasSinGestion }}
              {{ ficha.diasSinGestion === 1 ? 'día sin gestión' : 'días sin gestión' }}</span>
          </p>
          <p class="ficha-factores-pie">
            Vencía el {{ formatFecha(ficha.fechaVencimiento) }}.
            <template v-if="ficha.nuncaGestionada">
              Los días sin gestión se cuentan desde el vencimiento: nunca se ha gestionado después
              de vencer.
            </template>
            <!-- Una T0045 apuntada para un día que no ha llegado NO es «la última gestión»: no se
                 ha hecho. Los días sin gestión son 0 igual que en una gestionada hoy, así que si no
                 se dijera cuál de las dos es, la pantalla afirmaría de ésta lo que solo es verdad
                 de la otra. -->
            <template v-else-if="ficha.gestionPlanificada">
              Gestión de cobro planificada para el {{ formatFecha(ficha.silencioDesde) }}:
              todavía no se ha hecho, así que los días sin gestión se cuentan en 0.
            </template>
            <template v-else>
              Última gestión de cobro: {{ formatFecha(ficha.silencioDesde) }}.
            </template>
          </p>

          <!-- EL MOTIVO · por qué está aquí, en una frase. Lo escribe la API. -->
          <p class="ficha-motivo" :class="'ficha-motivo-' + (ficha.motivoCodigo || '').toLowerCase()">
            {{ texto(ficha.motivo) }}
          </p>

          <!-- EL CONTACTO · de la ficha del cliente, sin teclearlo otra vez (criterio 8). -->
          <div class="ficha-contacto">
            <p class="ficha-contacto-linea" v-if="ficha.contacto && ficha.contacto.telefono">
              <f7-icon f7="phone" class="ficha-contacto-icono"></f7-icon>
              <a :href="'tel:' + ficha.contacto.telefono" class="ficha-telefono">
                {{ ficha.contacto.telefono }}
              </a>
              <span class="ficha-contacto-quien">
                <template v-if="ficha.contacto.nombre">· {{ ficha.contacto.nombre }}</template>
                <template v-if="ficha.contacto.cargo"> ({{ ficha.contacto.cargo }})</template>
              </span>
            </p>
            <p class="ficha-contacto-origen" v-if="ficha.contacto && ficha.contacto.origenTelefono">
              {{ ficha.contacto.origenTelefono }}
            </p>
            <!-- D-COB-8 · lo que no está se dice, y se dice DÓNDE se rellena. Junto al dato que
                 falta, no en un aviso al principio de la pantalla. -->
            <p class="ficha-falta" v-if="ficha.contacto && ficha.contacto.queFalta">
              <f7-icon f7="exclamationmark_triangle" class="ficha-falta-icono"></f7-icon>
              <span>{{ ficha.contacto.queFalta }}</span>
            </p>
            <!-- El código del cliente que no cuadra: la frase la escribe la API y no esta
                 pantalla, porque es la MISMA que sale en los avisos al crear la gestión y porque
                 dice dónde se limpia (COB-0, #186). Escritas aparte, el módulo acabaría diciendo
                 dos cosas del mismo dato, que es justo lo que decidió dirección el 10/10/2026. -->
            <p class="ficha-falta" v-if="ficha.avisoCliente">
              <f7-icon f7="exclamationmark_triangle" class="ficha-falta-icono"></f7-icon>
              <span>{{ ficha.avisoCliente }}</span>
            </p>
          </div>

          <!-- LA ÚLTIMA PROMESA CON SU RESULTADO. Dos marcas y no una: en rojo solo lo que el
               gestor dijo que falló; una promesa que únicamente se ha pasado de fecha se avisa
               aparte, porque de ésa no se sabe en qué quedó —lo prometido podía ser una parte del
               saldo, así que la factura seguiría abierta con la promesa cumplida—. -->
          <div class="ficha-promesa" v-if="ficha.ultimaPromesa"
            :class="{'ficha-promesa-mal': ficha.ultimaPromesa.incumplida,
              'ficha-promesa-duda': ficha.ultimaPromesa.vencidaSinCerrar}">
            <p class="ficha-promesa-titulo">Última promesa de pago</p>
            <p class="ficha-promesa-cuerpo">
              {{ formatEurosExactos(ficha.ultimaPromesa.importeComprometido) }} € para el
              {{ formatFecha(ficha.ultimaPromesa.fechaComprometida) }} ·
              <strong>{{ texto(ficha.ultimaPromesa.rotuloResultado) }}</strong>
            </p>
            <p class="ficha-promesa-aviso" v-if="ficha.ultimaPromesa.vencidaSinCerrar">
              Esa fecha ya pasó y nadie ha cerrado la promesa, así que no se sabe en qué quedó: que
              la factura siga abierta no lo dice, porque lo prometido podía ser solo una parte del
              saldo. Pregúntalo en la llamada y anótalo al cerrar la gestión.
            </p>
            <!-- EL COMENTARIO DE LA PROMESA, junto a ella (dirección, 19/10/2026): es lo que
                 explica por qué el cliente prometió eso, y sin él la ficha enseña una cifra y una
                 fecha sin contexto. Si no hay ninguno NO se dibuja nada: el campo es opcional, y
                 una línea vacía con su rótulo diría que falta algo que no falta. -->
            <p class="ficha-promesa-comentario" v-if="comentarioDe(ficha.ultimaPromesa.comentario)">
              <f7-icon f7="text_quote" class="ficha-promesa-comentario-icono"></f7-icon>
              <span>{{ comentarioDe(ficha.ultimaPromesa.comentario) }}</span>
            </p>
            <p class="ficha-promesa-pie">
              Anotada por {{ texto(ficha.ultimaPromesa.anotadaPor) }} sobre la gestión
              {{ texto(ficha.ultimaPromesa.codigoTarea) }}
            </p>
          </div>
          <p class="ficha-promesa-ninguna" v-else>
            Sin ninguna promesa de pago anotada.
          </p>

          <!-- LOS BOTONES -->
          <div class="ficha-botones">
            <!-- EL BOTÓN SE APAGA EN TODAS LAS FICHAS, no solo en la que se está creando: el
                 guardia de `crearGestion` rechaza la pulsación de CUALQUIER ficha mientras hay una
                 creación en vuelo, así que apagar solo ésta dejaba los otros nueve botones con
                 pinta de disponibles y sin hacer nada al pulsarlos (revisión CODEX, ronda 5). Los
                 dos preguntan ahora lo mismo, `creandoGestion`. -->
            <button type="button" class="boton-gestion" :disabled="creandoGestion"
              @click="crearGestion(ficha)">
              {{ creandoEn === ficha.id ? 'Creando…' : 'Crear gestión de cobro' }}
            </button>
            <button type="button" class="boton-secundario" @click="abrirHistorial(ficha)">
              Ver historial ({{ numero(ficha.gestiones) }})
            </button>
            <!-- CRITERIO DE PANTALLA (dirección, 05/10/2026): un control que no se puede usar dice
                 POR QUÉ, QUIÉN lo desbloquea y DÓNDE, y lo dice JUNTO AL CONTROL. El texto lo manda
                 la API en `porqueNoSePuedeAnotarPromesa`. -->
            <button type="button" class="boton-secundario" :disabled="!ficha.sePuedeAnotarPromesa"
              @click="pulsarAnotarPromesa(ficha)">
              Anotar promesa de pago
            </button>
          </div>
          <!-- Y apagado dice por qué, igual que el de anotar la promesa: el mismo criterio de
               dirección. Cuelga del MISMO `creandoGestion` que apaga el botón —y no de que la
               creación en vuelo sea de otra ficha—, porque si fuera de ésta el botón se quedaría
               apagado y mudo, que es el defecto que la regla prohíbe. Lo que cambia según el caso
               es el texto, no si se dice. -->
          <p class="ficha-bloqueado" v-if="creandoGestion">
            {{ porqueNoSePuedeCrearGestion(ficha) }}
          </p>
          <p class="ficha-bloqueado" v-if="!ficha.sePuedeAnotarPromesa">
            {{ ficha.porqueNoSePuedeAnotarPromesa }}
          </p>
          <!-- Y encendido también puede tener algo que decir: la API avisa cuando desde la lista
               no se puede afirmar que haya una gestión ya ocurrida (su gestión más reciente está
               fechada después de hoy). El botón sigue activo —apagarlo afirmaría un hecho que
               nadie ha comprobado— y quien lo resuelve exacto es el formulario, que carga el
               historial al abrirse. -->
          <p class="ficha-aviso" v-if="ficha.sePuedeAnotarPromesa && ficha.avisoAnotarPromesa">
            {{ ficha.avisoAnotarPromesa }}
          </p>
        </div>
      </template>
    </f7-page-content>

    <!-- EL HISTORIAL · las gestiones y las promesas de una factura, sin salir de la pantalla.
         `data-popup-enhanced` para que el enhancer de `app.js` no le añada una segunda X al lado de
         la de esta navbar (ver `enhanceComponentPopups`).

         EL ABIERTO/CERRADO VA EN `:opened` Y NO EN UN `v-if`, que es el fallo 1 de la prueba de ABM
         en preview-2 (15/10/2026): con `v-if` + `:opened="true"`, poner el estado a `false` desde el
         código —que es lo que hace el guardado de la promesa al terminar bien— BORRA DEL DOM un
         popup que Framework7 tiene por abierto. Su `destroy()` no retira la cortina
         (`.popup-backdrop.backdrop-in`) ni la clase `with-modal-popup` del `html`, así que la
         pantalla se quedaba en gris, sin poder pulsar ni desplazar, y había que recargar con F5. Con
         `:opened` cierra Framework7: retira su cortina y solo entonces desaparece. -->
    <f7-popup class="popup-historial" :opened="historial.abierto" swipe-to-close
      data-popup-enhanced="true" @popup:close="historial.abierto = false">
      <f7-page>
        <f7-navbar :title="historial.titulo">
          <f7-nav-right><f7-link popup-close>Cerrar</f7-link></f7-nav-right>
        </f7-navbar>
        <f7-block v-if="historial.cargando" class="text-align-center">
          <f7-preloader></f7-preloader>
        </f7-block>
        <f7-block v-if="historial.error" class="aviso-error">{{ historial.error }}</f7-block>
        <template v-if="!historial.cargando && !historial.error">
          <f7-block-title>Gestiones de cobro</f7-block-title>
          <f7-block v-if="!historial.gestiones.length">
            Esta factura no tiene ninguna tarea de gestión de cobro.
          </f7-block>
          <f7-block v-else>
            <div v-for="gestion in historial.gestiones" :key="gestion.id" class="historial-fila">
              <p class="historial-cabecera">
                <strong>{{ formatFecha(gestion.fecha) }}</strong>
                <span class="historial-estado">{{ texto(gestion.estado) }}</span>
                <span class="historial-cuenta" v-if="gestion.cuentaParaGestionada === true">
                  posterior al vencimiento
                </span>
                <span class="historial-nocuenta" v-else-if="gestion.cuentaParaGestionada === false">
                  anterior al vencimiento: no cuenta como gestionada
                </span>
                <span class="historial-nocuenta" v-else>
                  la factura no tiene fecha de vencimiento: no se puede decidir
                </span>
              </p>
              <p class="historial-detalle">
                {{ texto(gestion.codigo) }} · {{ texto(gestion.descripcion) }}
                <span v-if="gestion.empleado">· {{ gestion.empleado }}</span>
              </p>
              <p class="historial-detalle" v-if="gestion.comentarios">{{ gestion.comentarios }}</p>
              <p class="historial-origen">Fecha tomada de: {{ gestion.origenFecha }}</p>
            </div>
          </f7-block>

          <f7-block-title>Promesas de pago</f7-block-title>
          <f7-block v-if="!historial.promesas.length">
            Todavía no se ha anotado ninguna promesa de pago de esta factura.
          </f7-block>
          <f7-block v-else>
            <div v-for="promesa in historial.promesas" :key="promesa.id" class="historial-fila"
              :class="{'historial-fila-mal': promesa.incumplida,
                'historial-fila-duda': promesa.vencidaSinCerrar}">
              <p class="historial-cabecera">
                <strong>{{ formatEurosExactos(promesa.importeComprometido) }} € para el
                  {{ formatFecha(promesa.fechaComprometida) }}</strong>
                <span class="historial-estado">{{ texto(promesa.rotuloResultado) }}</span>
              </p>
              <p class="historial-detalle">{{ texto(promesa.explicacionResultado) }}</p>
              <p class="historial-detalle" v-if="promesa.vencidaSinCerrar">
                Su fecha ya pasó y sigue sin cerrar: no se sabe en qué quedó.
              </p>
              <!-- Cada promesa con su comentario (dirección, 19/10/2026). Mismo criterio que en la
                   ficha: sin comentario no se dibuja el rótulo. -->
              <p class="historial-comentario" v-if="comentarioDe(promesa.comentario)">
                <f7-icon f7="text_quote" class="historial-comentario-icono"></f7-icon>
                <span>{{ comentarioDe(promesa.comentario) }}</span>
              </p>
              <p class="historial-origen">
                Anotada por {{ texto(promesa.anotadaPor) }} el
                {{ formatFechaHora(promesa.fechaAnotacion) }} sobre la gestión
                {{ texto(promesa.codigoTarea) }}
              </p>
            </div>
          </f7-block>
        </template>
      </f7-page>
    </f7-popup>

    <!-- EL FORMULARIO DE LA PROMESA · los tres campos que anota el gestor al cerrar la gestión.
         `:opened` y no `v-if`, por lo mismo que el historial de arriba: éste es el popup que se
         cierra SOLO al guardar, así que era el que dejaba la pantalla en gris. -->
    <f7-popup class="popup-promesa" :opened="promesa.abierto"
      data-popup-enhanced="true" @popup:close="alCerrarElPopupDeLaPromesa">
      <f7-page>
        <f7-navbar title="Anotar promesa de pago">
          <f7-nav-right><f7-link popup-close>Cerrar</f7-link></f7-nav-right>
        </f7-navbar>
        <f7-block v-if="promesa.cargando" class="text-align-center"><f7-preloader></f7-preloader></f7-block>
        <f7-block v-if="promesa.error" class="aviso-error">{{ promesa.error }}</f7-block>
        <template v-if="!promesa.cargando">
          <f7-block>
            <p class="promesa-contexto">
              <strong>{{ texto(promesa.cliente) }}</strong><br />
              Factura {{ texto(promesa.codigoFactura) }} ·
              <!-- Lo mismo que en la ficha, y por lo mismo: si arriba dice «saldo sin dato» y aquí
                   «— €», son dos partes de la misma pantalla diciendo cosas distintas. -->
              <span v-if="promesa.saldoDesconocido" class="celda-falta">
                el saldo pendiente no ha llegado: compruébalo en la factura
              </span>
              <template v-else>saldo pendiente {{ formatEuros(promesa.saldoPendiente) }} €</template>
            </p>
            <p class="ayuda" v-if="!promesa.confirmacion">
              Se anota sobre la gestión en la que el cliente la ha dado. No cambia el estado de la
              factura ni de la tarea: solo deja escrito qué prometió.
            </p>
          </f7-block>

          <!-- LA CONFIRMACIÓN DE LO QUE SE ACABA DE ANOTAR · fallo 3 de la prueba de dirección del
               19/10/2026: «el formulario se cierra y no queda a la vista lo que se acaba de anotar.
               Tiene que quedar una confirmación visible con importe, fecha, resultado y comentario».
               Los cuatro están aquí, releídos de la respuesta del servidor, y el popup NO se cierra
               solo: lo cierra la persona cuando lo ha leído.

               Los campos del formulario desaparecen mientras esto está delante (`v-else` de abajo) y
               no se quedan a su lado: con el botón de anotar todavía encendido, pulsarlo otra vez
               guardaría una SEGUNDA promesa —la referencia de esta ya está resuelta, así que la
               siguiente pulsación saldría con una nueva—. Para anotar otra se cierra y se vuelve a
               abrir, que es lo que ya se hacía. -->
          <template v-if="promesa.confirmacion">
            <f7-block class="promesa-confirmada">
              <p class="promesa-confirmada-titulo">
                <f7-icon f7="checkmark_seal" class="promesa-confirmada-icono"></f7-icon>
                Promesa anotada
              </p>
              <p class="promesa-confirmada-cuerpo">
                <strong>{{ promesa.confirmacion.importe }} €</strong> para el
                <strong>{{ promesa.confirmacion.fecha }}</strong> ·
                <strong>{{ promesa.confirmacion.resultado }}</strong>
              </p>
              <p class="promesa-confirmada-detalle">{{ promesa.confirmacion.explicacionResultado }}</p>
              <!-- El comentario, con su rótulo, y diciendo cuándo no hay ninguno en vez de dejar el
                   hueco: así quien creía haber escrito algo y no lo mandó se entera aquí y no tres
                   días después leyendo el historial. -->
              <p class="promesa-confirmada-comentario" v-if="promesa.confirmacion.comentario">
                <f7-icon f7="text_quote" class="promesa-confirmada-comentario-icono"></f7-icon>
                <span>{{ promesa.confirmacion.comentario }}</span>
              </p>
              <p class="promesa-confirmada-detalle" v-else>
                Sin comentario: no has escrito ninguno.
              </p>
              <p class="promesa-confirmada-pie">
                Queda anotada sobre la gestión {{ promesa.confirmacion.gestion }}. La lista de abajo
                ya se ha rehecho, así que esta factura habrá bajado de puesto: no hace falta recargar
                nada.
              </p>
              <!-- Y lo que no se haya podido hacer, aquí mismo: hoy el único caso es que el
                   comentario no se haya podido copiar en los Comentarios de la gestión. La promesa
                   está guardada igual, y la frase del servidor lo dice empezando por eso. -->
              <p class="promesa-confirmada-aviso" v-for="(aviso, i) in promesa.confirmacion.avisos"
                :key="i">
                {{ aviso }}
              </p>
            </f7-block>
            <f7-block>
              <f7-button fill @click="cerrarPromesa">Listo</f7-button>
              <p class="ayuda">
                Para anotar otra promesa de esta factura, cierra esto y vuelve a pulsar «Anotar
                promesa» en su ficha.
              </p>
            </f7-block>
          </template>

          <template v-else>
          <!-- NO SE OFRECE UNA GESTIÓN QUE LA ESCRITURA VA A RECHAZAR. El desplegable sale de las
               ELEGIBLES —las que ya han ocurrido, que las dice el servidor— y no de todas: una
               T0045 planificada para mañana se ve en el historial, porque es un dato que el gestor
               necesita, pero una promesa es lo que el cliente dijo durante esa gestión. Y cuando no
               hay ninguna elegible, la frase la manda el servidor (`porqueNoSePuedeAnotar`): es la
               misma que saldría al guardar, así que la pantalla y el servidor no pueden explicar de
               dos maneras la misma puerta cerrada. -->
          <f7-block v-if="!gestionesElegibles.length" class="aviso-error">
            {{ porqueNoSePuedeAnotarAqui }}
          </f7-block>
          <f7-list v-else no-hairlines-md>
            <f7-list-input label="Gestión en la que lo ha prometido" type="select"
              :disabled="promesaInmovil"
              :value="promesa.idTarea"
              @change="escribirEnElBorrador('idTarea', $event.target.value)">
              <option v-for="gestion in gestionesElegibles" :key="gestion.id" :value="gestion.id">
                {{ formatFecha(gestion.fecha) }} · {{ texto(gestion.codigo) }}
                <template v-if="gestion.empleado">· {{ gestion.empleado }}</template>
              </option>
            </f7-list-input>
            <f7-list-input label="Importe comprometido (€)" type="number" step="0.01" min="0"
              :disabled="promesaInmovil"
              :value="promesa.importe" placeholder="0,00"
              @input="escribirEnElBorrador('importe', $event.target.value)"></f7-list-input>
            <f7-list-input label="Fecha comprometida" type="date" :value="promesa.fecha"
              :disabled="promesaInmovil"
              @change="escribirEnElBorrador('fecha', $event.target.value)"></f7-list-input>
            <f7-list-input label="¿En qué ha quedado?" type="select" :value="promesa.resultado"
              :disabled="promesaInmovil"
              @change="escribirEnElBorrador('resultado', $event.target.value)">
              <option v-for="opcion in resultadosPromesa" :key="opcion.valor" :value="opcion.valor">
                {{ opcion.rotulo }}
              </option>
            </f7-list-input>
            <!-- EL COMENTARIO (dirección, 19/10/2026): lo que dijo el cliente o lo que el gestor
                 quiere dejar escrito. Es el cuarto campo y el único OPCIONAL, y eso se dice en el
                 rótulo: un campo sin marca se lee como obligatorio y quien no tiene nada que añadir
                 acaba escribiendo «nada» para poder guardar.

                 `textarea` y no `text`, con sitio para varias líneas: lo que se anota aquí es una
                 frase del cliente, no un código. El tope lo decide el servidor
                 (`comentarioQueSeGuarda`, que rechaza lo que no cabe) y aquí se IMPIDE llegar a él
                 con el mismo número, que vive en el adaptador con el resto del contrato
                 (`FactCobro.TOPE_COMENTARIO_PROMESA`): con el número escrito en el `.vue` las dos
                 cuentas se separarían en el primer cambio y el rechazo del servidor se vería como
                 un fallo del formulario. -->
            <f7-list-input label="Comentario (opcional)" type="textarea" resizable
              :disabled="promesaInmovil" :maxlength="topeComentario"
              :value="promesa.comentario"
              placeholder="Lo que ha dicho el cliente, o lo que quieras dejar escrito de la llamada"
              @input="escribirEnElBorrador('comentario', $event.target.value)"></f7-list-input>
          </f7-list>
          <!-- MIENTRAS NO SE SEPA SI LA ANOTACIÓN ANTERIOR QUEDÓ GUARDADA, LOS CAMPOS NO SE TOCAN.
               Y no es rigidez: el reintento lleva la MISMA referencia —es lo único que impide que
               se guarden dos— y con la misma referencia el servidor contesta con lo que se guardó
               la primera vez. Si entretanto se cambiara el importe, la primera podría entrar con
               retraso y la pantalla anunciaría unos datos que no son los que hay guardados
               (revisión CODEX, ronda 10). Dice qué pasa, quién lo desbloquea y dónde, y el «dónde»
               es el botón de comprobar que está debajo (dirección, 05/10/2026).

               Y EL «DÓNDE» CAMBIA CUANDO EL SERVIDOR YA HA CONTESTADO. Con la duda comprobada como
               «de eso no hay nada», el botón de comprobar ya no se dibuja —cuelga de
               `guardandoPromesa`, que se apaga en cuanto la duda deja de bloquear— y el que queda es
               el de anotar, que es el que manda el reintento. Mandar a pulsar un botón que no está
               es el defecto mudo que esa misma regla prohíbe, así que lo que se dice es lo que se
               puede hacer en cada momento. -->
          <f7-block v-if="dudaDeEstaPromesa" class="aviso-error">
            <p v-if="dudaDeEstaPromesa.resuelta">
              El servidor ya ha contestado que esta promesa <strong>no llegó a guardarse</strong>,
              así que lo que queda es mandarla otra vez <strong>tal como se mandó</strong>: los
              campos siguen bloqueados porque la referencia con la que sale ya está reclamada y con
              ella el servidor guarda estos datos y no otros. Lo haces tú con «Anotar la promesa»,
              aquí debajo. Para anotar una promesa con otro importe u otra fecha, manda primero esta
              y corrígela después: la siguiente sale con una referencia nueva.
            </p>
            <p v-else>
              De esta promesa no se sabe todavía si quedó guardada, así que lo único que se puede
              hacer con ella es volver a mandarla <strong>tal como se mandó</strong>: los campos
              están bloqueados porque cambiarlos no cambiaría lo que se guarda —el servidor reconoce
              esta anotación por su referencia y contesta con lo que haya quedado escrito de ella—.
              Lo desbloqueas tú con «Comprobar si se guardó», aquí debajo: si quedó guardada, esto
              se cierra y ya está; si no quedó, el botón de anotar se enciende y la manda otra vez
              con estos mismos datos. Para anotar una promesa con otro importe u otra fecha, espera
              a que esta se cierre.
            </p>
          </f7-block>
          <!-- LO QUE SE ESTABA ESCRIBIENDO AQUÍ NO SE MANDA CON LA REFERENCIA DE OTRA ANOTACIÓN,
               PERO TAMPOCO SE PIERDE EN SILENCIO. Pasa con la pantalla abierta en dos pestañas: en
               la otra se reserva la anotación de esta misma factura y desde ese momento los campos
               tienen que enseñar el cuerpo que el reintento va a reenviar. Enseñar unos datos y
               reenviar otros es el defecto que esto cierra; tirar lo teclado sin decirlo es el
               mismo defecto por el otro lado, así que se dice qué se ha guardado aparte, por qué y
               cuándo vuelve (dirección, 05/10/2026). -->
          <f7-block v-if="borradorApartadoDeEstaPromesa" class="aviso-error">
            <p>
              Lo que estabas escribiendo aquí —{{ resumenDelBorradorApartado }}—
              <strong>no se ha mandado ni se ha perdido</strong>: los campos enseñan ahora la
              anotación que ya salió hacia el servidor, que es la que se reenviaría, y no se puede
              mandar otra cosa con su referencia. En cuanto esa anotación quede resuelta, lo tuyo
              vuelve a estos campos y podrás guardarlo o cambiarlo.
            </p>
          </f7-block>
          <!-- Y CUANDO LO APARTADO HA VUELTO, SE DICE TAMBIÉN. Es la otra mitad de la promesa del
               aviso de arriba: si vuelve en silencio, el formulario enseña un importe y una fecha
               que no son las propuestas y nadie sabe de dónde han salido —y en la ficha pone que el
               importe propuesto es el saldo pendiente, así que las dos cosas se contradecirían—.
               El caso de verdad es abrirlo otra vez después de que la anotación ajena terminara
               (revisión CODEX, ronda 5). -->
          <f7-block v-if="promesa.borradorRecuperado" class="aviso-recuperado">
            <p>
              Los campos traen <strong>lo que tenías escrito</strong> la última vez, no las
              propuestas de la factura: se apartó mientras otra anotación de esta misma factura
              estaba en el aire y ha vuelto en cuanto ha quedado resuelta. Compruébalo antes de
              guardar, y cámbialo si el cliente ha dicho otra cosa.
            </p>
          </f7-block>
          <!-- La gestión que se acaba de crear todavía no está en el desplegable, así que NO se ha
               elegido ninguna: elegir otra anotaría la promesa en una llamada anterior. Dice qué
               pasa, quién lo desbloquea —ella misma— y dónde, y el «dónde» es un control de verdad
               justo debajo (dirección, 05/10/2026). -->
          <f7-block v-if="promesa.recienCreadaSinAparecer" class="aviso-error">
            <p>
              La gestión que acabas de crear todavía no aparece en la lista de arriba, así que no se
              ha elegido ninguna: anotar la promesa sobre otra la dejaría en una llamada anterior de
              esta misma factura. Pulsa «Volver a buscar la gestión» —tarda un instante— y, si aun
              así no apareciera, elígela a mano arriba.
            </p>
            <f7-button outline :disabled="promesa.cargando" @click="volverABuscarLaGestion">
              {{ promesa.cargando ? 'Buscando…' : 'Volver a buscar la gestión' }}
            </f7-button>
          </f7-block>
          <f7-block v-if="gestionesElegibles.length">
            <!-- El importe y el resultado llegan PROPUESTOS (el saldo pendiente y «Pendiente»), no
                 rellenos por el servidor: se ven escritos aquí y se pueden cambiar antes de
                 guardar. D-COB-8 prohíbe que un campo vacío se rellene solo, no que el formulario
                 proponga lo más probable a la vista de quien lo firma. -->
            <p class="ayuda">
              El importe propuesto es el saldo pendiente de la factura y el resultado propuesto es
              «Pendiente». Cámbialos si el cliente ha dicho otra cosa.
            </p>
            <f7-button fill :disabled="guardandoPromesa" @click="guardarPromesa">
              {{ guardandoPromesa ? 'Guardando…' : 'Anotar la promesa' }}
            </f7-button>
            <!-- Un control apagado dice POR QUÉ, QUIÉN lo desbloquea y DÓNDE, y lo dice JUNTO al
                 control y no en un aviso al principio de la pantalla (dirección, 05/10/2026). El
                 aviso cuelga del MISMO `guardandoPromesa` que apaga el botón, y no de que la
                 promesa en vuelo sea de otra factura: si fuera de ésta —se cierra el formulario con
                 el POST en vuelo y se vuelve a abrir el de la misma ficha— el botón se quedaba
                 apagado y mudo, que es el defecto que esa regla prohíbe. Lo que cambia según el
                 caso es el texto, no si se dice. -->
            <p class="ayuda ayuda-bloqueado" v-if="guardandoPromesa">
              <!-- Y el caso de la respuesta perdida va PRIMERO: ahí el botón no se desbloquea solo
                   «en cuanto termine», porque la petición ya terminó y lo que falta es comprobar
                   qué quedó escrito. Decir lo otro sería mandar a esperar algo que no va a pasar. -->
              <template v-if="dudaPromesaPendiente">
                No se sabe si la promesa de la factura
                {{ texto(dudaPromesaPendiente.codigoFactura) }} se guardó:
                <template v-if="dudaPromesaPendiente.deOtraPestana">salió desde otra pestaña tuya y
                desde aquí no se ve en qué ha quedado.</template>
                <template v-else>la petición se cortó sin respuesta.</template>
                Este botón sigue bloqueado para no
                anotarla dos veces, y lo desbloqueas tú con el botón de abajo: pregunta al servidor
                por esta anotación concreta y dice en qué quedó.
                <f7-button small outline class="boton-comprobar"
                  :disabled="dudaPromesaPendiente.comprobando"
                  @click="reconciliarEscrituraEnDuda(dudaPromesaPendiente)">
                  {{ dudaPromesaPendiente.comprobando ? 'Comprobando…' : 'Comprobar si se guardó' }}
                </f7-button>
                <!-- Y si el servidor ha dicho que no ha podido comprobarlo, el historial: comprobar
                     otra vez no va a contestar nada distinto. -->
                <f7-button small outline class="boton-comprobar"
                  v-if="dudaPromesaPendiente.revisaElHistorial"
                  @click="abrirHistorial({ id: dudaPromesaPendiente.idFactura,
                                           codigo: dudaPromesaPendiente.codigoFactura })">
                  Ver el historial de {{ texto(dudaPromesaPendiente.codigoFactura) }}
                </f7-button>
              </template>
              <!-- Y LOS CAMPOS TAMBIÉN ESTÁN QUIETOS MIENTRAS SE MANDA, que es el hallazgo `:471`
                   de la ronda 12: lo que viaja es el cuerpo con el que salió la petición, así que
                   cambiar el importe o la gestión con el POST en vuelo hacía que la pantalla
                   enseñara unos datos y el servidor guardara otros —y si la respuesta se perdía, el
                   reintento mandaba los de antes con los nuevos a la vista—. Se dice aquí, junto al
                   control, igual que el botón (dirección, 05/10/2026). -->
              <template v-else-if="enVueloDeEstaPromesa">
                La promesa de esta factura se está guardando ahora mismo, así que los campos están
                quietos: lo que se guarda es lo que ya ha salido, y cambiarlos ahora no lo cambiaría.
                Este botón y los campos se desbloquean solos en cuanto termine —no hace falta que
                nadie haga nada—. Si tarda más de unos segundos, cierra esto, recarga la lista con el
                botón de arriba y mira el historial de esta factura antes de volver a anotarla.
              </template>
              <template v-else>
                Se está guardando la promesa de la factura {{ texto(guardandoPromesaDe) }}. Este
                botón se desbloquea solo en cuanto termine —no hace falta que nadie haga nada—, y
                entonces podrás anotar ésta. Si tarda más de unos segundos, cierra esto, recarga la
                lista con el botón de arriba y mira el historial de esa factura antes de volver a
                anotar.
              </template>
            </p>
          </f7-block>
          </template>
        </template>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<style scoped>
/* NADA DE `gap`, `min()`, `max()` NI `clamp()` EN ESTE CSS: el browserslist del repo baja a
   Chrome 49 / Safari 11 y `postcss-preset-env` no los transforma, así que la declaración se queda
   inválida en silencio. Las separaciones van con `margin`. */
.sello-datos-bar { padding: 6px 16px 0; }

.linea-alcance {
  display: flex;
  align-items: flex-start;
  margin: 8px 16px 0;
  font-size: 12px;
  color: #4a5a78;
  line-height: 1.4;
}
.linea-alcance-tenue { color: #7c8db0; }
.linea-alcance-icono { font-size: 16px; color: #185FA5; flex-shrink: 0; margin-right: 6px; }

.aviso-error {
  background: #FDECEA;
  border-radius: 8px;
  color: #8E2B20;
  font-size: 13px;
}

/* Lo apartado que ha vuelto NO es un error: es una noticia. Se distingue a propósito del aviso
   rojo de arriba, que es el de «esto no se puede mandar todavía». */
.aviso-recuperado {
  background: #EAF2FB;
  border-radius: 8px;
  color: #1B4A7A;
  font-size: 13px;
}

/* BLOQUES */
.bloque {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  margin: 12px 16px 0;
  padding: 12px 14px;
}
.bloque-titulo {
  font-size: 13px;
  font-weight: 600;
  color: #1a2744;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
}
.bloque-titulo-icono { font-size: 17px; color: #534AB7; margin-right: 6px; }
.bloque-vacio { font-size: 13px; color: #7c8db0; margin: 16px; }
.ayuda { font-size: 11px; color: #7c8db0; margin: 6px 0 0; line-height: 1.45; }
/* El aparte de la cifra: la misma advertencia en ámbar de los demás huecos, porque lo que dice es
   que el número de al lado está incompleto y eso no puede leerse como una nota de pie. */
.ayuda-ojo { color: #6B4A10; background: #FDF4E3; padding: 6px 8px; border-radius: 6px; }
/* El por qué de un control apagado. En ámbar y no en rojo: no es un error, es «espera un momento».
   Mismo tono que los demás «falta un dato» de esta pantalla. */
.ayuda-bloqueado {
  background: #FDF4E3;
  color: #6B4A10;
  border-radius: 8px;
  padding: 8px 10px;
  margin-top: 8px;
}

.boton-ocultar {
  font-size: 11px;
  padding: 2px 8px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  color: #4a5a78;
  font-weight: 400;
  margin-left: auto;
}

/* LO ÚLTIMO QUE HAS HECHO */
.bloque-escritura { border-color: #0F6E56; }
.bloque-escritura-mal { border-color: #B23B2C; background: #FFF7F6; }
.escritura-resumen { font-size: 13px; color: #0F6E56; font-weight: 600; margin: 0; }
.escritura-resumen-mal { color: #8E2B20; }
.escritura-aviso { font-size: 11px; color: #6B4A10; margin: 6px 0 0; line-height: 1.45; }

/* LA CABECERA DE LA BANDEJA (#188) */
.bloque-bandeja { border-color: #534AB7; background: #FAFAFE; }
.bandeja-cifra { font-size: 15px; font-weight: 700; color: #1a2744; margin: 0; }
.bandeja-nota { font-size: 11px; color: #4a5a78; margin: 6px 0 0; line-height: 1.45; }
.boton-bandeja { margin-top: 10px; }
.bandeja-solo-lectura {
  font-size: 11px;
  color: #37307E;
  background: #EEEDFE;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 10px 0 0;
  line-height: 1.45;
}

/* EL SELECTOR DE GESTOR */
.selector-gestor {
  font-size: 12px;
  padding: 6px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  width: 100%;
  max-width: 340px;
}

/* LA FÓRMULA */
.bloque-formula { background: #F2F7FD; border-color: #cfe0f4; }
.formula {
  font-size: 13px;
  font-weight: 700;
  color: #185FA5;
  margin: 0;
  line-height: 1.4;
}
.formula-nota { font-size: 11px; color: #4a5a78; margin: 8px 0 0; line-height: 1.45; }

.cola-cifra { font-size: 14px; font-weight: 600; color: #1a2744; margin: 0; }

/* LAS FICHAS */
.ficha {
  background: white;
  border: 1px solid #e0e0e0;
  border-left: 4px solid #B23B2C;
  border-radius: 12px;
  margin: 12px 16px 0;
  padding: 12px 14px;
}
/* La gestionada hoy y la que no tiene saldo salen al final y en gris: siguen en la lista —para que
   se vea que están y por qué— pero no compiten visualmente con el trabajo de hoy. */
.ficha-apagada { border-left-color: #c6cedb; background: #FAFBFD; }

.ficha-cabecera { display: flex; align-items: flex-start; }
.ficha-puesto {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 50%;
  background: #1a2744;
  color: white;
  font-size: 12px;
  font-weight: 700;
  margin-right: 10px;
}
.ficha-identidad { min-width: 0; }
.ficha-cliente {
  font-size: 14px;
  font-weight: 700;
  color: #1a2744;
  margin: 0;
  line-height: 1.3;
}
.ficha-factura { font-size: 12px; color: #4a5a78; margin: 2px 0 0; }
.ficha-forma-pago { color: #7c8db0; }
.celda-falta { color: #9aa7bd; font-style: italic; }

/* El número de factura abre su ficha: un botón, no un enlace, para que el router de F7 no lo
   intercepte; con la pinta de enlace, que es lo que es. */
.enlace-factura {
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  color: #185FA5;
  text-decoration: underline;
  cursor: pointer;
}

/* LOS TRES FACTORES EN CLARO · el producto NO se pinta (criterio 3). */
.ficha-factores { margin: 10px 0 0; font-size: 13px; color: #1a2744; }
.factor {
  display: inline-block;
  background: #F2F7FD;
  border-radius: 6px;
  padding: 3px 8px;
  margin-right: 6px;
  margin-bottom: 4px;
  font-weight: 600;
}
.factor-importe { background: #FDF4E3; color: #6B4A10; }
/* El hueco del importe: en cursiva y apagado, igual que el resto de los huecos de la aplicación
   (`celda-falta`), para que no se confunda con una cifra. */
.factor-sin-dato { background: #F1F3F7; color: #7c8db0; font-style: italic; }
.ficha-factores-pie { font-size: 11px; color: #7c8db0; margin: 2px 0 0; line-height: 1.45; }

/* EL MOTIVO */
.ficha-motivo {
  font-size: 12px;
  color: #1a2744;
  background: #F6F7FA;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 10px 0 0;
  line-height: 1.45;
}
.ficha-motivo-promesa_incumplida, .ficha-motivo-promesa_parcial {
  background: #FDECEA;
  color: #8E2B20;
  font-weight: 600;
}
/* La promesa que solo se ha pasado de fecha NO va en rojo: el rojo es para lo que el gestor ha
   dicho que falló, y esto es un «no se sabe» que hay que preguntar. */
.ficha-motivo-promesa_vencida { background: #FDF4E3; color: #6B4A10; font-weight: 600; }
.ficha-motivo-nunca_gestionada { background: #FDF4E3; color: #6B4A10; }
.ficha-motivo-gestionada_hoy, .ficha-motivo-gestion_planificada,
.ficha-motivo-sin_saldo { color: #7c8db0; }
/* El saldo que NO SE SABE no es el saldo que no hay: va en ámbar, como la promesa vencida, porque
   es lo mismo —algo que hay que ir a comprobar— y no un caso cerrado que se pueda apagar. */
.ficha-motivo-saldo_desconocido { background: #FDF4E3; color: #6B4A10; font-weight: 600; }

/* EL CONTACTO */
.ficha-contacto { margin-top: 10px; }
.ficha-contacto-linea { display: flex; align-items: center; margin: 0; font-size: 13px; }
.ficha-contacto-icono { font-size: 16px; color: #0F6E56; flex-shrink: 0; margin-right: 6px; }
.ficha-telefono { color: #0F6E56; font-weight: 700; text-decoration: none; }
.ficha-contacto-quien { color: #4a5a78; margin-left: 4px; font-weight: 400; }
.ficha-contacto-origen { font-size: 10px; color: #9aa7bd; margin: 2px 0 0 22px; }
.ficha-falta {
  display: flex;
  align-items: flex-start;
  font-size: 11px;
  color: #6B4A10;
  background: #FDF4E3;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 6px 0 0;
  line-height: 1.45;
}
.ficha-falta-icono { font-size: 15px; color: #9A6411; flex-shrink: 0; margin-right: 6px; }

/* LA ÚLTIMA PROMESA */
.ficha-promesa {
  border: 1px solid #d7dde8;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 10px 0 0;
}
.ficha-promesa-mal { border-color: #e7b4ad; background: #FFF7F6; }
.ficha-promesa-duda { border-color: #e4c98f; background: #FFFBF2; }
.ficha-promesa-aviso {
  font-size: 11px;
  color: #6B4A10;
  margin: 4px 0 0;
  line-height: 1.45;
}
.ficha-promesa-titulo {
  font-size: 10px;
  text-transform: uppercase;
  color: #7c8db0;
  margin: 0;
}
.ficha-promesa-cuerpo { font-size: 12px; color: #1a2744; margin: 3px 0 0; line-height: 1.4; }
.ficha-promesa-pie { font-size: 10px; color: #9aa7bd; margin: 3px 0 0; }
.ficha-promesa-ninguna { font-size: 11px; color: #9aa7bd; margin: 10px 0 0; font-style: italic; }

/* LOS BOTONES */
.ficha-botones { margin-top: 12px; }
.boton-gestion {
  font-size: 12px;
  padding: 7px 14px;
  border: 0;
  border-radius: 6px;
  background: #534AB7;
  color: white;
  font-weight: 600;
  margin-right: 8px;
  margin-bottom: 6px;
}
.boton-gestion:disabled { background: #c9c6e6; }
.boton-secundario {
  font-size: 12px;
  padding: 7px 14px;
  border: 1px solid #d7dde8;
  border-radius: 6px;
  background: white;
  color: #4a5a78;
  margin-right: 8px;
  margin-bottom: 6px;
}
.boton-secundario:disabled { color: #b8c2d4; border-color: #eef1f6; }
/* Por qué el control está apagado, JUNTO al control (dirección, 05/10/2026). */
.ficha-bloqueado {
  font-size: 11px;
  color: #6B4A10;
  background: #FDF4E3;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 4px 0 0;
  line-height: 1.45;
}
/* Lo mismo junto al control, pero con el control ENCENDIDO: no es una puerta cerrada, es lo que
   hay que saber antes de pulsar. Se pinta en gris y no en el ámbar del bloqueo para que no se lea
   como un impedimento. */
.ficha-aviso {
  font-size: 11px;
  color: #4a5a78;
  background: #F3F5F9;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 4px 0 0;
  line-height: 1.45;
}

/* LOS POPUPS */
.boton-comprobar { margin-top: 6px; }
.historial-fila { border-bottom: 1px solid #eef1f6; padding: 8px 0; }
.historial-fila-mal { background: #FFF7F6; }
.historial-fila-duda { background: #FFFBF2; }
.historial-cabecera { font-size: 12px; color: #1a2744; margin: 0; }
.historial-estado { color: #4a5a78; margin-left: 8px; }
.historial-cuenta { color: #0F6E56; margin-left: 8px; font-size: 11px; }
.historial-nocuenta { color: #9A6411; margin-left: 8px; font-size: 11px; }
.historial-detalle { font-size: 11px; color: #4a5a78; margin: 3px 0 0; line-height: 1.4; }
.historial-origen { font-size: 10px; color: #9aa7bd; margin: 3px 0 0; }
.promesa-contexto { font-size: 13px; color: #1a2744; margin: 0; line-height: 1.5; }

/* EL COMENTARIO DE LA PROMESA (dirección, 19/10/2026) · en la ficha, en el historial y en la
   confirmación. Se distingue del resto como una cita y no como un aviso: no es ni un error ni una
   falta, es lo que dijo el cliente. `pre-line` conserva los saltos de línea que se tecleen en el
   formulario, que es un `textarea`: sin él, dos frases en dos líneas se leen pegadas. */
.ficha-promesa-comentario,
.historial-comentario,
.promesa-confirmada-comentario {
  display: flex;
  align-items: flex-start;
  white-space: pre-line;
  overflow-wrap: anywhere;
  line-height: 1.45;
}
.ficha-promesa-comentario { font-size: 12px; color: #2c3a57; margin: 5px 0 0; }
.historial-comentario { font-size: 11px; color: #2c3a57; margin: 3px 0 0; }
.promesa-confirmada-comentario { font-size: 13px; color: #16352a; margin: 6px 0 0; }
.ficha-promesa-comentario-icono,
.historial-comentario-icono,
.promesa-confirmada-comentario-icono {
  font-size: 14px;
  color: #7c8db0;
  flex-shrink: 0;
  margin-right: 6px;
}
.promesa-confirmada-comentario-icono { color: #0F6E56; }

/* LA CONFIRMACIÓN DE LO ANOTADO · verde, que es lo que dice «ha quedado hecho» sin tener que
   leerlo. No reutiliza `.bloque-escritura` de la pantalla a propósito: ése vive fuera de cualquier
   ficha y éste es de la promesa que se acaba de anotar en este formulario. */
.promesa-confirmada {
  background: #EDF7F3;
  border: 1px solid #b6ddcd;
  border-radius: 8px;
  padding: 10px 12px;
}
.promesa-confirmada-titulo {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #0F6E56;
  margin: 0;
}
.promesa-confirmada-icono { font-size: 18px; color: #0F6E56; margin-right: 6px; }
.promesa-confirmada-cuerpo { font-size: 15px; color: #16352a; margin: 6px 0 0; line-height: 1.4; }
.promesa-confirmada-detalle { font-size: 12px; color: #3d5a4e; margin: 4px 0 0; line-height: 1.45; }
.promesa-confirmada-pie { font-size: 11px; color: #577b6c; margin: 8px 0 0; line-height: 1.45; }
.promesa-confirmada-aviso {
  font-size: 12px;
  color: #6B4A10;
  background: #FDF4E3;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 8px 0 0;
  line-height: 1.45;
}
</style>

<script>
import SelloDatos from '../../components/SelloDatos.vue';
import FactCobro from '../../js/db/FactCobro.js';
import Utils from '../../js/Utils.js';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';
import formularioEnUso from '../../js/utils/formularioEnUso.js';

/** El valor del selector que quiere decir «solo las que no tienen gestor asignado». */
const SIN_GESTOR = '__SIN_GESTOR__';

/**
 * Dónde sobreviven las escrituras en duda cuando esta pantalla desaparece.
 *
 * `localStorage` y no `sessionStorage`: una respuesta que se pierde se pierde porque la red o la
 * pasarela se han caído, y lo que hace la persona entonces es cerrar la pestaña o el navegador —no
 * solo recargar—. Con `sessionStorage` la duda se iría justo en el caso para el que existe.
 *
 * Es el principio del nombre del hueco, no el hueco: **cada OPERACIÓN vive en el suyo**
 * (`<almacén>|<usuario>|<tipo>|<idFactura>|<clave>`, ver `huecoDeLaOperacion`), porque con el mapa
 * entero en un solo hueco dos pestañas de la misma persona se borran las dudas la una a la otra, y
 * con el hueco por `tipo|idFactura` se las pisan igual en cuanto las dos son de la misma factura
 * (revisión CODEX, rondas 11 y 12).
 */
const ALMACEN_DUDAS = 'simecal.factcobro.trabajoHoy.dudas';

/**
 * Cuánto se conserva una duda **ya reconciliada**. Pasado eso se descarta al restaurar.
 *
 * No es una caducidad de negocio —la referencia sigue reservada en el servidor para siempre— sino
 * higiene del navegador.
 *
 * **Y solo vale para las reconciliadas**, que es lo que la hace inocua: de una duda que el servidor
 * ya ha cerrado como «no llegó a guardarse» consta que la petición original no puede escribir
 * después, así que perder su referencia no duplica nada. De una que sigue **sin reconciliar** sí:
 * la referencia está reclamada en el servidor y no caduca nunca, de modo que descartarla aquí hace
 * que la pulsación siguiente genere una clave nueva y pueda anotar una segunda promesa o crear una
 * segunda gestión de la misma llamada (hallazgo `:1945` de la ronda 13). Esas se conservan hasta
 * que se sepa en qué quedaron, por viejas que sean.
 *
 * **Reconciliada y además quieta**, con las dos condiciones: una duda cerrada como «de eso no hay
 * nada» que se reintenta vuelve a tener una petición en el aire con su referencia, así que deja de
 * estar reconciliada en lo que importa aquí. El reintento le renueva la fecha y la marca en vuelo
 * (`reservarOperacion`), y `caducada` mira las dos cosas: sin eso, el reintento de una duda antigua
 * perdía su referencia a mitad de camino (hallazgo `:2162` de la ronda 14).
 */
const DIAS_QUE_VIVE_UNA_DUDA = 7;

/**
 * Dónde sobrevive **«lo último que has hecho»** a una recarga de la pantalla.
 *
 * Es el fallo 2 de la prueba en preview-2 (15/10/2026): se anotaba la promesa, el bloque la contaba,
 * y al pulsar F5 ya no estaba. La promesa vuelve a verse en la ficha de su factura —eso lo arregla
 * la API, que deja las gestionadas hoy al final de la lista en vez de tirarlas fuera del tope—, pero
 * el acuse de lo que acabas de hacer también tiene que seguir ahí: es lo que dice que la escritura
 * salió bien y con qué datos.
 *
 * `sessionStorage` y no `localStorage`, al contrario que las dudas: esto no es una pregunta abierta
 * que haya que resolver —no obliga a nada ni impide nada—, es el acuse de la última escritura de
 * **esta** sesión de la pantalla, así que acompaña a la pestaña y se va con ella. Y lleva el día
 * dentro: una pestaña que se queda abierta de un día para otro no puede seguir enseñando lo de ayer
 * en una pantalla que se llama «Mi trabajo de hoy».
 */
const ALMACEN_ULTIMA = 'simecal.factcobro.trabajoHoy.ultimo';

/**
 * «Mi trabajo de hoy» (COB-4, #190): **la pantalla que hace bajar la cifra**. Las demás del Centro
 * de Cobros miden; esta actúa.
 *
 * Arriba, mientras queden facturas sin gestor, la bandeja de asignación de #188. Debajo, las diez
 * facturas vencidas de más prioridad, cada una con el motivo por el que está ahí, los tres factores
 * en claro, el contacto del cliente, la última promesa con su resultado y dos botones: crear la
 * gestión T0045 y ver el historial. Y el formulario con el que el gestor anota la promesa de pago al
 * cerrar la gestión.
 *
 * CUATRO COSAS QUE DECIDE EL SERVIDOR Y ESTA PANTALLA NO:
 *
 *  1. **El orden** y los tres factores de cada ficha. La fórmula es
 *     `importe × antigüedad × silencio × probabilidad de cobro` (dirección, 04/10/2026) y **el
 *     producto no se pinta**: da cifras de millones que no significan nada para quien las lee, así
 *     que lo que se enseña son los tres factores en claro. Esta pantalla no calcula ninguno.
 *  2. **El motivo** de cada ficha, en una frase. Lo escribe la API porque depende de la promesa y de
 *     las reglas del silencio; deducirlo aquí sería tener dos definiciones del mismo texto.
 *  3. **De quién es la lista** (`deQuienEsLaLista`, `gestorAplicado`) y **si se puede elegir**
 *     (`puedeElegirGestor`). El `gestorAplicado` viaja *aplicado* y no *pedido*: a quien no ve toda
 *     la cartera el servidor le ignora el filtro y le contesta la suya, así que sin eso la pantalla
 *     podría estar enseñando una lista y creer que es otra.
 *  4. **Si se puede repartir la bandeja** (`puedeAsignar`, criterio 5 de #188) y **si se puede
 *     anotar una promesa** en cada ficha (`sePuedeAnotarPromesa`, con su
 *     `porqueNoSePuedeAnotarPromesa`).
 *
 * Y EL ESTADO QUE SÍ ES DE LA PANTALLA es poco: de quién se está mirando la lista, qué popup está
 * abierto y lo que hay escrito en el formulario de la promesa. Después de cada escritura se recarga
 * la lista **siempre**, también si la respuesta trae avisos: lo que ha quedado escrito lo sabe la
 * base de datos y no esta pantalla.
 */
export default {
  components: { SelloDatos },
  props: {
    /**
     * Si quien entra ve toda la cartera, resuelto por la barrera de la ruta **antes** de montar.
     *
     * Llega como `prop` y no se pregunta en `created()` por lo mismo que en el resto del front:
     * mientras una respuesta está en vuelo, «todavía no se sabe» se acaba tratando como el valor
     * permisivo. Aquí además no hace falta para decidir nada que no diga ya la respuesta de la
     * lista (`puedeElegirGestor`) — está para que la pantalla no se monte nunca sin que el servidor
     * haya dicho que esta persona entra.
     */
    veTodaLaCartera: { type: Boolean, required: true }
  },
  data: function() {
    return {
      cargando: false,
      error: null,
      dto: null,
      /** De quién se mira la lista: '' = toda, `SIN_GESTOR`, o el username de un gestor. */
      deQuien: '',
      /**
       * El resultado de la última escritura, que se queda en pantalla hasta que se oculta.
       *
       * Aparte de `error` a propósito: después de escribir se recarga la lista y `cargar()` limpia
       * `error`, así que con el aviso de la escritura ahí dentro duraría exactamente lo que tardara
       * esa recarga. Es el mismo reparto que en la bandeja de #188.
       */
      ultimaEscritura: null,
      /**
       * Las escrituras **apuntadas**, una por OPERACIÓN: las que están en vuelo con su referencia y
       * las que quedaron en duda porque su POST acabó sin respuesta (timeout de pasarela o conexión
       * cortada) después de que el servidor pudiera haber escrito. Valen para las dos, la promesa y
       * la gestión, porque la avería es la misma.
       *
       * **Una operación se apunta cuando SALE, no cuando se sabe que ha ido mal** (`enVuelo`, ver
       * `reservarOperacion`). Apuntándola solo al perder la respuesta, la referencia no existía en
       * ningún sitio durante el único rato en el que de verdad no se sabe nada: si la pestaña se
       * recargaba o se cerraba con el POST en el aire, la referencia se perdía y la pulsación
       * siguiente generaba otra, que es lo que duplica la escritura que sí llegó (revisión CODEX,
       * ronda 14, hallazgo `:2162`). Mientras está en vuelo no se le pregunta nada a nadie: no es
       * una duda todavía, así que no sale en el aviso de las dudas, pero su referencia ya está
       * guardada y **es ella la que apaga el botón** (ver `promesaEnVuelo`, `gestionEnVuelo`).
       *
       * **Y ES EL ÚNICO REGISTRO DE LO QUE ESTÁ VIVO**, que es la decisión técnica del 15/10/2026.
       * Había además un `promesaEnVuelo` y un `guardandoPromesa` en `data`, o sea el mismo hecho
       * apuntado en dos sitios con dos identidades distintas: el mapa lo sabía por operación
       * (`tipo|factura|clave`) y el otro era uno solo para toda la pantalla. Por esa juntura entraba
       * el defecto: `escrituraTerminada()` lo borraba **sin mirar qué operación había terminado**,
       * así que terminar o reconciliar una GESTIÓN desbloqueaba el botón y descongelaba el borrador
       * de una PROMESA cuyo POST seguía en el aire —y al reabrir esa factura se podía editar y
       * mandar otra vez—. Ahora el estado de los botones y del borrador **se deriva** de este mapa
       * (`creandoGestion`, `guardandoPromesa`, `promesaInmovil`) y cada camino solo cierra **su
       * propia** operación, por su clave exacta.
       *
       * Lo que lleva cada una es **la clave con la que se mandó** (`clave`), y eso es lo que la hace
       * resoluble: el servidor contesta por ella «se hizo», «está dentro», «de eso no hay nada» o
       * «no se ha podido mirar» (`reconciliarEscrituraEnDuda`). Antes llevaba una foto de la ficha y
       * el desenlace se deducía de si había cambiado, que se equivoca en los dos sentidos: con la
       * foto igual se quedaba bloqueada para siempre si la petición no llegó a salir, y con la foto
       * distinta daba por guardada la propia cuando quien había anotado era otra sesión (revisión
       * CODEX, ronda 8).
       *
       * **Un MAPA y no una sola ranura**, que es lo que fallaba: con una sola, una segunda escritura
       * en duda sustituía a la primera y la primera se quedaba sin nadie que la reconciliara —su
       * clave se perdía, el reintento generaba otra y podía duplicar— (revisión CODEX, ronda 9,
       * hallazgo `:1440`). Y de ahí salían los otros dos del mismo sitio: el camino de la gestión no
       * la borraba al terminar bien mientras el de la promesa sí, y el aviso mandaba pulsar un botón
       * que solo se dibujaba dentro del formulario de la promesa. Las tres eran la misma avería: un
       * dato con una sola forma para dos escrituras y N facturas.
       *
       * **La llave es la operación** (`tipo|idFactura|clave`, ver `llaveDeOperacion`) y no la
       * factura: dos anotaciones del mismo tipo sobre la misma factura hechas en dos pestañas son
       * dos operaciones con dos referencias, y ninguna puede sustituir ni borrar a la otra (revisión
       * CODEX, ronda 12, hallazgo `:1702`). El tipo y la factura siguen sirviendo para AGRUPAR —de
       * ahí salen `dudasDeLaFactura` y `dudaDe`—, que no es lo mismo que identificar.
       *
       * Nadie toca este objeto por su cuenta: se lee con `dudaDe` o `operacionDe`, se apunta con
       * `reservarOperacion`, se pasa a duda con `anotarEnDuda`, se suelta con `liquidarReserva` y se
       * quita con `resolverOperacion`, que es lo que evita que el camino siguiente se olvide otra
       * vez.
       *
       * **Y sobrevive a la pantalla**: se guarda en `localStorage` por usuario y se restaura al
       * montar (`restaurarDudas`). Mientras vivía solo aquí, recargar el navegador o salir de la
       * ruta se llevaba la clave y el cuerpo, así que la pulsación siguiente generaba una clave
       * nueva y —si la primera petición sí había llegado— creaba una gestión o una promesa
       * duplicada, que es exactamente el caso que la reconciliación existe para evitar (revisión
       * CODEX, ronda 10, hallazgo `:970`). No se guarda desde cada camino: lo hace el observador
       * `escriturasEnDuda`, que es el único sitio por el que pasan todos los cambios.
       *
       * De cada duda, `bloquea` dice si además hay que apagar el botón: en la promesa sí hasta
       * saberlo, en la gestión no, porque el reintento lleva esta misma clave y no puede crear dos.
       * Y mientras no esté `resuelta` no se quita: su clave es la que tiene que llevar el reintento.
       */
      escriturasEnDuda: {},
      historial: {
        abierto: false,
        cargando: false,
        error: null,
        titulo: '',
        gestiones: [],
        promesas: []
      },
      promesa: {
        abierto: false,
        cargando: false,
        error: null,
        idFactura: null,
        codigoFactura: '',
        cliente: '',
        saldoPendiente: null,
        saldoDesconocido: false,
        gestiones: [],
        /**
         * Los ids de las gestiones sobre las que **se puede anotar**, tal como los manda el
         * servidor. El desplegable sale de aquí y no de `gestiones`: ver `gestionesElegibles`.
         */
        idsElegibles: [],
        /** Y por qué no se puede anotar ninguna, escrito por el servidor. */
        porqueNoSePuedeAnotar: null,
        idTarea: '',
        /**
         * La gestión recién creada sobre la que hay que anotar, y si el historial **todavía no la
         * trae**. Mientras no la traiga no se elige ninguna: ver `aplicarGestiones`.
         */
        idTareaRecienCreada: null,
        recienCreadaSinAparecer: false,
        importe: '',
        fecha: '',
        resultado: 'PENDIENTE',
        /**
         * Lo que dijo el cliente, en texto libre (dirección, 19/10/2026). Es el cuarto campo del
         * formulario y el único opcional: en blanco quiere decir que no había nada que añadir.
         */
        comentario: '',
        /**
         * **Lo que se acaba de anotar, releído de la respuesta del servidor**, o `null` si todavía
         * no se ha anotado nada en este formulario.
         *
         * Mientras tiene algo, el formulario deja de dibujar los campos y dibuja la confirmación:
         * importe, fecha, resultado y comentario, tal como han quedado guardados. **El popup no se
         * cierra solo al guardar**, que es el fallo 3 de la prueba de dirección del 19/10/2026: se
         * cerraba de golpe y no quedaba forma de releer lo anotado sin recargar la pantalla. Lo
         * cierra la persona, cuando ha terminado de leerlo.
         *
         * Y los campos no se dibujan a la vez que esto, a propósito: con el formulario delante
         * después de guardar, volver a pulsar «Anotar la promesa» anotaría una segunda —la
         * referencia ya está resuelta, así que la siguiente sale con una nueva y el servidor la
         * guardaría—. Para anotar otra se cierra y se vuelve a abrir, que es lo que ya hacía.
         */
        confirmacion: null,
        /**
         * Si lo que hay en los campos es el borrador que se apartó y acaba de volver, para poder
         * decirlo: si no, al abrir el formulario se ven unas cifras que no son las propuestas y
         * nadie sabe de dónde salen. Ver `recuperarElBorradorApartado`.
         */
        borradorRecuperado: false
      },
      /**
       * Lo que la persona tenía escrito en el formulario **y no ha mandado**, cuando una operación
       * ha pasado a gobernarlo y los campos han tenido que enseñar otra cosa.
       *
       * Es el caso de las dos pestañas: aquí se estaba escribiendo 200 € y en la otra se reservó la
       * anotación de esta misma factura por 100 €. Desde ese momento el formulario tiene que
       * enseñar los 100 € —son los que el reintento va a reenviar con esa referencia— y los 200 no
       * se pueden mandar con ella; pero tampoco se tiran a la basura sin decirlo: se guardan aquí,
       * se cuentan en pantalla y vuelven a los campos en cuanto esa operación deja de gobernar
       * (`sincronizarElCuerpoVisible`). Perderlos en silencio es la otra mitad del mismo defecto
       * que enseñar unos datos y reenviar otros.
       *
       * **Y sobrevive a que el formulario se quite de delante**, que es lo que no hacía: el cierre
       * que viene del éxito del guardado —o de una duda que se reconcilia— lo ocultaba sin
       * devolverlo, y al volver a abrirlo `estrenarElFormulario` lo soltaba, así que lo tecleado se
       * perdía justo después de que la pantalla hubiera prometido por escrito que volvería (revisión
       * CODEX, ronda 5 de esta vuelta, hallazgo `:2190`). Quien decide si vuelve o se suelta es
       * `recuperarElBorradorApartado`, al estrenar el formulario.
       */
      borradorApartado: null,
      resultadosPromesa: FactCobro.RESULTADOS_PROMESA,
      /** Cuánto cabe en el comentario. Del adaptador, que es donde vive el contrato con la API. */
      topeComentario: FactCobro.TOPE_COMENTARIO_PROMESA
    };
  },
  computed: {
    /** Si la pantalla está enseñando datos ahora mismo. Gobierna el sello de datos (#16). */
    hayDatos: function() {
      return !!this.dto && !this.cargando;
    },
    fichas: function() {
      return (this.dto && this.dto.fichas) || [];
    },
    /**
     * La creación de gestión que tiene el POST en el aire ahora mismo, o `null`.
     *
     * **Sale del mapa de operaciones y no de un campo de `data`**: así terminar, liquidar o
     * reconciliar cualquier OTRA escritura no la puede soltar. `creandoEn` era un campo que los
     * manejadores de `crearGestion` ponían a `null` sin mirar de qué operación venían, que es la
     * misma forma del defecto que tenía `promesaEnVuelo` (decisión técnica del 15/10/2026).
     *
     * Solo puede haber una: el guardia de `crearGestion` rechaza la pulsación mientras la haya.
     */
    gestionEnVuelo: function() {
      return this.operacionesEnVuelo('GESTION')[0] || null;
    },
    /** De qué ficha es esa creación, para el rótulo «Creando…» de su botón. */
    creandoEn: function() {
      return this.gestionEnVuelo ? this.gestionEnVuelo.idFactura : null;
    },
    /**
     * Si hay una gestión creándose ahora mismo, **sea de la ficha que sea**.
     *
     * Es el mismo predicado con el que `crearGestion` rechaza la pulsación, y está aquí para que
     * sea uno y no dos: los botones se apagaban con `creandoEn === ficha.id` y el guardia rechaza
     * con `if (self.creandoEn)`, así que las otras nueve fichas tenían el botón encendido y no
     * hacía nada al pulsarlo (revisión CODEX, ronda 5). Lo que apaga el control y lo que rechaza
     * la pulsación tienen que ser la misma pregunta, o vuelven a separarse.
     */
    creandoGestion: function() {
      return !!this.gestionEnVuelo;
    },
    gestoresConCartera: function() {
      return (this.dto && this.dto.gestoresConCartera) || [];
    },
    /**
     * Si el gestor elegido ya no tiene cartera abierta asignada.
     *
     * Es el caso de uso real del selector: se mira la lista de alguien, se le reparte toda su
     * cartera a otro y deja de tener facturas asignadas, así que desaparece de `gestoresConCartera`.
     * Sin decirlo, la lista sale vacía y parece un fallo de carga. No se limpia el selector —eso
     * cambiaría la lista que la persona está mirando sin que lo haya pedido—: se explica.
     */
    gestorElegidoYaNoTieneCartera: function() {
      if (!this.deQuien || this.deQuien === SIN_GESTOR) return false;
      const elegido = this.deQuien;
      return !this.gestoresConCartera.some(function(opcion) { return opcion.clave === elegido; });
    },
    /**
     * Las escrituras en duda que **todavía hay que resolver**: las que piden algo de la persona.
     *
     * Son las que se pintan con su propio control de comprobar. Una duda ya resuelta como «no
     * quedó» se queda en el mapa —su clave es la que tiene que llevar el reintento— pero no se
     * pinta: lo que hay que hacer con ella es volver a anotar, con el botón normal.
     *
     * Y una operación **en vuelo** tampoco: su referencia está apuntada por si la pestaña se va
     * (`reservarOperacion`), pero no hay nada que preguntar todavía —la petición no ha vuelto— y
     * decir «no se sabe si se guardó» de algo que se está guardando ahora mismo sería afirmar algo
     * falso. Lo que la cuenta mientras tanto es `promesaEnVuelo` / `gestionEnVuelo`, que salen del
     * mismo mapa.
     */
    dudasPendientes: function() {
      const dudas = this.escriturasEnDuda;
      return Object.keys(dudas)
        .map(function(llave) { return dudas[llave]; })
        .filter(function(duda) { return duda && !duda.resuelta && !duda.enVuelo; });
    },
    /**
     * La duda que mantiene **bloqueado** el botón de anotar la promesa, si hay alguna.
     *
     * Solo las de la promesa bloquean, y por eso es una y no una lista: mientras no se sepa si una
     * promesa quedó escrita no se admite anotar otra, se abra el formulario que se abra. Las de la
     * gestión no bloquean nada —el reintento lleva su misma clave y no puede crear dos—, así que el
     * gestor puede seguir trabajando con otra factura, que es lo que pidió dirección.
     */
    dudaPromesaPendiente: function() {
      return this.dudasPendientes.filter(function(duda) { return duda.bloquea; })[0] || null;
    },
    /**
     * La anotación que tiene el POST en el aire ahora mismo, **sea de la factura que sea**, o
     * `null`. También del mapa, por lo mismo que `gestionEnVuelo`.
     */
    promesaEnVuelo: function() {
      return this.operacionesEnVuelo('PROMESA')[0] || null;
    },
    /**
     * Si el botón de anotar la promesa está apagado: **se deriva de las operaciones vivas y de las
     * dudosas**, nunca de un «ya no queda ninguna» asignado a mano.
     *
     * Dos motivos, uno por cada clase de operación viva de la promesa: una que se está mandando
     * —otra pulsación mandaría una segunda— y una de la que no se sabe si quedó escrita. Y ninguna
     * de las dos se cuenta aparte del mapa: era el `guardandoPromesa` de `data`, que `crearGestion`
     * acababa poniendo en `false` al terminar su propia escritura (decisión técnica del
     * 15/10/2026).
     *
     * La gestión no entra aquí: su duda no bloquea nada —el reintento lleva su misma clave y no
     * puede crear dos— y su vuelo apaga su propio botón (`creandoGestion`), no éste.
     */
    guardandoPromesa: function() {
      return !!this.promesaEnVuelo || !!this.dudaPromesaPendiente;
    },
    /**
     * De qué factura es la anotación que tiene el botón apagado, para decirlo junto al control
     * (dirección, 05/10/2026). La duda manda sobre el vuelo, que es el orden en que la plantilla
     * explica los dos casos.
     */
    guardandoPromesaDe: function() {
      const cual = this.dudaPromesaPendiente || this.promesaEnVuelo;
      return cual ? cual.codigoFactura : null;
    },
    /**
     * La duda de **la promesa de la factura que tiene el formulario abierto**, resuelta o no.
     *
     * Es la que decide que los campos del formulario no se puedan cambiar, y por eso NO sale de
     * `dudasPendientes`: una duda contestada con «no quedó» sigue en el mapa —su clave es la que
     * lleva el reintento— y es justo entonces cuando el botón se enciende y alguien podría editar
     * el importe. Eso es lo que no puede pasar: el servidor reconoce esa anotación por su
     * referencia, así que lo que se guarde serán los datos de la primera vez (revisión CODEX,
     * ronda 10). Mientras la duda esté puesta, el reintento manda el cuerpo de entonces y el
     * formulario enseña esos mismos datos.
     */
    dudaDeEstaPromesa: function() {
      return this.promesa.idFactura ? this.dudaDe('PROMESA', this.promesa.idFactura) : null;
    },
    /**
     * Si **la anotación en vuelo es la de este formulario**, con su operación.
     *
     * Por operación y no por «hay algo guardándose»: mientras se manda la promesa de una factura se
     * puede cerrar su formulario y abrir el de otra, y ese segundo borrador se puede rellenar —lo
     * que se manda no es suyo—. Lo que no se puede tocar es el de la operación que está en vuelo.
     */
    enVueloDeEstaPromesa: function() {
      return this.promesaEnVueloDe(this.promesa.idFactura);
    },
    /**
     * Si el borrador que hay delante **no se puede tocar**: el único sitio que lo decide.
     *
     * La pregunta es una y no dos: **de esta factura hay una anotación cuyo cuerpo ya está
     * comprometido**, o sea que ya salió hacia el servidor con su referencia y lo que se guarde
     * será ése (`operacionComprometidaDe`). Da igual si está en vuelo o si quedó en duda, porque en
     * los dos casos lo que se guardaría no es lo que se ve:
     *
     *  1. **se está mandando**: el cuerpo ya salió, así que cambiar un campo ahora no cambia lo que
     *     el servidor va a guardar; y si la respuesta se perdiera, el reintento manda ese mismo
     *     cuerpo mientras la pantalla enseñaría otros valores (revisión CODEX, ronda 12, hallazgo
     *     `:471`);
     *  2. **quedó en duda**: su referencia ya está reclamada en el servidor, que contesta con lo
     *     que haya quedado escrito de ella (ronda 10).
     *
     * Y es **la misma operación** que da la clave con la que sale el reintento (`claveParaEscribir`)
     * y el cuerpo que se vuelca en el formulario (`cuerpoComprometidoDe`), que es lo que garantiza
     * que no salga nunca un POST con una clave ya usada y un cuerpo distinto. Preguntarlo por
     * separado —una condición para el bloqueo y otra para el cuerpo— es lo que dejaba los campos
     * editables con el POST en vuelo.
     */
    promesaInmovil: function() {
      return !!this.operacionComprometidaDe('PROMESA', this.promesa.idFactura);
    },
    /**
     * El borrador que se apartó **de la factura que está delante**, o `null`.
     *
     * Por factura, como todo lo demás del formulario: lo apartado de otra no se cuenta aquí ni se
     * devuelve aquí (ver `devolverElBorradorApartado`).
     */
    borradorApartadoDeEstaPromesa: function() {
      const borrador = this.borradorApartado;
      return borrador && this.promesa.idFactura
        && borrador.idFactura === this.promesa.idFactura ? borrador : null;
    },
    /** Lo apartado, en una línea: «250,00 € para el 02/11/2026». */
    resumenDelBorradorApartado: function() {
      const borrador = this.borradorApartadoDeEstaPromesa;
      if (!borrador) return '';
      const importe = borrador.importe === '' || borrador.importe === null
        || borrador.importe === undefined
        ? 'sin importe' : this.formatEurosExactos(borrador.importe) + ' €';
      // Y si llevaba comentario se nombra, aunque no se repita entero: el aviso que acompaña a esto
      // promete que lo tecleado «no se ha perdido», y el comentario es lo que más cuesta volver a
      // escribir de memoria. Sin nombrarlo, la promesa se leería como si solo hablara de las cifras.
      return importe + (borrador.fecha ? ' para el ' + this.formatFecha(borrador.fecha) : '')
        + (this.comentarioDe(borrador.comentario) ? ', con su comentario' : '');
    },
    /**
     * Las gestiones que el desplegable puede ofrecer: las que el servidor marca como **elegibles**.
     *
     * Se filtra por los ids que manda el servidor y no se ofrece todo lo que trae el historial: una
     * promesa es lo que el cliente dijo *durante* esa gestión, así que una T0045 planificada para
     * mañana se enseña en el historial pero no se puede anotar sobre ella, y proponerla era
     * ofrecer algo que la escritura rechaza (hallazgo `:568` de la ronda 12).
     *
     * **Sin la lista no se ofrece nada**, a propósito: si una respuesta no la trae, lo que toca es
     * no dejar elegir —y decirlo— en vez de abrir la puerta por omisión.
     */
    gestionesElegibles: function() {
      const ids = this.promesa.idsElegibles;
      if (!Array.isArray(ids) || !ids.length) return [];
      return (this.promesa.gestiones || []).filter(function(gestion) {
        return !!gestion && ids.indexOf(gestion.id) >= 0;
      });
    },
    /**
     * Por qué no se puede anotar sobre esta factura. **La frase la escribe el servidor**, que es
     * quien decide; la de aquí es solo para cuando no manda ninguna, y dice lo que de verdad se
     * sabe en ese caso: que no se puede elegir ninguna.
     */
    porqueNoSePuedeAnotarAqui: function() {
      return this.promesa.porqueNoSePuedeAnotar
        || 'Esta factura no tiene ninguna gestión de cobro sobre la que anotar la promesa. Cierra '
        + 'esto, pulsa «Crear gestión de cobro» en la ficha y vuelve.';
    }
  },
  /**
   * Los carriles de peticiones y el dueño del formulario se crean aquí y no en `data`: no son
   * estado de pantalla y meterlos en `data` los volvería reactivos para nada.
   *
   * Un carril por carga y no uno para todo porque son independientes: abrir el historial de una
   * factura no tiene que descartar la carga de la lista que pudiera estar en vuelo, ni al revés.
   *
   * **Y la promesa se guarda también por carril** (`carrilPromesaGuardado`), que es lo que no
   * estaba. El motivo por el que se dejó fuera era bueno a medias: la respuesta de una escritura no
   * se puede *perder* —es la única noticia de lo que ha quedado escrito—, pero sí puede dejar de
   * ser quien escribe **en el formulario**, porque ese formulario ya no está delante. Para eso está
   * `descartada`, que el carril ofrece justo para las escrituras: lo que ha pasado se cuenta en el
   * aviso de la pantalla (`ultimaEscritura`, que no es de ninguna ficha) y se recarga la lista, sin
   * tocar el formulario de otra factura que alguien esté rellenando (revisión CODEX, ronda 3).
   *
   * **`formularioPromesa` es el dueño del formulario de la promesa** (`formularioEnUso`), y es la
   * decisión de dirección del 10/10/2026 sobre el punto que volvió a diseño: mientras la persona lo
   * tiene delante, nada que llegue de una petición lo abre, lo reinicia ni lo cierra, y esa garantía
   * vive en **un solo sitio** por el que pasan los caminos que lo abren o lo cierran —el botón
   * «Anotar promesa», la respuesta de crear la gestión, el cierre del popup y el éxito del
   * guardado—. Lo que las peticiones escriben *dentro* del formulario va por los dos carriles que
   * se le entregan, a los que él pone la sesión: así «de qué sesión del formulario es esta
   * respuesta» se decide en un sitio y no en cada manejador.
   *
   * Taparlo botón a botón ya se intentó y no cerró la familia: se protegieron tres caminos y la
   * ronda siguiente trajo el cuarto —crear la gestión, que se había dejado fuera «porque no escribe
   * en ningún formulario» cuando en realidad es quien lo abre—.
   *
   * La creación de la gestión sigue sin carril, y aquí sí es correcto: lo único que escribe es su
   * propia operación del mapa y `ultimaEscritura`, y su reserva ya impide que haya dos en vuelo
   * (`gestionEnVuelo`). Lo que tenía que arreglar era otra cosa, y es lo que hace ahora el dueño: no
   * tocar el formulario que alguien tenga abierto (ver `crearGestion`).
   */
  watch: {
    /**
     * Guarda las dudas en cuanto cambian: **el único sitio que escribe el almacén**.
     *
     * Con `deep` porque dentro de cada duda cambian `resuelta`, `comprobando` y
     * `revisaElHistorial`, y una duda que se resolvió como «no quedó» tiene que quedarse guardada
     * —su clave es la que debe llevar el reintento—. Y aquí y no en cada camino por lo mismo que
     * `resolverOperacion` es un método y no un `delete` suelto: en cuanto hay que acordarse de hacerlo
     * en cinco sitios, uno se olvida (lo que pasó en la ronda 9 con el camino de la gestión).
     */
    escriturasEnDuda: {
      deep: true,
      handler: function() {
        this.guardarDudas();
        // Y el formulario abierto enseña lo que su operación va a reenviar: por aquí pasan TODOS
        // los cambios del mapa de esta pestaña —reservar, anotar en duda, resolver, liquidar,
        // reconciliar—, así que ningún camino puede olvidarse de sincronizarlo, ni el que se añada
        // mañana. Ver `sincronizarElCuerpoVisible`.
        this.sincronizarElCuerpoVisible();
      }
    },
    /**
     * Guarda «lo último que has hecho» en cuanto cambia: **el único sitio que escribe su hueco**.
     *
     * Sin `deep` porque este objeto se sustituye entero —nadie le cambia un campo por dentro— y a
     * `null` también, que es lo que lo borra: si la persona lo oculta, se queda oculto también
     * después de recargar.
     */
    ultimaEscritura: function() {
      this.guardarLaUltimaEscritura();
    }
  },
  created: function() {
    const self = this;
    /**
     * Los huecos de `localStorage` que **esta pestaña** ha escrito o restaurado.
     *
     * No es estado de pantalla y por eso no está en `data`. Lo que hace falta de él es que
     * `guardarDudas` no borre el hueco de una duda de otra pestaña: solo quita los que están aquí.
     * Se inicializa antes de `restaurarDudas` porque es ella la que lo rellena.
     */
    this.huecosPropios = {};
    /**
     * La huella de la operación que gobierna el formulario abierto, tal como la dejó el último
     * volcado: ver `sincronizarElCuerpoVisible`. No es estado de pantalla —nada la pinta— y por eso
     * no está en `data`; lo que se pinta es el borrador apartado, que sí está.
     */
    this.gobiernoDelFormulario = null;
    // Antes de los carriles y antes de cargar: `cargar` dispara `reconciliarLasDudas`, así que las
    // dudas que vengan de la sesión anterior tienen que estar puestas para que esa primera lectura
    // ya pregunte por ellas.
    this.restaurarDudas();
    // Y a partir de aquí, lo que escriba OTRA pestaña de esta misma persona mientras ésta sigue
    // montada: restaurar al crear solo trae lo que ya estaba (ver `escucharElAlmacen`).
    this.escucharElAlmacen();
    // Y lo último que esta persona hizo en esta pantalla, que sobrevive a un F5: ver
    // `restaurarLaUltimaEscritura`. Va antes de cargar porque la reconciliación de las dudas puede
    // escribir ahí una noticia más nueva, y la más nueva es la que manda.
    this.restaurarLaUltimaEscritura();
    // #472 · El «cargando» de cada lectura lo enciende y lo apaga su carril, que es el único que
    // sabe cuándo ha contestado la petición vigente: una respuesta descartada no lo apaga, y no hay
    // un `false` por manejador que olvidar. El del formulario de la promesa se apaga además cuando
    // `formularioEnUso` le cambia el turno, que es cuando lo que estaba en vuelo deja de ser suyo.
    this.carrilLista = carrilPeticiones({
      cargando: function(si) { self.cargando = si; }
    });
    this.carrilHistorial = carrilPeticiones({
      cargando: function(si) { self.historial.cargando = si; }
    });
    this.carrilPromesa = carrilPeticiones({
      cargando: function(si) { self.promesa.cargando = si; }
    });
    this.carrilPromesaGuardado = carrilPeticiones();
    this.formularioPromesa = formularioEnUso({
      // El estado sigue estando en `data`, que es lo que pinta el popup; el dueño lo pregunta en
      // vez de guardarse una copia, para no tener el mismo booleano en dos sitios.
      abierto: function() { return self.promesa.abierto; },
      cerrar: function() {
        self.promesa.abierto = false;
        // Y la confirmación se va con él, en el ÚNICO sitio por el que el formulario deja de estar
        // delante: dejarla puesta haría que la próxima apertura enseñara, durante el instante que
        // tarda en volcarse, «lo que acabas de anotar» de otra factura.
        self.promesa.confirmacion = null;
      },
      carriles: [self.carrilPromesa, self.carrilPromesaGuardado]
    });
  },
  beforeDestroy: function() {
    // Primero el oyente: un componente que ya no está en pantalla no puede seguir tocando su mapa
    // de operaciones, y el oyente vive en `window`, que no se destruye con él.
    this.dejarDeEscucharElAlmacen();
    this.cerrarLosPopupsAlIrse();
  },
  methods: {
    onPageInit: function() {
      this.cargar();
    },
    /** Pide la lista con el selector puesto. */
    cargar: function() {
      const self = this;
      self.error = null;
      self.carrilLista.lanzar(FactCobro.trabajoHoy(self.filtroParaLaApi()), {
        exito: function(respuesta) {
          self.dto = respuesta;
          // El selector que manda es el que diga el servidor, no el que se pidió: a quien no ve
          // toda la cartera le ignora el filtro y le contesta la suya, así que dejar puesto lo
          // pedido sería tener la pantalla diciendo una cosa y la lista siendo otra.
          self.deQuien = self.deQuienSegunLaRespuesta(respuesta);
          // Y aquí se resuelven, si hay alguna, TODAS las escrituras que quedaron en duda: la
          // reconciliación vive en la LECTURA, así que la hacen por igual esta recarga, el botón de
          // recargar y el selector de gestor.
          self.reconciliarLasDudas();
        },
        limpiar: function() {
          // Sin datos no se deja lo de antes en pantalla: el sello de datos y los recuentos
          // estarían afirmando algo sobre una lista que esta pantalla ya no está enseñando.
          self.dto = null;
        },
        fallo: function(e) {
          self.error = self.textoDelFallo(e,
            'No se ha podido cargar tu trabajo de hoy. Vuelve a intentarlo con el botón de '
            + 'recargar.');
        }
      });
    },
    filtroParaLaApi: function() {
      if (this.deQuien === SIN_GESTOR) return { sinGestor: true };
      return { gestor: this.deQuien || null };
    },
    /** Con qué valor se queda el selector después de una carga: lo que diga la respuesta. */
    deQuienSegunLaRespuesta: function(respuesta) {
      if (!respuesta) return '';
      if (respuesta.sinGestorAplicado) return SIN_GESTOR;
      return respuesta.gestorAplicado || '';
    },
    /**
     * Crea la gestión T0045 de esa factura y recarga la lista.
     *
     * Se recarga **siempre**, también si la respuesta trae avisos: la gestión que acaba de entrar
     * baja a cero los días sin gestión de esa factura, así que la lista cambia de orden y seguir
     * enseñando la de antes invitaría a llamar otra vez al mismo cliente.
     *
     * Y al terminar bien se abre el formulario de la promesa sobre la gestión recién creada, que es
     * el flujo que pidió dirección: el gestor llama, y lo que el cliente le promete se anota en esta
     * pantalla al cerrar la gestión, no en la ficha de la tarea.
     *
     * **Salvo que la persona tenga ya un formulario delante**, sea de la factura que sea: esta
     * respuesta puede llegar un rato después —el gestor ha podido abrir entretanto el de otra ficha,
     * o el de ésta misma, y estar escribiendo en él— y abrirlo encima tiraría lo tecleado. Lo decide
     * el dueño del formulario (`formularioPromesa`), que es quien sabe si hay uno delante; aquí no
     * se vuelve a razonar. Que la factura sea la misma **no** da
     * derecho a reiniciarlo: era justo el agujero que quedaba (revisión CODEX, ronda 4) y la
     * decisión de dirección del 10/10/2026 es que lo tecleado se conserva tal cual.
     *
     * Cuando no se abre, la gestión está creada igual y se dice qué ha pasado y qué hacer.
     */
    /**
     * Qué se le dice a la persona cuando el botón de crear la gestión está apagado.
     *
     * Las tres cosas del criterio de pantalla de dirección (05/10/2026): POR QUÉ no se puede usar,
     * QUIÉN lo desbloquea —nadie, se desbloquea solo— y DÓNDE mirar si tarda. En dos versiones,
     * porque no es lo mismo que la creación en vuelo sea de ESTA ficha que de otra: en el segundo
     * caso hay que decir de cuál, o la frase parece hablar de una factura que no se ha tocado.
     *
     * No se escribe en la plantilla porque son dos frases largas y ahí no se leen.
     */
    porqueNoSePuedeCrearGestion: function(ficha) {
      const esta = this.creandoEn === ficha.id;
      const otra = this.fichas.filter(function(f) { return f.id === this.creandoEn; }, this)[0];
      const deQuien = esta
        ? 'La gestión de esta factura se está creando ahora mismo.'
        : 'Se está creando la gestión de la factura ' + this.texto(otra && otra.codigo) + '.';
      return deQuien + ' Este botón se desbloquea solo en cuanto termine —no hace falta que nadie '
        + 'haga nada—. Si tarda más de unos segundos, recarga la lista con el botón de arriba y '
        + 'mira el historial antes de volver a pulsarlo: dos pulsaciones son dos gestiones de la '
        + 'misma llamada.';
    },
    crearGestion: function(ficha) {
      const self = this;
      if (self.creandoGestion) return;
      // La referencia se APUNTA antes de salir, no al perder la respuesta: con el POST en el aire,
      // una recarga o un cierre de pestaña se llevaba la clave y la pulsación siguiente creaba una
      // segunda T0045 de la misma llamada (ver `reservarOperacion`).
      // Y es ESA reserva la que apaga el botón mientras vuela (`gestionEnVuelo`): no hay ningún
      // `creandoEn` aparte que un camino pueda poner a `null` sin mirar de qué operación venía.
      const reserva = self.reservarOperacion('GESTION', ficha.id, ficha.codigo, null);
      // Sin reserva guardada no sale el POST: ver `reservarOperacion`. Se dice aquí, donde se ha
      // pulsado, y la lista no se recarga —no ha cambiado nada que recargar—.
      if (reserva.sinConstancia) {
        self.ultimaEscritura = {
          resumen: self.porqueNoConstaLaReserva('GESTION'),
          avisos: [],
          mal: true
        };
        return;
      }
      const clave = reserva.clave;
      self.ultimaEscritura = null;
      FactCobro.crearGestionCobro(ficha.id, clave).then(function(respuesta) {
        self.liquidarReserva(reserva);
        // La creación terminó: si venía de un reintento, su duda ya no tiene nada que resolver, y
        // dejarla puesta haría que `claveParaCrearGestion` devolviera esta misma clave para la
        // gestión SIGUIENTE de esta factura —el servidor contestaría con esta de forma idempotente
        // mientras la pantalla anuncia una nueva— (revisión CODEX, ronda 9, hallazgo `:1080`).
        self.resolverOperacion('GESTION', ficha.id, clave);
        const avisos = ((respuesta && respuesta.avisos) || []).slice();
        if (respuesta && respuesta.id) {
          // Sin turno: esta petición no ha salido de ningún formulario, ha salido de la lista, así
          // que no es dueña de ninguno y solo abre si no hay nada delante (ver `formularioEnUso`).
          const abierto = self.abrirFormularioPromesa(ficha, respuesta.id, {});
          if (!abierto) avisos.push(self.avisoFormularioNoAbierto(ficha));
        }
        self.ultimaEscritura = {
          resumen: (respuesta && respuesta.resumen) || 'Gestión de cobro creada.',
          avisos: avisos,
          mal: avisos.length > 0
        };
        self.cargar();
      }, function(e) {
        // La reserva se suelta antes de decidir: si el servidor ha contestado, de esa referencia ya
        // se sabe lo que hay, y si no ha contestado la convierte en duda `anotarEnDuda`. Soltarla
        // es también lo que vuelve a encender el botón, y solo la suya.
        self.liquidarReserva(reserva);
        // Si la respuesta se PERDIÓ, se queda en duda con su clave y se pregunta por ella: volver a
        // pulsar es seguro —el reintento lleva la misma referencia y no crea dos gestiones—, así que
        // este botón no se bloquea, pero tampoco se afirma que la gestión no se creó.
        // Y se pregunta por ESTA operación, por su clave: con otra operación más antigua de la
        // misma factura en el mapa, `dudaDe` devolvería aquélla y ésta se quedaría sin preguntar.
        if (self.anotarEnDuda(e, 'GESTION', clave, ficha.id, ficha.codigo)) {
          self.reconciliarEscrituraEnDuda(self.operacionDe('GESTION', ficha.id, clave));
          self.cargar();
          return;
        }
        self.ultimaEscritura = {
          resumen: self.textoDelFallo(e,
            'No se sabe si la gestión se ha llegado a crear. Se ha vuelto a cargar la lista: mira '
            + 'el historial de esa factura antes de volver a pulsar el botón.'),
          avisos: [],
          mal: true
        };
        self.cargar();
      });
    },
    /** Abre el historial de una factura: sus gestiones y sus promesas. */
    abrirHistorial: function(ficha) {
      const self = this;
      self.historial.abierto = true;
      self.historial.error = null;
      self.historial.titulo = 'Historial · ' + self.texto(ficha.codigo);
      self.historial.gestiones = [];
      self.historial.promesas = [];
      self.carrilHistorial.lanzar(FactCobro.historialTrabajoHoy(ficha.id), {
        exito: function(respuesta) {
          self.historial.gestiones = (respuesta && respuesta.gestiones) || [];
          self.historial.promesas = (respuesta && respuesta.promesas) || [];
        },
        fallo: function(e) {
          self.historial.error = self.textoDelFallo(e,
            'No se ha podido cargar el historial de esta factura.');
        }
      });
    },
    /**
     * El botón «Anotar promesa de pago» de una ficha: lo pide la persona, así que se abre siempre.
     *
     * Es el único camino hacia el formulario que lleva `porLaPersona`, y está en un método propio
     * para que eso no sea un parámetro que un camino nuevo pueda poner por descuido: quien no es la
     * persona pasa por `abrirFormularioPromesa` con su turno y se somete a la decisión del dueño.
     */
    pulsarAnotarPromesa: function(ficha) {
      this.abrirFormularioPromesa(ficha, null, { porLaPersona: true });
    },
    /**
     * Abre el formulario de la promesa de esa factura, **si quien lo pide manda sobre él**.
     *
     * Quién manda lo decide `formularioPromesa` y no este método: la persona siempre, y una
     * respuesta solo cuando no hay ningún formulario delante o el que hay es el de su propia sesión
     * (ver `formularioEnUso`). El volcado de los campos va dentro del `abrir` a propósito: así no
     * hay forma de reiniciar el formulario sin pasar por esa decisión.
     *
     * Las gestiones sobre las que se puede anotar se piden al abrir y no vienen en la lista: cuál es
     * la última T0045 de una factura es una consulta sobre las tareas, y en la carga de la pantalla
     * serían diez consultas para rellenar un desplegable que casi nunca se abre. La ficha ya dice
     * **si** hay alguna (`sePuedeAnotarPromesa`).
     *
     * @param {Object} ficha la ficha de la lista.
     * @param {String} [idTareaRecienCreada] la gestión que se acaba de crear, para preseleccionarla
     *        en vez de la que el servidor propondría. Es la que el gestor acaba de usar para llamar.
     * @param {Object} quien `{ porLaPersona: true }` o `{ turno }` de la petición que lo pide.
     * @returns {Boolean} si se ha abierto.
     */
    abrirFormularioPromesa: function(ficha, idTareaRecienCreada, quien) {
      const self = this;
      return self.formularioPromesa.abrir(quien, function() {
        self.promesa.abierto = true;
        self.promesa.cargando = true;
        self.promesa.error = null;
        self.promesa.idFactura = ficha.id;
        self.promesa.codigoFactura = ficha.codigo;
        self.promesa.cliente = ficha.cliente;
        self.promesa.saldoPendiente = ficha.saldoPendiente;
        self.promesa.saldoDesconocido = !!ficha.saldoDesconocido;
        self.promesa.gestiones = [];
        self.promesa.idsElegibles = [];
        self.promesa.porqueNoSePuedeAnotar = null;
        self.promesa.idTarea = '';
        self.promesa.idTareaRecienCreada = idTareaRecienCreada || null;
        self.promesa.recienCreadaSinAparecer = false;
        // PROPUESTAS, no rellenadas por el servidor: el saldo pendiente como importe y «Pendiente»
        // como resultado. Se ven escritas en el formulario y se pueden cambiar antes de guardar, que
        // es lo que las distingue de un campo vacío que se rellena solo (D-COB-8).
        self.promesa.importe = self.importePropuesto(ficha.saldoPendiente);
        self.promesa.fecha = '';
        self.promesa.resultado = 'PENDIENTE';
        // El comentario NO se propone: es texto libre y no hay nada probable que proponer. Arranca
        // vacio, y vacio es un dato —no habia nada que añadir—, no un hueco que rellenar.
        self.promesa.comentario = '';
        // Y la confirmacion de la vez anterior se va: este formulario todavia no ha anotado nada,
        // asi que dejarla puesta enseñaria como «lo que acabas de anotar» la promesa de otra ficha.
        self.promesa.confirmacion = null;
        // Salvo que de esta factura haya una anotación cuyo cuerpo ya esté comprometido —en vuelo
        // o en duda—: ahí el formulario enseña **lo que se mandó**, porque lo único que se puede
        // hacer con ella es volver a mandar eso mismo (su referencia ya está reclamada en el
        // servidor). Enseñar la propuesta de nuevo haría que la pantalla dijera un importe y el
        // reintento mandara otro. Y lo mismo si esa anotación llega DESPUÉS, con el formulario ya
        // abierto: por eso el volcado y la huella de quién gobierna se ponen en el mismo sitio
        // (`estrenarElFormulario`, `sincronizarElCuerpoVisible`).
        self.estrenarElFormulario(ficha.id);
        // Esta carga escribe DENTRO del formulario, así que va por el carril al que el dueño acaba
        // de poner la sesión de este turno: si el formulario se cierra o se abre otro antes de que
        // conteste, su respuesta no llega aquí.
        self.cargarGestionesDeLaPromesa(ficha.id);
      });
    },
    /**
     * El cuerpo de la promesa de esa factura que **ya está comprometido**, o `null`: el único sitio
     * que lo contesta.
     *
     * Comprometido quiere decir que ese cuerpo ya salió hacia el servidor y todavía no se sabe en
     * qué quedó, y eso pasa de **dos** maneras, no de una:
     *
     *  1. **en duda**: su respuesta se perdió, su referencia está reclamada y el reintento tiene
     *     que volver a mandar ese mismo cuerpo;
     *  2. **en vuelo**: el POST ha salido y aún no ha contestado. No hay duda todavía, pero el
     *     cuerpo está igual de comprometido: lo que el servidor guarde será eso.
     *
     * Las dos y no solo la primera, porque son exactamente los dos motivos por los que el borrador
     * está inmóvil (`promesaInmovil`). Mirando solo la duda, cerrar el formulario con el POST en
     * vuelo y volver a abrir esa misma factura dejaba a la vista las **propuestas** iniciales,
     * bloqueadas y distintas de lo que se mandó; y si después se perdía la respuesta, la duda
     * nacía con el cuerpo de verdad y ya no había quien lo volcara (revisión CODEX, ronda 2,
     * hallazgo `:1544`). Lo que bloquea el borrador y lo que decide qué cuerpo se enseña tienen que
     * ser la misma pregunta.
     *
     * Y los dos casos los contesta `operacionComprometidaDe`, que es **la misma operación** de la
     * que sale la clave (`claveParaEscribir`): así el cuerpo y la referencia que viajan juntos son
     * siempre los de la misma operación. Preguntándolo por separado —la duda primero y el vuelo
     * después— podían salir de dos operaciones distintas del mismo grupo y mandarse un cuerpo con
     * una clave que no era la suya.
     */
    cuerpoComprometidoDe: function(idFactura) {
      return (this.operacionComprometidaDe('PROMESA', idFactura) || {}).cuerpo || null;
    },
    /**
     * Si de esa factura hay una promesa comprometida, el formulario enseña **el cuerpo que se
     * mandó**.
     *
     * Los campos están bloqueados mientras lo esté (ver `promesaInmovil`), así que esto es lo que
     * hace que lo que se lee y lo que se manda sean lo mismo: el reintento lleva la referencia de
     * entonces y el servidor contesta con lo que quedó escrito de ella.
     *
     * `idTarea` no se vuelca aquí: lo escribe `aplicarGestiones` cuando llega el desplegable, y es
     * quien mira el cuerpo comprometido para no proponer otra gestión distinta de la que se mandó.
     */
    volcarElCuerpoComprometido: function(idFactura) {
      const cuerpo = this.cuerpoComprometidoDe(idFactura);
      if (!cuerpo) return;
      this.promesa.importe = cuerpo.importeComprometido === null
        || cuerpo.importeComprometido === undefined ? '' : String(cuerpo.importeComprometido);
      this.promesa.fecha = cuerpo.fechaComprometida || '';
      this.promesa.resultado = cuerpo.resultado || '';
      // El comentario va con los otros, y por lo mismo: viaja en el cuerpo de la anotacion, asi que
      // si no se volcara la pantalla enseñaria un comentario y el reintento mandaria otro. Es el
      // mismo defecto de «enseña unos datos y manda otros» que cerro la revision tardia del 16/10,
      // y un campo nuevo que no pase por aqui lo reabre.
      this.promesa.comentario = cuerpo.comentario || '';
      // Y la gestión también, que es el quinto campo del cuerpo: el reintento la manda igual que el
      // importe. Lo volvía a escribir `aplicarGestiones` cuando llegaba el desplegable, y eso
      // bastaba al abrir el formulario —ahí la carga viene detrás—, pero no cuando la operación
      // pasa a gobernar un formulario que ya está cargado: la llegada de una reserva de otra
      // pestaña dejaba a la vista la gestión elegida aquí mientras el reintento mandaba la suya.
      this.promesa.idTarea = cuerpo.idTarea || '';
    },
    /**
     * La huella de la operación que **gobierna el formulario** de esa factura: su identidad y su
     * cuerpo juntos, o `null` si no hay ninguna.
     *
     * Las dos cosas en la misma huella y no solo la identidad, porque lo que tiene que estar
     * sincronizado es el par: qué referencia sale (`claveParaEscribir`) y qué cuerpo viaja con ella
     * (`cuerpoComprometidoDe`). Así `sincronizarElCuerpoVisible` detecta tanto que ha empezado a
     * gobernar otra operación como que la que gobierna ha cambiado de cuerpo.
     */
    gobiernoDelFormularioDe: function(idFactura) {
      const operacion = this.operacionComprometidaDe('PROMESA', idFactura);
      if (!operacion) return null;
      const cuerpo = operacion.cuerpo || {};
      return this.llaveDeOperacion('PROMESA', idFactura, operacion.clave) + '|'
        + JSON.stringify([cuerpo.idTarea || '', cuerpo.importeComprometido === null
          || cuerpo.importeComprometido === undefined ? '' : String(cuerpo.importeComprometido),
        cuerpo.fechaComprometida || '', cuerpo.resultado || '', cuerpo.comentario || '']);
    },
    /**
     * Deja el formulario abierto enseñando **el cuerpo de la operación que lo gobierna**, y guarda
     * aparte el borrador que hubiera sin mandar. **El único sitio que los sincroniza.**
     *
     * El defecto que cierra: `operacionComprometidaDe` decide con qué referencia y con qué cuerpo
     * sale la escritura, y el cuerpo a la vista se volcaba **solo al abrir el formulario**. Cuando
     * la operación que gobierna cambia con el formulario ya abierto, las dos cosas se separan: se
     * ve un importe y se reenvía otro. Pasa al recibir una reserva de otra pestaña
     * (`sincronizarHueco`), y de la misma forma cuando una operación del grupo se suelta y la
     * siguiente pasa a gobernar —dos pestañas dejan dos operaciones de la misma factura—. Por eso
     * la sincronización no vive en el camino que lo destapó, sino aquí, y la llaman **todos** los
     * cambios del mapa: el observador de `escriturasEnDuda`, por el que pasan los que ocurren en
     * esta pestaña, y los dos caminos del almacén, que la llaman además **en el mismo turno** para
     * que la reconciliación o el reintento que puedan salir detrás no vean el cuerpo viejo
     * (hallazgo `:2381` de la revisión CODEX y decisión técnica del 16/10/2026).
     *
     * **El borrador sin mandar no se pierde ni se manda con la referencia ajena**: se aparta
     * (`borradorApartado`), se cuenta en pantalla y vuelve a los campos cuando esa operación deja
     * de gobernar. Y todo mirando **la factura del formulario**, así que una operación de otra
     * factura —o una posterior de ésta que no gobierna— no toca lo que hay delante.
     */
    sincronizarElCuerpoVisible: function() {
      // La confirmación cuenta IGUAL QUE ESTAR CERRADO, y esto no es un detalle: desde que el
      // guardado deja la confirmación delante en vez de cerrar el popup (dirección, 19/10/2026), el
      // formulario sigue «abierto» pero sus campos no se dibujan, así que no hay nada que
      // sincronizar — y devolver aquí lo apartado lo escribiría en campos invisibles y lo gastaría:
      // al cerrar la confirmación y volver a abrir, `abrirFormularioPromesa` repone las propuestas y
      // lo tecleado se habría perdido en silencio, justo después de que la pantalla hubiera
      // prometido por escrito que volvía. Es el mismo defecto que cerró la revisión tardía del
      // 16/10; lo que cambia es por dónde entra. Apartado se queda, y lo devuelve
      // `recuperarElBorradorApartado` cuando haya dónde.
      if (!this.promesa.abierto || !this.promesa.idFactura || this.promesa.confirmacion) {
        this.gobiernoDelFormulario = null;
        return;
      }
      const idFactura = this.promesa.idFactura;
      const ahora = this.gobiernoDelFormularioDe(idFactura);
      if (ahora === this.gobiernoDelFormulario) return;
      const gobernaba = !!this.gobiernoDelFormulario;
      this.gobiernoDelFormulario = ahora;
      if (ahora) {
        // El borrador se aparta ANTES de volcar: después ya no se distingue de lo comprometido.
        // Y solo al pasar de editable a gobernado: entre dos operaciones gobernantes lo que hay a
        // la vista es el cuerpo de la primera, que no es de nadie.
        if (!gobernaba) this.apartarElBorrador(idFactura);
        this.volcarElCuerpoComprometido(idFactura);
        return;
      }
      this.devolverElBorradorApartado(idFactura);
    },
    /** Guarda lo que hay escrito en el formulario como borrador sin mandar. Ver `borradorApartado`. */
    apartarElBorrador: function(idFactura) {
      // Lo que se va a ver ahora es el cuerpo ajeno, así que el aviso de «esto es lo que tenías
      // escrito» deja de ser verdad: lo dice el otro, el de que se ha apartado.
      this.promesa.borradorRecuperado = false;
      this.borradorApartado = {
        idFactura: idFactura,
        idTarea: this.promesa.idTarea,
        importe: this.promesa.importe,
        fecha: this.promesa.fecha,
        resultado: this.promesa.resultado,
        comentario: this.promesa.comentario
      };
    },
    /**
     * Devuelve a los campos el borrador que se apartó, **si es de esta factura**: el único sitio
     * que lo hace.
     *
     * Si fuera de otra no se devuelve y tampoco se tira: el formulario de delante es otro, y lo
     * apartado solo tiene sentido en el suyo. Se suelta al estrenar el formulario de **esa otra**
     * factura, que es cuando deja de haber a dónde devolverlo
     * (`recuperarElBorradorApartado`).
     *
     * Lo llaman los dos momentos en los que lo apartado vuelve a tener dónde caer: con el
     * formulario delante, cuando la operación que lo gobernaba deja de gobernarlo
     * (`sincronizarElCuerpoVisible`), y al abrirlo de nuevo si quedó apartado de la vez anterior
     * (`recuperarElBorradorApartado`). Y deja dicho que los campos no son las propuestas
     * (`borradorRecuperado`) aquí y no en cada llamante, por lo mismo que lo demás de este
     * formulario: repartido se olvida en uno.
     */
    devolverElBorradorApartado: function(idFactura) {
      const borrador = this.borradorApartado;
      if (!borrador || borrador.idFactura !== idFactura) return;
      this.borradorApartado = null;
      this.promesa.idTarea = borrador.idTarea;
      this.promesa.importe = borrador.importe;
      this.promesa.fecha = borrador.fecha;
      this.promesa.resultado = borrador.resultado;
      this.promesa.comentario = borrador.comentario || '';
      this.promesa.borradorRecuperado = true;
    },
    /**
     * El formulario se estrena: se fija de qué operación parte y los campos enseñan lo que toque.
     *
     * Va aquí y no en el cuerpo de `abrirFormularioPromesa` para que el estado del que parte
     * `sincronizarElCuerpoVisible` lo deje puesto **el mismo sitio** que vuelca los campos: si la
     * apertura volcara sin fijar la huella, el primer cambio del mapa la vería a cero y apartaría
     * como borrador de la persona lo que acaba de volcarse.
     *
     * **Lo apartado ya no se suelta de oficio aquí**: lo decide `recuperarElBorradorApartado`, y
     * solo cuando no hay ninguna operación gobernando. Si la hay, los campos tienen que seguir
     * enseñando el cuerpo comprometido y lo apartado se queda apartado, con su aviso.
     */
    estrenarElFormulario: function(idFactura) {
      this.promesa.borradorRecuperado = false;
      this.gobiernoDelFormulario = this.gobiernoDelFormularioDe(idFactura);
      this.volcarElCuerpoComprometido(idFactura);
      if (this.gobiernoDelFormulario) return;
      this.recuperarElBorradorApartado(idFactura);
    },
    /**
     * Al estrenar el formulario: **lo apartado de esta factura vuelve a los campos**, y lo de otra
     * se suelta.
     *
     * Es el único sitio por el que lo apartado deja de estar apartado al abrir, y existe porque
     * `estrenarElFormulario` lo ponía a `null` sin mirar de qué factura era. Con eso, el cierre que
     * no lo devuelve —el del éxito del guardado y el de una duda que se reconcilia, que son los dos
     * que la pantalla decide por su cuenta— acababa tirando lo tecleado, y justo después de haberle
     * dicho a la persona, por escrito y en este mismo formulario, que «no se ha mandado ni se ha
     * perdido» y que «vuelve a estos campos». Dos partes de la misma pantalla diciendo lo contrario
     * es el defecto que prohíbe el corolario de dirección, y la decisión del 10/10/2026 sobre esta
     * pantalla es que lo tecleado se conserva tal cual.
     *
     * La gestión elegida vuelve con los otros tres campos, pero **no manda**: detrás de la apertura
     * va `cargarGestionesDeLaPromesa`, y si el servidor ya no la ofrece como elegible —muy posible,
     * porque la anotación que acaba de terminar es de una de ellas— lo que vale es lo que él diga
     * (`aplicarGestiones`). El importe, la fecha y el resultado son lo que no se puede volver a
     * teclear de memoria, y ésos sí se conservan.
     */
    recuperarElBorradorApartado: function(idFactura) {
      const borrador = this.borradorApartado;
      if (!borrador) return;
      if (borrador.idFactura !== idFactura) {
        // De otra factura: aquí no hay a dónde devolverlo y guardarlo más tiempo sería que
        // reapareciera en un formulario que ya no tiene nada que ver.
        this.borradorApartado = null;
        return;
      }
      this.devolverElBorradorApartado(idFactura);
    },
    /**
     * Pide las gestiones sobre las que se puede anotar y las vuelca en el formulario abierto.
     *
     * **Solo toca `gestiones` e `idTarea`**, no lo tecleado: la usan la apertura del formulario y
     * el botón de volver a buscar la gestión recién creada, y ese segundo se pulsa con el importe y
     * la fecha ya escritos.
     *
     * Va por `carrilPromesa`, el carril del formulario: si se cierra o se abre otro antes de que
     * conteste, esta respuesta no escribe aquí.
     */
    cargarGestionesDeLaPromesa: function(idFactura) {
      const self = this;
      self.promesa.error = null;
      self.carrilPromesa.lanzar(FactCobro.historialTrabajoHoy(idFactura), {
        exito: function(respuesta) {
          self.aplicarGestiones(respuesta);
        },
        fallo: function(e) {
          self.promesa.error = self.textoDelFallo(e,
            'No se han podido cargar las gestiones de esta factura, así que no se puede anotar '
            + 'la promesa sobre ninguna. Cierra esto y vuelve a intentarlo.');
        }
      });
    },
    /**
     * Qué gestión queda elegida con las que acaba de traer el historial.
     *
     * **Si se viene de crear una gestión y ésa todavía no está en la respuesta, no se elige
     * ninguna.** Caerse a la que propone el servidor (`idTareaSugerida`) elige una gestión
     * **anterior** —otra llamada, de otro día—, y el formulario parecería listo para guardar: la
     * promesa quedaría anotada en la llamada equivocada y de eso no se enteraría nadie, porque las
     * dos gestiones son de esta misma factura (revisión CODEX, ronda 7).
     *
     * La gestión se acaba de crear, así que esto es una carrera de un instante: lo que se hace es
     * decirlo y dar el control que lo resuelve al lado (`volverABuscarLaGestion`), no adivinar.
     */
    aplicarGestiones: function(respuesta) {
      this.promesa.gestiones = (respuesta && respuesta.gestiones) || [];
      // Quiénes se pueden elegir y por qué no, tal como lo manda el servidor: el desplegable sale de
      // ahí (ver `gestionesElegibles`) y la frase también, que es la misma que saldría al guardar.
      this.promesa.idsElegibles = (respuesta && respuesta.idsGestionesElegibles) || [];
      this.promesa.porqueNoSePuedeAnotar = (respuesta && respuesta.porqueNoSePuedeAnotar) || null;
      // Si de esta factura hay una anotación con el cuerpo ya comprometido, la gestión es **la que
      // se mandó con ella** y no hay nada que proponer: el reintento lleva su misma referencia, así
      // que proponer otra enseñaría una gestión distinta de la que el servidor tiene reclamada para
      // esa anotación. Por el mismo sitio que los tres campos (`cuerpoComprometidoDe`), y no solo
      // por la duda: con el POST en vuelo esto proponía `idTareaSugerida` encima del `idTarea` que
      // acababa de salir.
      const comprometido = this.cuerpoComprometidoDe(this.promesa.idFactura);
      if (comprometido) {
        this.promesa.recienCreadaSinAparecer = false;
        this.promesa.idTarea = comprometido.idTarea || '';
        return;
      }
      const recienCreada = this.promesa.idTareaRecienCreada;
      // Y se busca entre las ELEGIBLES, no entre todas: preseleccionar una que el servidor no acepta
      // es la misma avería que proponerla, con el formulario además pareciendo listo para guardar.
      const esta = !!recienCreada && this.gestionesElegibles.some(function(g) {
        return g.id === recienCreada;
      });
      this.promesa.recienCreadaSinAparecer = !!recienCreada && !esta;
      if (this.promesa.recienCreadaSinAparecer) {
        this.promesa.idTarea = '';
        return;
      }
      this.promesa.idTarea = esta ? recienCreada : ((respuesta && respuesta.idTareaSugerida) || '');
    },
    /**
     * Escribe un campo del borrador de la promesa, **si ese borrador se puede tocar**.
     *
     * Es el único sitio por el que los cuatro campos del formulario se modifican, y existe porque
     * el `:disabled` no basta: deshabilitado es lo que se ve, y lo que decide qué se guarda son los
     * manejadores. Un `@input` que escribiera directo en `promesa.*` seguiría pudiendo cambiar el
     * cuerpo mientras la petición está en vuelo —por un campo que se pinte habilitado un instante,
     * por un autocompletado del navegador, o por un camino nuevo que se añada mañana— y entonces la
     * pantalla enseñaría unos datos y el servidor guardaría otros (revisión CODEX, ronda 12,
     * hallazgo `:471`; el contrato lo pide «también desde los manejadores»).
     *
     * Quién puede y quién no lo contesta `promesaInmovil`, el mismo predicado que apaga los campos.
     */
    escribirEnElBorrador: function(campo, valor) {
      if (this.promesaInmovil) return;
      this.promesa[campo] = valor;
    },
    /** Vuelve a pedir las gestiones para encontrar la que se acaba de crear. */
    volverABuscarLaGestion: function() {
      if (this.promesa.idFactura) this.cargarGestionesDeLaPromesa(this.promesa.idFactura);
    },
    /**
     * Qué se le dice a la persona cuando la gestión se ha creado y el formulario NO se ha abierto.
     *
     * Las tres cosas que pide el criterio de pantalla de dirección (05/10/2026): qué ha pasado,
     * quién lo desbloquea —ella misma— y dónde. Y en dos versiones, porque no es lo mismo tener
     * delante el formulario de **otra** factura que el de **ésta**: en el segundo caso la gestión
     * que se acaba de crear no está en el desplegable del que hay abierto, que se cargó antes, así
     * que hay que decir cómo llegar a ella.
     */
    avisoFormularioNoAbierto: function(ficha) {
      const codigo = this.texto(ficha.codigo);
      if (this.promesa.idFactura === ficha.id) {
        return 'La gestión está creada, pero el formulario de la promesa no se ha vuelto a abrir '
          + 'para no borrar lo que estás escribiendo en el que tienes delante. Si quieres anotarla '
          + 'sobre la gestión que acaba de crearse, guarda o cierra ése y pulsa «Anotar promesa» '
          + 'otra vez en la ficha de la factura ' + codigo + ': ahí ya estará la nueva.';
      }
      return 'La gestión está creada, pero no se ha abierto su formulario de promesa para no tocar '
        + 'el que tienes abierto. Cuando acabes con ése, pulsa «Anotar promesa» en la ficha de la '
        + 'factura ' + codigo + '.';
    },
    /**
     * Cierra el formulario de la promesa porque lo ha cerrado la persona.
     *
     * Lo que estuviera guardándose **sigue guardándose** —no hay forma de cancelar un POST que ya
     * ha salido, y decir que se ha cancelado sería mentir—, pero su respuesta ya no escribe aquí:
     * el dueño sube el turno al cerrar y esa respuesta sale por `descartada`, que la cuenta en el
     * aviso de la pantalla. Y no se admite otra escritura hasta que vuelva (`guardandoPromesa`),
     * se abra el formulario que se abra.
     */
    cerrarPromesa: function() {
      this.formularioPromesa.cerrar({ porLaPersona: true });
    },
    /**
     * Framework7 **empieza** a cerrar el popup de la promesa: la X, el swipe, la tecla Esc.
     *
     * Cuelga de `popup:close` y no de `popup:closed` a propósito, y no es un detalle: `closed` llega
     * al **final** de la animación, unas décimas después, y en ese rato la persona puede haber
     * pulsado «Anotar promesa» en otra ficha —el popup es el mismo elemento, así que ese aviso
     * tardío no se distingue del de ahora— y el formulario recién abierto se cerraría solo. Con
     * `close` el aviso llega pegado al gesto, así que no hay rato en el que equivocarse.
     *
     * Y si el estado dice ya «cerrado», esto es el eco del cierre que acaba de decidir el código
     * —el guardado al terminar bien, la reconciliación de una duda—: la decisión está tomada y no se
     * vuelve a tomar aquí.
     */
    alCerrarElPopupDeLaPromesa: function() {
      if (!this.promesa.abierto) return;
      this.cerrarPromesa();
    },
    /**
     * Cierra sin animación los popups que queden delante al irse de la pantalla.
     *
     * Es el fallo 1 de la prueba en preview-2 por el otro camino: un popup abierto cuyo elemento
     * desaparece del DOM deja puesta la cortina de Framework7 —y la clase `with-modal-popup` del
     * `html`, que además corta el desplazamiento—, y eso se queda sobre la pantalla a la que se
     * vuelve, en gris y sin nadie que lo quite. Al guardar lo arregla el `:opened` de la plantilla;
     * aquí no vale, porque lo que se va es el componente entero, así que se cierra por Framework7
     * antes de que Vue lo destruya.
     */
    cerrarLosPopupsAlIrse: function() {
      const f7 = this.$f7;
      if (!f7 || !f7.popup) return;
      ['.popup-promesa.modal-in', '.popup-historial.modal-in'].forEach(function(cual) {
        try {
          if (document.querySelector(cual)) f7.popup.close(cual, false);
        } catch (e) {
          // Si Framework7 no puede cerrarlo, no hay nada mejor que hacer desde aquí y lo que no
          // puede es tumbar la salida de la pantalla.
        }
      });
    },
    /**
     * Anota la promesa y recarga la lista.
     *
     * Los tres campos se mandan **tal como están**: si falta uno, el servidor lo rechaza con un
     * mensaje concreto y no escribe nada. No se valida aquí además de allí para no tener dos
     * criterios de qué es una promesa completa; lo que sí se hace es no dejar pulsar dos veces.
     *
     * **La escritura va por su carril y la factura se guarda en una variable local.** Las dos cosas
     * por lo mismo: cuando esta respuesta llegue, el formulario de delante puede ser otro —se puede
     * cerrar éste y abrir el de otra factura mientras el POST está en vuelo— y entonces esta
     * respuesta no escribe en él (`descartada`), sino en el aviso de la pantalla, que no es de
     * ninguna ficha. Sin la variable local, además, ese aviso nombraría la factura equivocada.
     */
    guardarPromesa: function() {
      const self = this;
      if (self.guardandoPromesa) return;
      const idFactura = self.promesa.idFactura;
      const codigoFactura = self.promesa.codigoFactura;
      // Ya no se guarda el turno de salida: desde que el guardado deja la confirmación delante en
      // vez de cerrar el formulario (dirección, 19/10/2026), esta escritura no quita nada de delante
      // y no tiene sobre qué mandar. Quien escribe en el formulario sigue siendo el carril, que ya
      // lleva el sello de sesión y descarta por `descartada` lo que vuelva a una sesión que no es la
      // suya; lo que desapareció es el único camino por el que esta respuesta cerraba algo.
      // El cuerpo se calcula ANTES de reservar, porque el comprometido sale de la operación que ya
      // estaba apuntada y la reserva no lo toca.
      //
      // Con la clave viaja **el cuerpo de entonces**, no el del formulario de ahora. Es la otra
      // mitad de reutilizar la referencia: el servidor reconoce la anotación por ella y contesta
      // con lo que haya quedado escrito, así que mandando otros datos con la misma referencia la
      // pantalla podía anunciar un importe que no es el guardado —basta con que la primera entre
      // con retraso— (revisión CODEX, ronda 10). Mientras el cuerpo esté comprometido los campos
      // están bloqueados y enseñan ése, así que las dos cosas dicen lo mismo: lo pregunta el mismo
      // `cuerpoComprometidoDe` que vuelca el formulario.
      //
      // Y es el CANDIDATO, no todavía el que viaja: la reserva puede salir con una referencia que
      // ya estaba reclamada —la de un reintento, o la que otra pestaña acaba de reclamar en este
      // mismo instante—, y entonces el cuerpo que viaja es el de aquélla. Lo decide el mismo sitio
      // que la clave y lo devuelve en la reserva (ver `reservarOperacion`), porque preguntarlo aquí
      // antes de reservar es lo que dejaba salir un POST con la clave de una operación y el cuerpo
      // de otra.
      const candidato = self.cuerpoComprometidoDe(idFactura) || {
        idTarea: self.promesa.idTarea || null,
        importeComprometido: self.promesa.importe === '' ? null : Number(self.promesa.importe),
        fechaComprometida: self.promesa.fecha || null,
        resultado: self.promesa.resultado || null,
        // Vacio se manda como `null` y no como cadena vacia: el servidor guarda `null` cuando no hay
        // comentario, asi que mandar `''` haria que el cuerpo comprometido y lo guardado se
        // distinguieran en un campo que es el mismo.
        comentario: (self.promesa.comentario || '').trim() || null
      };
      // La referencia de ESTA anotación, apuntada ANTES del POST. Se reutiliza la de la escritura
      // ya apuntada de esta misma factura —ése es el reintento, y la clave es lo único que impide
      // que escriba una segunda promesa— y es nueva en cualquier otro caso. Apuntarla antes es lo
      // que la conserva si la pestaña se va con la petición en el aire (ver `reservarOperacion`).
      // La reserva es **lo único** que apunta que esta anotación está en vuelo: lleva su identidad
      // (`tipo|factura|clave`) y su cuerpo, de ella salen el bloqueo del botón (`guardandoPromesa`)
      // y la congelación de SU borrador y no de cualquiera (`promesaInmovil`, ronda 12, hallazgo
      // `:471`), y la suelta `liquidarReserva` por esa clave exacta. Antes había además un
      // `promesaEnVuelo` en `data` que `escrituraTerminada()` borraba sin mirar qué operación había
      // terminado, así que la vuelta de una GESTIÓN liberaba esta anotación todavía viva (decisión
      // técnica del 15/10/2026).
      const reserva = self.reservarOperacion('PROMESA', idFactura, codigoFactura, candidato);
      // Sin reserva guardada no sale el POST: ver `reservarOperacion`. El formulario se queda
      // abierto con lo tecleado, como con cualquier otro rechazo: esto se arregla y se vuelve a
      // pulsar, y hacerle teclear la promesa otra vez sería castigarla por el navegador.
      if (reserva.sinConstancia) {
        self.promesa.error = self.porqueNoConstaLaReserva('PROMESA');
        return;
      }
      const clave = reserva.clave;
      // El cuerpo de la operación con la que se sale, que es el único que puede viajar con esa
      // clave. Coincide con el candidato cuando la referencia es nueva.
      const cuerpo = reserva.cuerpo || candidato;
      self.promesa.error = null;
      self.ultimaEscritura = null;
      self.carrilPromesaGuardado.lanzar(FactCobro.anotarPromesa(idFactura, {
        idTarea: cuerpo.idTarea,
        importeComprometido: cuerpo.importeComprometido,
        fechaComprometida: cuerpo.fechaComprometida,
        resultado: cuerpo.resultado,
        comentario: cuerpo.comentario === undefined ? null : cuerpo.comentario,
        claveOperacion: clave
      }), {
        exito: function(respuesta) {
          self.liquidarReserva(reserva);
          // La anotación terminó: si venía de un reintento, su duda ya no tiene nada que resolver y
          // dejarla puesta volvería a reutilizar su clave en la anotación siguiente. Por su clave
          // exacta, así que ninguna otra operación de esta misma factura se va con ella.
          self.resolverOperacion('PROMESA', idFactura, clave);
          // EL FORMULARIO NO SE CIERRA, y es el fallo 3 de la prueba de dirección del 19/10/2026:
          // «nada más pulsar Anotar la promesa el popup se cierra y no se puede releer lo
          // guardado». Lo que queda delante es la CONFIRMACIÓN —importe, fecha, resultado y
          // comentario, releídos de la respuesta—, y lo cierra la persona cuando la ha leído, que es
          // además la decisión de dirección del 10/10/2026 sobre quién manda en este formulario.
          //
          // Lo que se enseña sale de `respuesta` y no del formulario: lo que ha quedado guardado lo
          // dice el servidor, y en un reintento puede no ser lo que hubiera en los campos.
          self.promesa.confirmacion = self.confirmacionDeLaPromesa(respuesta);
          self.promesa.error = null;
          self.ultimaEscritura = {
            resumen: self.resumenDeLaPromesa(respuesta, codigoFactura),
            // Y los avisos del servidor, que hoy son dos y por sitio: que el comentario no se haya
            // podido copiar en los Comentarios de la gestión, y que no se haya podido refrescar lo
            // que de esa gestión enseña el calendario. La promesa está guardada; lo que falta es
            // dónde se lee ese texto, y eso se dice uno por uno (D-COB-8). Se pintan todos: la
            // lista llega del servidor y esta pantalla no decide cuántos caben.
            avisos: self.avisosDe(respuesta),
            mal: false
          };
          // La lista se rehace sola —paso 4 de dirección— mientras la confirmación está delante, así
          // que al cerrarla la factura gestionada ya ha bajado de puesto sin pulsar F5.
          self.cargar();
        },
        // No hay `limpiar`: lo único que esta escritura había dejado puesto es SU operación en el
        // mapa, y la sueltan `fallo` y `descartada` por su clave exacta. Un `limpiar` que recalculara
        // «si queda algo en vuelo» es lo que había antes, y era un sitio más donde una operación
        // podía liberar otra.
        fallo: function(e) {
          // La reserva se suelta antes de decidir: si el servidor ha contestado, de esa referencia
          // ya se sabe lo que hay, y si no ha contestado la convierte en duda `anotarEnDuda`.
          self.liquidarReserva(reserva);
          // El popup se queda abierto: el rechazo es «te falta un campo» o «elige otra gestión», y
          // cerrarlo obligaría a teclearlo todo otra vez.
          self.promesa.error = self.textoDelFallo(e,
            'No se sabe si la promesa se ha llegado a guardar. Cierra esto, recarga la lista y '
            + 'mira el historial de esta factura antes de anotarla otra vez.');
          // Y si la respuesta se PERDIÓ, el botón NO se desbloquea: ver `anotarEnDuda`. Un rechazo
          // del servidor sí deja reintentar —no ha escrito nada—, y los dos casos llegan por aquí.
          if (self.anotarEnDuda(e, 'PROMESA', clave, idFactura, codigoFactura, cuerpo)) {
            // La duda la resuelve el servidor por su clave, así que se pregunta ya: muchas veces
            // queda resuelta sin que la persona tenga que hacer nada.
            self.reconciliarEscrituraEnDuda(self.operacionDe('PROMESA', idFactura, clave));
          }
        },
        descartada: function(ok, resultado) {
          self.liquidarReserva(reserva);
          // El formulario que la lanzó ya no está delante. La respuesta NO se pierde —es la única
          // noticia de lo que ha quedado escrito— pero se cuenta en el aviso de la pantalla y no
          // dentro de un formulario que es de otra factura.
          //
          // Y la duda vale igual con el formulario cerrado: lo que no se sabe es si la promesa de
          // ESA factura quedó escrita, y eso no depende de qué haya delante ahora.
          if (!ok && self.anotarEnDuda(resultado, 'PROMESA', clave, idFactura, codigoFactura,
            cuerpo)) {
            self.reconciliarEscrituraEnDuda(self.operacionDe('PROMESA', idFactura, clave));
            return;
          }
          // Terminó bien aunque su formulario ya no esté delante: la duda de ESA operación, si la
          // había, queda resuelta igual. Lo que no se sabía era si la promesa quedó escrita, y eso
          // no depende de qué haya delante ahora.
          if (ok) self.resolverOperacion('PROMESA', idFactura, clave);
          self.ultimaEscritura = ok
            ? {
              resumen: self.resumenDeLaPromesa(resultado, codigoFactura),
              // Los avisos del servidor también cuando su formulario ya no está delante: lo que no
              // se haya podido hacer alrededor de esta promesa no depende de qué haya delante ahora.
              avisos: self.avisosDe(resultado),
              mal: false
            }
            : {
              // El mensaje del servidor va DENTRO de una frase que nombra la factura: ese
              // formulario ya no está delante, así que un «te falta un campo» a secas se leería
              // como si fuera del que sí lo está.
              resumen: 'Lo que ha pasado con la promesa de la factura '
                + self.texto(codigoFactura) + ', cuyo formulario ya se ha cerrado: '
                + self.textoDelFallo(resultado, 'no se sabe si se ha llegado a guardar. Mira el '
                  + 'historial de esa factura antes de anotarla otra vez.'),
              avisos: [],
              mal: true
            };
          self.cargar();
        }
      });
    },
    /**
     * La llave con la que vive una duda en el mapa: **una por OPERACIÓN**.
     *
     * La identidad de una operación es `usuario + tipo + factura + clave idempotente` —el usuario va
     * en el nombre del hueco de `localStorage` y dentro del dato; aquí, en memoria, van las otras
     * tres—. El tipo y la factura **agrupan** (`dudaDe`, `dudasDeLaFactura`) pero no identifican: dos
     * anotaciones del mismo tipo sobre la misma factura, hechas en dos pestañas, son dos operaciones
     * distintas con dos referencias distintas, y la una no puede sustituir ni borrar a la otra
     * (revisión CODEX, ronda 12, hallazgo `:1702`, y decisión técnica del 15/10/2026).
     *
     * Antes la llave era `tipo|idFactura`, así que la segunda pestaña pisaba la referencia de la
     * primera —en memoria al restaurar y en el almacén al guardar— y la primera se quedaba sin la
     * clave con la que tenía que reintentar: un intento más generaba otra referencia y podía
     * duplicar la escritura que sí había llegado.
     */
    llaveDeOperacion: function(tipo, idFactura, clave) {
      return tipo + '|' + idFactura + '|' + clave;
    },
    /** El tramo por el que se agrupan las operaciones de una factura: `tipo|idFactura|`. */
    grupoDeLaFactura: function(tipo, idFactura) {
      return tipo + '|' + idFactura + '|';
    },
    /**
     * Quién es el dueño de las dudas guardadas: el usuario de la sesión, o cadena vacía.
     *
     * Va **dentro** del dato guardado y además en el nombre del hueco, y las dos cosas: el nombre
     * es lo que evita leer las de otra cuenta, y la copia de dentro es lo que lo detecta si el
     * nombre cambiara de forma. Es el mismo motivo por el que el sello de sesión del carril mira
     * usuario y token y no solo uno de los dos: en el mismo dispositivo entra más de una persona,
     * y aquí lo que está guardado es con qué referencia se escribió en nombre de quién.
     */
    duenoDeLasDudas: function() {
      const usuario = Utils.getUser();
      return (usuario && usuario.username) || '';
    },
    /** El prefijo de los huecos de `localStorage` de esta persona: `almacén|usuario|`. */
    prefijoDeLasDudas: function() {
      return ALMACEN_DUDAS + '|' + this.duenoDeLasDudas() + '|';
    },
    /**
     * El hueco de **una** duda. Uno por operación, y eso es lo que impide que dos pestañas se pisen.
     *
     * Con el mapa entero en un solo hueco, dos pestañas de la misma persona que pierdan una
     * respuesta cada una se borran la duda la una a la otra: cada componente tiene su propio mapa y
     * el `setItem` de la segunda sustituye en bloque lo que había escrito la primera, así que al
     * recargar la primera ya no recupera su clave idempotente y un intento más puede duplicar
     * (revisión CODEX, ronda 11). Y **fusionar antes de escribir no lo arregla**: entre el `getItem`
     * y el `setItem` no hay nada que impida que la otra pestaña escriba en medio —no existe una
     * escritura atómica de `localStorage`—, así que lo que se quita es la necesidad de fusionar:
     * cada operación en su hueco y nadie escribe sobre el de nadie.
     */
    huecoDeLaOperacion: function(tipo, idFactura, clave) {
      return this.prefijoDeLasDudas() + this.llaveDeOperacion(tipo, idFactura, clave);
    },
    /**
     * Guarda las dudas, **una por hueco**. No lo llama nadie a mano: lo dispara el observador de
     * `escriturasEnDuda`.
     *
     * Y **solo borra los huecos que esta pestaña había escrito o restaurado** (`huecosPropios`), no
     * los que haya en el almacén: una duda de otra pestaña que esta no conoce no es basura, es la
     * referencia con la que la otra tiene que reintentar. Es la otra mitad de tener un hueco por
     * operación; sin esto, la limpieza haría lo mismo que hacía el `setItem` en bloque.
     *
     * Si el navegador no deja escribir —modo privado, cuota llena— esto **no revienta**: una
     * excepción de almacenamiento no puede tumbar lo que la persona está haciendo. Pero tampoco se
     * da por hecho que haya escrito: quien necesita que la reserva conste lo comprueba releyéndola
     * (`reservaConsta`), y es ahí donde se decide, no aquí.
     */
    guardarDudas: function() {
      const self = this;
      const dudas = self.escriturasEnDuda;
      const ahora = {};
      Object.keys(dudas).forEach(function(llave) {
        const duda = dudas[llave];
        if (!duda) return;
        const hueco = self.huecoDeLaOperacion(duda.tipo, duda.idFactura, duda.clave);
        ahora[hueco] = true;
        self.escribirHueco(hueco, duda);
      });
      Object.keys(self.huecosPropios || {}).forEach(function(hueco) {
        // El hueco que no se ha podido retirar SIGUE siendo de esta pestaña: olvidándolo, nadie
        // volvería a intentar borrarlo y ese resto resucitaría una referencia ya consumida la
        // próxima vez que se lea el grupo (`incorporarElGrupoDelAlmacen`).
        if (!ahora[hueco] && !self.borrarHueco(hueco)) ahora[hueco] = true;
      });
      self.huecosPropios = ahora;
    },
    /**
     * Escribe un hueco, con el dueño dentro, y dice si la excepción se ha comido o no.
     *
     * Lo que **no** se puede deducir de que no haya lanzado es que la reserva esté guardada: hay
     * navegadores que aceptan el `setItem` y no conservan nada. Por eso la prueba de que una reserva
     * consta es releerla, no que esto devuelva `true`.
     */
    escribirHueco: function(hueco, duda) {
      try {
        window.localStorage.setItem(hueco, JSON.stringify({
          usuario: this.duenoDeLasDudas(),
          duda: this.instantaneaDeLaOperacion(duda)
        }));
        return true;
      } catch (e) {
        return false;
      }
    },
    /**
     * Lo que de una operación se GUARDA, que no es todo lo que tiene en memoria.
     *
     * **`comprobando` se queda fuera**, y es la misma forma del fallo que el de las pestañas: es un
     * dato de la pestaña que lanzó la comprobación —no de la operación—, así que en el almacén
     * compartido no significa nada y además hacía que el hueco cambiara dos veces por cada
     * comprobación, avisando a las demás pestañas de algo que no les dice nada. Lo que se guarda es
     * lo que cualquier pestaña necesita saber de esa referencia: con qué salió, qué cuerpo viajó con
     * ella, cuándo, y en qué quedó.
     *
     * Y con **la forma fija** y siempre los mismos campos, porque es lo que permite comparar lo
     * guardado con lo que hay en memoria sin que sobre ni falte nada (`mismaOperacion`).
     */
    instantaneaDeLaOperacion: function(duda) {
      return {
        tipo: duda.tipo,
        clave: duda.clave,
        // El turno SÍ se guarda: es con lo que las dos pestañas deciden igual cuál de las dos
        // reclamaciones manda, así que tiene que viajar en el hueco (ver `turnoDelGrupo`).
        turno: this.turnoDe(duda),
        idFactura: duda.idFactura,
        codigoFactura: duda.codigoFactura || '',
        cuerpo: duda.cuerpo || null,
        fecha: duda.fecha || null,
        enVuelo: !!duda.enVuelo,
        bloquea: !!duda.bloquea,
        resuelta: !!duda.resuelta,
        revisaElHistorial: !!duda.revisaElHistorial
      };
    },
    /** Si dos operaciones dicen lo mismo de esa referencia. Ver `instantaneaDeLaOperacion`. */
    mismaOperacion: function(una, otra) {
      return JSON.stringify(this.instantaneaDeLaOperacion(una))
        === JSON.stringify(this.instantaneaDeLaOperacion(otra));
    },
    /** Borra un hueco y dice si de verdad ha dejado de estar. Ver `guardarDudas`. */
    borrarHueco: function(hueco) {
      try {
        window.localStorage.removeItem(hueco);
        return window.localStorage.getItem(hueco) === null;
      } catch (e) {
        return false;
      }
    },
    /** Lo que hay en un hueco, o `null`: lo que viene del almacén es un dato de fuera. */
    leerHueco: function(hueco) {
      try {
        return JSON.parse(window.localStorage.getItem(hueco) || 'null');
      } catch (e) {
        return null;
      }
    },
    /** Los nombres de los huecos de esta persona, listados antes de tocar ninguno. */
    huecosGuardados: function() {
      const prefijo = this.prefijoDeLasDudas();
      const nombres = [];
      try {
        // Se recogen todos ANTES de borrar: quitando huecos mientras se recorre por índice, los de
        // detrás se corren y se saltan.
        for (let i = 0; i < window.localStorage.length; i++) {
          const nombre = window.localStorage.key(i);
          if (nombre && nombre.indexOf(prefijo) === 0) nombres.push(nombre);
        }
      } catch (e) {
        // A propósito: ver `guardarDudas`.
      }
      return nombres;
    },
    /**
     * Recupera las dudas que quedaron de la sesión anterior de esta misma persona.
     *
     * Lo que se restaura es **la clave y el cuerpo**, que es lo que hace resoluble la duda: con
     * ellos la pulsación siguiente reutiliza la referencia y el servidor contesta «ya estaba hecha»
     * en vez de escribir una segunda. Lo que NO se restaura es `comprobando`: una comprobación en
     * vuelo se fue con la página y hay que volver a lanzarla, cosa que hace `reconciliarLasDudas`.
     *
     * Se descarta lo que no tenga forma de duda y lo que sea de otra cuenta: el almacén lo puede
     * haber tocado cualquiera y lo que entra de ahí se trata como lo que es, un dato de fuera. Y lo
     * que se descarta se borra, hueco a hueco: lo que no se puede resolver desde aquí no tiene por
     * qué seguir ocupando sitio.
     *
     * **Por vieja, solo se descarta la que el servidor ya ha reconciliado.** Una duda sin
     * reconciliar guarda la única referencia con la que el reintento no duplica, y esa referencia
     * no caduca en el servidor: ver `DIAS_QUE_VIVE_UNA_DUDA`.
     */
    restaurarDudas: function() {
      const self = this;
      const limite = Date.now() - DIAS_QUE_VIVE_UNA_DUDA * 24 * 60 * 60 * 1000;
      self.huecosPropios = {};
      self.huecosGuardados().forEach(function(hueco) {
        const guardado = self.leerHueco(hueco);
        const duda = guardado && guardado.duda;
        if (!self.esDeEstaPersona(guardado) || !self.esUnaDudaGuardada(duda)
          || self.caducada(duda, limite)) {
          self.borrarHueco(hueco);
          return;
        }
        // Y se apunta como propio: a partir de aquí esta pestaña sí puede quitarlo cuando su duda
        // quede resuelta.
        self.huecosPropios[hueco] = true;
        self.$set(self.escriturasEnDuda,
          self.llaveDeOperacion(duda.tipo, duda.idFactura, duda.clave),
          self.operacionDelAlmacen(duda));
      });
      // Y no hace falta recalcular nada: el bloqueo del botón y la congelación del borrador se
      // derivan del mapa, así que una promesa en duda restaurada ya llega apagando su botón.
    },
    /** Si lo guardado en un hueco es de la cuenta con la que se ha entrado. Ver `duenoDeLasDudas`. */
    esDeEstaPersona: function(guardado) {
      return !!guardado && guardado.usuario === this.duenoDeLasDudas();
    },
    /**
     * La operación tal como queda EN MEMORIA a partir de lo que hay en su hueco: **el único sitio
     * que lo traduce**, lo lea quien lo lea (al montar o al cambiar otra pestaña).
     *
     * Dos campos no se copian, y los dos por el mismo motivo —son de la pestaña que lanzó la
     * petición, no de la referencia—:
     *
     *  - **`enVuelo` siempre vuelve a `false`**, así que lo que estaba volando se incorpora aquí
     *    como una DUDA. Esta pestaña no va a ver esa respuesta: o se fue con la página anterior, o
     *    la está esperando otra pestaña. De una operación cuyo desenlace no se va a ver no se sabe
     *    si quedó escrita —que es exactamente lo que es una duda—, así que se pregunta por su
     *    referencia al servidor (`reconciliarLasDudas`) y hay un control con el que salir de ahí.
     *    Dejarla «en vuelo» aquí apagaría el botón sin nada que lo volviera a encender si la otra
     *    pestaña se cierra, que es un control mudo de los que no quiere dirección (05/10/2026).
     *  - **`comprobando` siempre `false`**: ni se guarda (`instantaneaDeLaOperacion`) ni se hereda.
     *
     * Lo que sí se conserva es lo único que la hace resoluble: **la clave y el cuerpo** con los que
     * salió. Con ellos, una pulsación en cualquier pestaña reutiliza la referencia y el servidor
     * contesta «ya estaba hecha» en vez de escribir una segunda.
     *
     * @param {boolean} [deOtraPestana] si viene de otra pestaña abierta ahora mismo, y no de lo que
     *        quedó guardado de antes. Solo cambia **lo que se le dice a la persona**: de ésa no
     *        consta que su petición se cortara, así que el aviso no lo afirma. No se guarda, porque
     *        la misma operación es propia en una pestaña y ajena en la otra.
     */
    operacionDelAlmacen: function(duda, deOtraPestana) {
      return {
        deOtraPestana: !!deOtraPestana,
        tipo: duda.tipo,
        clave: duda.clave,
        // Tal como está guardado, sin recalcularlo: el turno es de la RECLAMACIÓN, no de la pestaña
        // que la lee, y dándole uno nuevo aquí la reclamación ajena adelantaría a la propia.
        turno: this.turnoDe(duda),
        idFactura: duda.idFactura,
        codigoFactura: duda.codigoFactura || '',
        cuerpo: duda.cuerpo || null,
        fecha: duda.fecha,
        enVuelo: false,
        bloquea: duda.tipo === 'PROMESA',
        // Una que volaba no está resuelta, conste lo que conste: su reintento salió y de él no se
        // sabe nada. Ver `caducada`, que mira las dos cosas por lo mismo.
        resuelta: !!duda.resuelta && !duda.enVuelo,
        comprobando: false,
        revisaElHistorial: !!duda.revisaElHistorial
      };
    },
    /**
     * Empieza a escuchar el almacén: **lo que otra pestaña de esta misma persona reserve, resuelva
     * o suelte, mientras ésta sigue abierta**.
     *
     * Tener un hueco por operación evitaba que dos pestañas se *pisaran* lo guardado (ronda 11),
     * pero no sincroniza los mapas en memoria, que es lo que faltaba: `restaurarDudas` solo corre al
     * crear el componente, así que con las dos pestañas ya montadas la B no se enteraba nunca de lo
     * que la A reservó después. En la B el botón seguía encendido y `claveParaEscribir` generaba una
     * referencia NUEVA para esa misma factura, de modo que anotar allí escribía una segunda promesa
     * —o creaba una segunda T0045— si la petición de la A sí había llegado al servidor (revisión
     * CODEX, ronda 16, hallazgo `:1444`). El almacén es el único sitio que las dos ven, y el
     * navegador ya avisa de cada cambio: esto es escucharlo.
     *
     * El oyente vive en `window`, que no se va con el componente, así que se quita al salir
     * (`dejarDeEscucharElAlmacen`): si no, la pantalla siguiente tendría un componente destruido
     * tocando su mapa.
     */
    escucharElAlmacen: function() {
      const self = this;
      if (!window.addEventListener) return;
      this.alCambiarElAlmacen = function(evento) { self.incorporarCambioDelAlmacen(evento); };
      window.addEventListener('storage', this.alCambiarElAlmacen);
    },
    /** Deja de escuchar. Ver `escucharElAlmacen`. */
    dejarDeEscucharElAlmacen: function() {
      if (!this.alCambiarElAlmacen || !window.removeEventListener) return;
      window.removeEventListener('storage', this.alCambiarElAlmacen);
      this.alCambiarElAlmacen = null;
    },
    /**
     * Lo que otra pestaña acaba de escribir en el almacén, incorporado aquí.
     *
     * El navegador avisa **solo a las demás pestañas**, nunca a la que escribe, así que esto no se
     * pisa con lo que hace esta pantalla.
     *
     * Y se mira únicamente el almacén de las dudas: el acuse de la última escritura vive en
     * `sessionStorage` y es de esta pestaña **a propósito** (ver `ALMACEN_ULTIMA`), así que lo que
     * otra haya hecho con el suyo no se incorpora. Son dos decisiones distintas, no un olvido: una
     * referencia reservada obliga a todas las pestañas; «lo último que has hecho» solo a la tuya.
     */
    incorporarCambioDelAlmacen: function(evento) {
      if (!evento) return;
      if (evento.storageArea && evento.storageArea !== window.localStorage) return;
      // Sin `key` es un vaciado entero del almacén: no dice qué huecos, así que se miran todos.
      if (evento.key === null || evento.key === undefined) {
        this.resincronizarDudas();
        return;
      }
      if (String(evento.key).indexOf(this.prefijoDeLasDudas()) !== 0) return;
      this.sincronizarHueco(evento.key);
    },
    /**
     * Pone al día **una** operación con lo que diga su hueco ahora mismo.
     *
     * Lo que esta pestaña tiene EN VUELO no lo toca nadie de fuera: su POST está ocurriendo aquí y
     * su objeto es el que esperan los manejadores de esa petición —la identidad se compara por
     * objeto (`sigueSiendoLaMismaOperacion`)—, así que sustituirlo desde un evento dejaría esa
     * respuesta sin nadie que la aplicara.
     *
     * Y si lo guardado dice lo mismo que lo que ya hay, no se sustituye nada: así una comprobación
     * en marcha en esta pestaña no se queda sin su objeto por un eco del almacén.
     */
    sincronizarHueco: function(hueco) {
      const guardado = this.leerHueco(hueco);
      const duda = guardado && guardado.duda;
      if (!this.esDeEstaPersona(guardado) || !this.esUnaDudaGuardada(duda)) {
        // El hueco se ha ido —la otra pestaña resolvió esa operación o la soltó— o ya no vale.
        this.olvidarLaOperacionDelHueco(hueco);
        return;
      }
      const llave = this.llaveDeOperacion(duda.tipo, duda.idFactura, duda.clave);
      const nuestra = this.escriturasEnDuda[llave];
      if (nuestra && nuestra.enVuelo) return;
      const comoQueda = this.operacionDelAlmacen(duda, true);
      if (nuestra && this.mismaOperacion(nuestra, comoQueda)) return;
      this.$set(this.escriturasEnDuda, llave, comoQueda);
      // En el MISMO turno, no cuando el observador del mapa se despierte: si esta operación pasa a
      // gobernar el formulario abierto, lo que salga detrás —la reconciliación que se pide aquí
      // mismo, o un reintento— ya puede reenviar su cuerpo, y hasta entonces la pantalla estaría
      // enseñando otro (hallazgo `:2381`). Ver `sincronizarElCuerpoVisible`.
      this.sincronizarElCuerpoVisible();
    },
    /**
     * La operación de ese hueco deja de estar apuntada aquí, porque en el almacén ya no está.
     *
     * Conservarla sería peor que perderla: `claveParaEscribir` seguiría entregando una referencia de
     * la que ya se sabe en qué quedó, el servidor contestaría siempre con lo de la primera vez y el
     * borrador seguiría congelado sin nada que lo descongele.
     *
     * **Salvo la que esta pestaña esté mandando**, que no la suelta nadie de fuera: su referencia
     * tiene que seguir guardada mientras esa petición pueda escribir, y su propio observador la
     * vuelve a escribir en cuanto cambie.
     */
    olvidarLaOperacionDelHueco: function(hueco) {
      const prefijo = this.prefijoDeLasDudas();
      if (String(hueco).indexOf(prefijo) !== 0) return;
      const llave = String(hueco).slice(prefijo.length);
      const nuestra = this.escriturasEnDuda[llave];
      if (!nuestra || nuestra.enVuelo) return;
      this.$delete(this.escriturasEnDuda, llave);
      // Por lo mismo que en `sincronizarHueco`, y aquí al revés: si era la que gobernaba el
      // formulario, los campos se desbloquean en este turno y lo que vuelve a ellos es el borrador
      // que se apartó, no el cuerpo de una operación que ya no existe.
      this.sincronizarElCuerpoVisible();
      this.avisarDeLoQueCerroOtraPestana(nuestra);
    },
    /**
     * Lo dice **si aquí se notaba**: un control que estaba apagado y se enciende solo tiene que
     * explicar por qué (dirección, 05/10/2026).
     *
     * Y solo entonces: una operación que no bloqueaba nada ni era la del formulario de delante se
     * suelta en silencio, porque interrumpir con un aviso lo que la persona esté leyendo por algo
     * que no cambia lo que tiene delante es la otra mitad del mismo defecto.
     */
    avisarDeLoQueCerroOtraPestana: function(operacion) {
      const bloqueaba = operacion.tipo === 'PROMESA' && operacion.bloquea && !operacion.resuelta;
      const esLaDeDelante = this.promesa.abierto
        && this.promesa.idFactura === operacion.idFactura;
      if (!bloqueaba && !esLaDeDelante) return;
      this.ultimaEscritura = {
        resumen: 'En otra pestaña se ha terminado con ' + this.loQueSeEscribia(operacion.tipo)
          + ' de la factura ' + this.texto(operacion.codigoFactura) + ', así que aquí ya no queda '
          + 'nada reservado de ella. Recarga la lista para ver cómo ha quedado antes de volver a '
          + 'anotarla.',
        avisos: [],
        verHistorialDe: { id: operacion.idFactura, codigo: operacion.codigoFactura },
        mal: true
      };
    },
    /**
     * Pone al día el mapa entero con el almacén. Es lo que toca cuando el aviso no dice qué hueco
     * ha cambiado —un vaciado entero del almacén desde otra pestaña—.
     *
     * Las tres cosas, y no solo la primera: lo que hay en el almacén se incorpora, lo que ya no está
     * se suelta, y lo que esta pestaña tenga en vuelo se vuelve a escribir —el vaciado se llevó su
     * hueco y su referencia tiene que estar guardada mientras la petición pueda escribir—.
     */
    resincronizarDudas: function() {
      const self = this;
      const vivos = {};
      self.huecosGuardados().forEach(function(hueco) {
        vivos[hueco] = true;
        self.sincronizarHueco(hueco);
      });
      const dudas = self.escriturasEnDuda;
      Object.keys(dudas).forEach(function(llave) {
        const operacion = dudas[llave];
        if (!operacion) return;
        const hueco = self.huecoDeLaOperacion(operacion.tipo, operacion.idFactura, operacion.clave);
        if (!vivos[hueco]) self.olvidarLaOperacionDelHueco(hueco);
      });
      self.guardarDudas();
    },
    /** Si eso que venía del almacén es una duda y no cualquier otra cosa. */
    esUnaDudaGuardada: function(duda) {
      return !!duda && typeof duda === 'object'
        && (duda.tipo === 'PROMESA' || duda.tipo === 'GESTION')
        && typeof duda.clave === 'string' && !!duda.clave
        && typeof duda.idFactura === 'string' && !!duda.idFactura;
    },
    /**
     * Si esa duda guardada se puede tirar por vieja: **solo si ya está reconciliada**.
     *
     * Mientras no lo esté, su referencia es la que el servidor tiene reclamada y la que el
     * reintento tiene que volver a mandar; descartarla por antigua es lo que hace que la pulsación
     * siguiente genere otra clave y pueda escribir una segunda vez (hallazgo `:1945` de la ronda
     * 13). Reconciliada, en cambio, consta que la petición original ya no puede escribir —el
     * servidor la marcó— y entonces perder la referencia no duplica nada.
     *
     * **Y tampoco si estaba en vuelo**, aunque conste reconciliada: una duda contestada como «de
     * eso no hay nada» que se reintenta vuelve a tener una petición en el aire con esa misma
     * referencia, así que lo reconciliado ya no describe lo que puede pasar con ella. Mirando solo
     * `resuelta`, el reintento de una duda antigua se quedaba sin referencia a mitad de camino
     * (hallazgo `:2162` de la ronda 14). La fecha se renueva además al reintentar
     * (`reservarOperacion`), así que son dos cosas las que lo impiden y no una.
     */
    caducada: function(duda, limite) {
      return !!duda.resuelta && !duda.enVuelo && this.cuando(duda.fecha) < limite;
    },
    /** Cuándo se anotó una duda, en milisegundos. Sin fecha legible, se trata como caducada. */
    cuando: function(fecha) {
      const instante = fecha ? Date.parse(fecha) : NaN;
      return isNaN(instante) ? 0 : instante;
    },
    /** El hueco de «lo último que has hecho» de esta persona. Ver `ALMACEN_ULTIMA`. */
    huecoDeLaUltimaEscritura: function() {
      return ALMACEN_ULTIMA + '|' + this.duenoDeLasDudas();
    },
    /** Hoy, como `2026-10-15`, para no enseñar mañana lo que se hizo hoy. */
    elDiaDeHoy: function() {
      const ahora = new Date();
      const mes = ahora.getMonth() + 1;
      const dia = ahora.getDate();
      return ahora.getFullYear() + '-' + (mes < 10 ? '0' + mes : mes) + '-'
        + (dia < 10 ? '0' + dia : dia);
    },
    /**
     * Guarda —o borra— el acuse de la última escritura. Lo dispara su observador, nadie a mano.
     *
     * Si el navegador no deja escribir no se avisa de esto ni se rompe nada, igual que con las
     * dudas: la pantalla se queda como estaba antes de este arreglo, o sea con el acuse vivo
     * mientras no se recargue.
     */
    guardarLaUltimaEscritura: function() {
      const hueco = this.huecoDeLaUltimaEscritura();
      try {
        if (!this.ultimaEscritura) {
          window.sessionStorage.removeItem(hueco);
          return;
        }
        window.sessionStorage.setItem(hueco, JSON.stringify({
          usuario: this.duenoDeLasDudas(),
          dia: this.elDiaDeHoy(),
          ultima: this.ultimaEscritura
        }));
      } catch (e) {
        // A propósito: ver `guardarDudas`.
      }
    },
    /**
     * Recupera el acuse de la última escritura de esta persona **de hoy**.
     *
     * Lo que viene del almacén es un dato de fuera y se trata como tal: se descarta lo que no tenga
     * forma de acuse, lo que sea de otra cuenta —en el mismo dispositivo entra más de una persona— y
     * lo que no sea de hoy. Lo descartado se borra: no vale para nada y en esta pantalla, que se
     * llama «Mi trabajo de hoy», enseñar lo de ayer sería afirmar algo falso.
     */
    restaurarLaUltimaEscritura: function() {
      const hueco = this.huecoDeLaUltimaEscritura();
      let guardado = null;
      try {
        guardado = JSON.parse(window.sessionStorage.getItem(hueco) || 'null');
      } catch (e) {
        guardado = null;
      }
      const ultima = guardado && guardado.ultima;
      if (!guardado || guardado.usuario !== this.duenoDeLasDudas()
        || guardado.dia !== this.elDiaDeHoy() || !ultima || typeof ultima !== 'object'
        || typeof ultima.resumen !== 'string' || !ultima.resumen) {
        try {
          window.sessionStorage.removeItem(hueco);
        } catch (e) {
          // A propósito: ver `guardarDudas`.
        }
        return;
      }
      this.ultimaEscritura = {
        resumen: ultima.resumen,
        avisos: Array.isArray(ultima.avisos) ? ultima.avisos : [],
        // Solo si trae las dos cosas que el botón necesita: con media referencia, el botón de ver
        // el historial abriría el de ninguna factura.
        verHistorialDe: ultima.verHistorialDe && ultima.verHistorialDe.id
          ? { id: ultima.verHistorialDe.id, codigo: ultima.verHistorialDe.codigo || '' }
          : null,
        mal: !!ultima.mal
      };
    },
    /**
     * **Todas** las operaciones apuntadas de esa escritura en esa factura, **la que reclamó primero
     * delante**, en vuelo incluidas.
     *
     * Puede haber más de una: dos pestañas de la misma persona que pierdan cada una su respuesta
     * sobre la misma factura dejan dos operaciones, cada una con su referencia, y las dos hay que
     * conservarlas hasta que se sepa en qué quedó cada una.
     *
     * **El orden es el del `turno` de la reclamación, no el de la fecha de la petición**, y eso es
     * lo que hace que las dos pestañas elijan la misma ganadora: ver `turnoDelGrupo`. Con la fecha
     * —que se renueva en cada reintento— el orden de un grupo podía además darse la vuelta sin que
     * nadie reclamara nada, cambiando a mitad de camino con qué clave y con qué cuerpo se
     * comprometía el formulario.
     *
     * La fecha queda detrás, para las operaciones guardadas antes de que existiera el turno, y la
     * clave al final para que dos empatadas salgan siempre en el mismo orden en las dos pestañas.
     */
    operacionesDeLaFactura: function(tipo, idFactura) {
      const dudas = this.escriturasEnDuda;
      const self = this;
      const grupo = this.grupoDeLaFactura(tipo, idFactura);
      return Object.keys(dudas)
        .filter(function(llave) { return llave.indexOf(grupo) === 0 && !!dudas[llave]; })
        .map(function(llave) { return dudas[llave]; })
        .sort(function(a, b) { return self.elOrdenDeLaReclamacion(a, b); });
    },
    /**
     * Cuál de dos operaciones del MISMO grupo reclamó antes. **El único sitio que lo decide**, y por
     * eso las dos pestañas no pueden ordenar distinto.
     *
     * Manda el turno. Dos con el mismo turno es que ninguna de las dos había publicado cuando la
     * otra calculó el suyo (ver `turnoDelGrupo`), y ahí desempata la clave y **no la fecha**: la
     * fecha es la de la última petición y es justamente la que no sirve para esto.
     *
     * La fecha solo decide entre las guardadas **antes de que existiera el turno**, que llegan las
     * dos a cero: para ellas sigue valiendo lo que valía, que es lo único que se sabe de ellas.
     */
    elOrdenDeLaReclamacion: function(a, b) {
      const turno = this.turnoDe(a) - this.turnoDe(b);
      if (turno !== 0) return turno;
      if (this.turnoDe(a) === 0) {
        const cuando = this.cuando(a.fecha) - this.cuando(b.fecha);
        if (cuando !== 0) return cuando;
      }
      return String(a.clave).localeCompare(String(b.clave));
    },
    /** El turno de una operación, con `0` para las guardadas antes de que existiera. */
    turnoDe: function(operacion) {
      return Number((operacion && operacion.turno) || 0);
    },
    /**
     * Las de esa factura que son una DUDA: las que han vuelto sin desenlace conocido.
     *
     * Las que están en vuelo quedan fuera, y no es un detalle: lo que gobierna el formulario y el
     * aviso es «de esto no se sabe si quedó escrito», y de una petición que todavía no ha
     * contestado no se dice eso —ésa la cuenta `promesaEnVuelo`—. Su referencia sí está apuntada,
     * y la entrega `claveParaEscribir`, que mira el grupo entero.
     */
    dudasDeLaFactura: function(tipo, idFactura) {
      return this.operacionesDeLaFactura(tipo, idFactura)
        .filter(function(duda) { return !duda.enVuelo; });
    },
    /**
     * La operación que **gobierna el formulario** de esa factura: la más antigua que queda en el
     * mapa. **El único sitio que elige una del grupo.**
     *
     * La más antigua y no la última, porque es la que tiene reclamada la referencia más vieja: es la
     * que el reintento tiene que volver a mandar y la que puede llegar con retraso. Las demás no se
     * tocan —siguen en el mapa, con su propio control de comprobar— hasta que cada una llegue a su
     * desenlace.
     */
    dudaDe: function(tipo, idFactura) {
      return this.dudasDeLaFactura(tipo, idFactura)[0] || null;
    },
    /** Esa operación exacta tal como está en el mapa, o `null`: por su clave, no por su grupo. */
    operacionDe: function(tipo, idFactura, clave) {
      return this.escriturasEnDuda[this.llaveDeOperacion(tipo, idFactura, clave)] || null;
    },
    /**
     * Las operaciones de esa clase de escritura con **una petición en el aire ahora mismo**, la más
     * antigua primero.
     *
     * Salen del mismo mapa que las dudas porque son el mismo dato en otro momento de la misma
     * operación: `reservarOperacion` pone su `enVuelo` al salir y `liquidarReserva` lo quita cuando
     * esa referencia exacta vuelve con un desenlace.
     *
     * **Por TIPO**, y eso es lo que arregla el defecto de fondo: lo que está vivo era un campo por
     * pantalla (`promesaEnVuelo`) que `escrituraTerminada()` borraba sin saber qué operación había
     * terminado, así que la vuelta de una gestión soltaba una promesa todavía en el aire. Las dos
     * clases de escritura conviven, con su identidad y su ciclo de vida separados, y cada una sabe
     * si está viva por sus propias operaciones (decisión técnica del 15/10/2026).
     */
    operacionesEnVuelo: function(tipo) {
      const dudas = this.escriturasEnDuda;
      const self = this;
      return Object.keys(dudas)
        .map(function(llave) { return dudas[llave]; })
        .filter(function(op) { return !!op && op.tipo === tipo && !!op.enVuelo; })
        .sort(function(a, b) {
          const cuando = self.cuando(a.fecha) - self.cuando(b.fecha);
          return cuando !== 0 ? cuando : String(a.clave).localeCompare(String(b.clave));
        });
    },
    /**
     * La anotación de **esa factura** que está en el aire, o `null`.
     *
     * Por factura y no «hay algo guardándose»: mientras se manda la promesa de una se puede abrir el
     * formulario de otra, y ése sí se puede rellenar (ronda 12, hallazgo `:471`).
     */
    promesaEnVueloDe: function(idFactura) {
      if (!idFactura) return null;
      return this.operacionesEnVuelo('PROMESA').filter(function(op) {
        return op.idFactura === idFactura;
      })[0] || null;
    },
    /**
     * La operación de esa factura cuyo **cuerpo y clave ya están comprometidos**, o `null`: la más
     * antigua del grupo, esté en vuelo o en duda. **El único sitio que elige una.**
     *
     * Lo que hace que sirva es que es **una sola pregunta** para las tres cosas que tienen que
     * coincidir: con qué referencia sale el reintento (`claveParaEscribir`), qué cuerpo viaja con
     * ella (`cuerpoComprometidoDe`) y si el borrador se puede tocar (`promesaInmovil`). Si la clave
     * la eligiera una operación y el cuerpo otra, podría salir un POST con una clave ya usada y un
     * cuerpo distinto, que es justamente lo que el servidor no puede detectar: contesta con lo que
     * guardó la primera vez.
     */
    operacionComprometidaDe: function(tipo, idFactura) {
      if (!idFactura) return null;
      return this.operacionesDeLaFactura(tipo, idFactura)[0] || null;
    },
    /**
     * Quita **esa operación** de la lista de dudas: **el único sitio que la borra**.
     *
     * Por su clave exacta, que es lo que la hace una y no «la de esa factura»: resolver una no puede
     * llevarse por delante la de otra pestaña sobre la misma factura y del mismo tipo (hallazgo
     * `:1702` de la ronda 12). Borrar una llave que no está no hace nada, y eso es lo que pasa
     * cuando una escritura termina bien a la primera: no había ninguna duda que quitar.
     *
     * Está en un método propio y no en un `$delete` suelto porque los dos caminos de éxito tenían
     * que acordarse de hacerlo y uno no se acordaba: el de la gestión no la borraba, así que
     * `claveParaCrearGestion` seguía devolviendo esa misma clave para cualquier gestión posterior de
     * esa factura y el servidor contestaba con la gestión anterior mientras la pantalla anunciaba
     * una nueva (revisión CODEX, ronda 9, hallazgo `:1080`). Con un solo sitio, el camino que se
     * añada mañana no puede olvidarlo de otra manera.
     *
     * Y **no toca nada más**: el bloqueo del botón y la congelación del borrador se derivan del
     * mapa, así que quitar esta operación no puede desbloquear otra que siga viva. Aquí es donde
     * entraba el defecto: resolver una operación llamaba además a un `escrituraTerminada()` que
     * borraba «la promesa en vuelo», fuera cual fuera (decisión técnica del 15/10/2026).
     */
    resolverOperacion: function(tipo, idFactura, clave) {
      this.$delete(this.escriturasEnDuda, this.llaveDeOperacion(tipo, idFactura, clave));
    },
    /**
     * Con qué referencia **saldría** una escritura de esa factura: la de la operación ya apuntada
     * si la hay, y una nueva si no.
     *
     * Reutilizarla es lo que hace seguro el reintento: la clave está reclamada en el servidor, así
     * que la segunda petición —o la primera, si llegara con retraso— no escribe otra promesa. Con
     * una clave nueva en cada pulsación el reintento de una respuesta perdida sí podría duplicarla.
     *
     * Sale de `operacionComprometidaDe`, que mira el grupo ENTERO y no solo las dudas —una
     * operación en vuelo también tiene su referencia reclamada— y es **la misma** de la que sale el
     * cuerpo (`cuerpoComprometidoDe`): así la clave y el cuerpo que viajan juntos son siempre de la
     * misma operación.
     *
     * **Pero esto no reclama nada, así que no es por aquí por donde sale una escritura**: contesta
     * con lo que esta pestaña tiene en memoria, y lo que manda es el grupo reclamado en el almacén,
     * que es lo que ven las dos pestañas. Quien escribe pasa por `reservarOperacion`, el único
     * sitio que reclama y el que entrega la clave y el cuerpo juntos; esto se queda como la
     * pregunta que hacen la pantalla y las pruebas —«¿con qué referencia iría?»—, y de ahí no puede
     * salir un POST.
     */
    claveParaEscribir: function(tipo, idFactura) {
      return (this.operacionComprometidaDe(tipo, idFactura) || {}).clave
        || FactCobro.claveDeOperacion();
    },
    /** Con qué referencia sale una anotación. Ver `claveParaEscribir`. */
    claveParaAnotar: function(idFactura) {
      return this.claveParaEscribir('PROMESA', idFactura);
    },
    /** La misma idea para la gestión: el reintento de la misma pulsación lleva su clave. */
    claveParaCrearGestion: function(idFactura) {
      return this.claveParaEscribir('GESTION', idFactura);
    },
    /**
     * Apunta la operación que va a salir y devuelve su reserva: **el único sitio por el que una
     * escritura obtiene su referencia**.
     *
     * Por aquí pasan las dos escrituras de la pantalla, y lo hacen ANTES del POST a propósito: la
     * referencia tiene que estar guardada durante todo el rato en el que la escritura puede haber
     * ocurrido sin que nadie lo sepa. Apuntándola solo al perder la respuesta —como se hacía—
     * quedaba fuera justo ese rato: con el POST en el aire, una recarga o un cierre de pestaña se
     * llevaba la clave, la pulsación siguiente generaba otra y se podía guardar una segunda promesa
     * o crear una segunda T0045 de la misma llamada. Es la misma familia que el hallazgo `:1945`
     * (no tirar por viejas las referencias cuyo desenlace no se conoce): la referencia tiene que
     * estar viva mientras pueda escribirse, y ahora eso lo garantiza un solo sitio en vez de cada
     * camino (revisión CODEX, ronda 14, hallazgo `:2162`).
     *
     * **Un reintento no crea otra: renueva la que había.** Vuelve a salir una petición con esa
     * referencia, así que la operación vuelve a estar en vuelo y su fecha se pone a ahora —si no,
     * una duda vieja ya contestada como «de eso no hay nada» se reintentaba conservando su fecha
     * original y la higiene de `restaurarDudas` la tiraba a mitad del reintento, perdiendo otra vez
     * la referencia—. Lo que NO se toca es su cuerpo: el reintento manda el que se comprometió, que
     * es la decisión de la ronda 10.
     *
     * La reserva que devuelve es lo que hace falta para soltarla si la petición vuelve con un
     * desenlace claro: ver `liquidarReserva`. Y lleva **el cuerpo** con el que sale esa referencia,
     * que puede no ser el que traía quien llama: si la referencia es de una operación ya
     * comprometida, el cuerpo que viaja es el de ella. Los dos salen de aquí porque tienen que ser
     * de la misma operación —ver `operacionComprometidaDe`—, y quien llama manda `reserva.cuerpo`.
     *
     * ## Y el grupo `tipo|factura` se reclama DE FORMA COMPARTIDA, no solo en esta pestaña
     *
     * Dos pestañas que empiecen la misma escritura antes de recibir el aviso `storage` de la otra
     * llegaban las dos sin operación previa, generaban dos referencias distintas y escribían dos
     * promesas —o dos T0045— de la misma llamada: la idempotencia del servidor agrupa por
     * referencia, así que dos referencias son dos escrituras legítimas para él (revisión CODEX,
     * ronda 1 de esta vuelta, hallazgo `:2924`). Escuchar el almacén (ronda 16) cerraba el caso de
     * la pestaña que ya se había enterado, no el de las dos a la vez, y encima la reserva se
     * publicaba en el observador de `escriturasEnDuda`, o sea **después** de este turno.
     *
     * Lo que lo cierra es reclamar el grupo donde las dos pestañas miran, con el único orden que
     * las dos calculan igual, y en este orden:
     *
     *  1. **se lee el grupo del almacén** antes de decidir, en este mismo turno y sin esperar
     *     ningún aviso: lo que otra pestaña haya reclamado ya es la referencia de esta escritura;
     *  2. **se publica la reclamación en el acto** (`guardarDudas`), no cuando despierte el
     *     observador: entre el `$set` y esa escritura cabía la reclamación de la otra pestaña;
     *  3. **se vuelve a leer el grupo** y, si la que manda es otra, esta pestaña **suelta la suya
     *     y se suma a aquélla**. Soltarla no pierde nada: todavía no ha salido ningún POST con
     *     ella, así que de esa referencia no puede haber nada escrito.
     *
     * El paso 3 es lo que hace que esto no sea solo una ventana más estrecha: cada pestaña escribe
     * antes de leer, así que **no puede pasar que las dos lecturas se pierdan la reclamación de la
     * otra** —si la A no ve a la B es porque leyó antes de que la B escribiera, y entonces la B,
     * que escribió antes de leer, sí ve a la A—. Y quién manda lo decide una sola función con el
     * mismo criterio para las dos (`operacionComprometidaDe`).
     *
     * **Pero ese argumento solo vale si las dos ordenan igual**, y con la fecha de la petición no
     * ordenaban igual: la fecha se pone al CREAR la operación y la reclamación se publica después,
     * así que la que publicó segunda podía llevar la fecha más antigua, creerse la que manda y
     * mandar también —sin ninguna necesidad de que las dos cayeran en el mismo milisegundo, que es
     * lo que esta explicación afirmaba— (revisión CODEX, ronda 2 de esta vuelta, hallazgo `:2973`).
     * Lo que ordena ahora es el **turno de la reclamación**, calculado leyendo el almacén justo al
     * reclamar: quien reclama con algo ya publicado delante saca un turno mayor y cede. El criterio,
     * el resto que queda y lo que haría falta para cerrarlo del todo —un mecanismo atómico o
     * serializar en el servidor— están en `turnoDelGrupo`, que es donde se decide.
     *
     * ## Y una referencia NUEVA no sale si no consta en el almacén
     *
     * Todo lo de arriba se apoya en que publicar la reclamación funciona, y eso no se puede dar por
     * hecho: con la cuota llena, el almacenamiento desactivado o el navegador en una ventana que no
     * lo permite, el `setItem` falla —o acepta y no conserva nada— y aquí no se notaba, así que el
     * POST salía igual anunciando una reserva que no existía. Con la petición en el aire, una
     * recarga o un cierre de pestaña se llevaba la clave, la pulsación siguiente generaba otra y se
     * podía crear una segunda T0045 o guardar una segunda promesa de la misma llamada; y entre dos
     * pestañas no había ninguna serialización, porque las dos reclamaban en un almacén que no
     * guardaba (revisión CODEX, ronda 4 de esta vuelta, hallazgo `:2332`).
     *
     * La prueba de que una reserva consta es **releerla** (`reservaConsta`), no que el `setItem` no
     * haya lanzado. Y si no consta, **no se escribe**: la reserva se suelta —de ella no ha salido
     * nada— y se devuelve `sinConstancia`, que es lo que los dos llamantes convierten en el mensaje
     * de `porqueNoConstaLaReserva`. Negarse es lo correcto y no una cautela: la referencia es lo
     * único que impide duplicar, así que sin ella la escritura no tiene red.
     *
     * **El reintento sí sale**, y es la única excepción: su referencia ya está reclamada en el
     * servidor, que agrupa por ella, así que volver a mandarla no puede duplicar nada —es lo que
     * resuelve la duda— y negárselo dejaría la anotación en el aire sin ninguna ganancia. Lo que se
     * niega es el **nacimiento** de una referencia nueva sin constancia.
     */
    reservarOperacion: function(tipo, idFactura, codigoFactura, cuerpo) {
      // 1 · lo que otra pestaña ya tenga reclamado de este grupo manda sobre lo que haya aquí.
      this.incorporarElGrupoDelAlmacen(tipo, idFactura);
      const previa = this.operacionComprometidaDe(tipo, idFactura);
      if (previa) {
        return this.retomarLaOperacion(tipo, idFactura, previa);
      }
      const clave = FactCobro.claveDeOperacion();
      this.$set(this.escriturasEnDuda, this.llaveDeOperacion(tipo, idFactura, clave),
        this.operacionApuntada(tipo, clave, idFactura, codigoFactura, cuerpo, true));
      // 2 · publicada ya, por el único sitio que escribe el almacén.
      this.guardarDudas();
      // 2 bis · y publicada DE VERDAD: releída del almacén. Sin eso, los pasos 1 y 3 preguntan a
      // un sitio que no guarda nada y el POST sale sin la única referencia que lo protege.
      if (!this.reservaConsta(tipo, idFactura, clave)) {
        this.soltarLaReservaSinEnviar(tipo, idFactura, clave);
        return { tipo: tipo, idFactura: idFactura, sinConstancia: true };
      }
      // 3 · y si en el mismo instante la reclamó otra pestaña, manda una sola y es la misma para
      // las dos.
      this.incorporarElGrupoDelAlmacen(tipo, idFactura);
      const manda = this.operacionComprometidaDe(tipo, idFactura);
      if (manda && manda.clave !== clave) {
        this.soltarLaReservaSinEnviar(tipo, idFactura, clave);
        return this.retomarLaOperacion(tipo, idFactura, manda);
      }
      return {
        tipo: tipo,
        idFactura: idFactura,
        clave: clave,
        cuerpo: cuerpo,
        nueva: true,
        resueltaAntes: false,
        bloqueabaAntes: false
      };
    },
    /**
     * Esta pestaña sale con una operación que **ya estaba reclamada**: la suya de antes —el
     * reintento— o la que acaba de reclamar otra pestaña. Las dos cosas son lo mismo visto desde
     * aquí, y por eso es un solo sitio.
     *
     * Vuelve a estar en vuelo y su fecha se pone a ahora —si no, una duda vieja ya contestada como
     * «de eso no hay nada» se reintentaba conservando su fecha original y la higiene de
     * `restaurarDudas` la tiraba a mitad del reintento, perdiendo otra vez la referencia—. Lo que
     * NO se toca es su cuerpo: lo que sale es el que se comprometió (decisión de la ronda 10), y
     * por eso la reserva lo devuelve.
     */
    retomarLaOperacion: function(tipo, idFactura, operacion) {
      operacion.enVuelo = true;
      operacion.fecha = new Date().toISOString();
      // Y a partir de ahora es de ESTA pestaña, venga de donde venga: el reintento sale de aquí,
      // así que su respuesta —o su corte— se ve aquí.
      operacion.deOtraPestana = false;
      // En el acto, por lo mismo que en `reservarOperacion`: lo que las demás pestañas tienen que
      // ver es que esta referencia está viva otra vez, no cuando despierte el observador.
      this.guardarDudas();
      return {
        tipo: tipo,
        idFactura: idFactura,
        clave: operacion.clave,
        cuerpo: operacion.cuerpo || null,
        nueva: false,
        resueltaAntes: !!operacion.resuelta,
        bloqueabaAntes: !!operacion.bloquea
      };
    },
    /**
     * Suelta una reserva **de la que no ha salido ninguna petición**: la que esta pestaña acaba de
     * reclamar y cede porque el grupo ya era de otra.
     *
     * No es lo mismo que `liquidarReserva` y no puede pasar por ella: aquélla decide qué queda
     * guardado de una referencia **con la que se escribió**, y aquí no se ha mandado nada, así que
     * de ésta no hay nada que saber ni que reintentar. Lo que sí hace falta es que no quede su
     * hueco: una referencia apuntada que nadie va a mandar bloquearía el botón y congelaría el
     * borrador hasta que una reconciliación averiguara lo que ya se sabe.
     */
    soltarLaReservaSinEnviar: function(tipo, idFactura, clave) {
      this.$delete(this.escriturasEnDuda, this.llaveDeOperacion(tipo, idFactura, clave));
      this.guardarDudas();
    },
    /**
     * Si esa reserva **consta en el almacén**, que es la única prueba de que existe fuera de esta
     * pestaña: el hueco se vuelve a leer y dice esa misma clave.
     *
     * Se relee en vez de fiarse de que el `setItem` no haya lanzado porque lanzar no es la única
     * forma de no guardar: hay navegadores que lo aceptan y no conservan nada, y el modo privado de
     * algunos da un almacén que se vacía solo. Y se comprueba con las mismas dos preguntas con las
     * que se lee en cualquier otro sitio —que el hueco sea de esta persona y que lo guardado tenga
     * forma de duda—, porque una reserva que `restaurarDudas` no sabría leer no protege nada: lo
     * que hace falta no es que haya algo escrito, es que esta referencia **se recupere** si la
     * pestaña se va con la petición en el aire.
     *
     * Y se exige además que **el listado la encuentre** (`huecosGuardados`), que es el otro camino
     * por el que se llega a un hueco y el que usan las dos lecturas del grupo
     * (`incorporarElGrupoDelAlmacen`, `turnoDelGrupo`). Es la misma forma del fallo por el otro
     * lado: con el recorrido del almacén roto, esas dos lecturas no ven nada y cada pestaña se cree
     * la única, aunque leer un hueco por su nombre siga funcionando. Si el listado no encuentra ni
     * la nuestra, no va a encontrar la de la otra pestaña.
     */
    reservaConsta: function(tipo, idFactura, clave) {
      const hueco = this.huecoDeLaOperacion(tipo, idFactura, clave);
      const guardado = this.leerHueco(hueco);
      const duda = guardado && guardado.duda;
      return this.esDeEstaPersona(guardado) && this.esUnaDudaGuardada(duda)
        && duda.clave === clave
        && this.huecosGuardados().indexOf(hueco) >= 0;
    },
    /**
     * Qué se le dice a quien pulsa cuando la reserva no ha podido quedar guardada.
     *
     * Las tres cosas del criterio de pantalla de dirección (05/10/2026): POR QUÉ no se puede
     * escribir, QUIÉN lo desbloquea y DÓNDE. No se dice «ha fallado algo»: lo que ha pasado es que
     * el navegador de esta persona no está guardando los datos de la pantalla, y eso lo arregla
     * ella en un minuto si se le dice dónde mirar.
     */
    porqueNoConstaLaReserva: function(tipo) {
      return 'No se ha guardado ' + this.loQueSeEscribia(tipo) + ', y no se ha intentado a '
        + 'propósito: este navegador no está conservando los datos de esta pantalla —almacenamiento '
        + 'lleno, desactivado, o una ventana de navegación privada—, y sin eso una recarga a mitad '
        + 'de la operación puede acabar duplicándola. Lo desbloqueas tú: sal de la navegación '
        + 'privada, o permite el almacenamiento de este sitio y borra datos de navegación para '
        + 'hacer sitio, y vuelve a pulsar. Si con eso sigue igual, avisa a Sistemas.';
    },
    /**
     * Incorpora lo que el almacén tenga de **ese grupo** `tipo|factura`, en este mismo turno.
     *
     * Es `sincronizarHueco` —el único sitio que traduce lo guardado a memoria— aplicado a los
     * huecos del grupo, en vez de esperar al aviso `storage`, que llega cuando llega. Se usa al
     * reclamar: ahí es donde no saberlo todavía se paga con una escritura duplicada.
     *
     * Y solo del grupo, no del almacén entero: lo que importe de otra factura ya lo trae su aviso,
     * y recorrerlo todo en cada pulsación es trabajo que no cambia nada de esta decisión.
     *
     * **Antes de leer, esta pestaña pone al día lo suyo** (`guardarDudas`), y no es un detalle: el
     * almacén lo escribe el observador del mapa, que despierta un turno después, así que entre
     * resolver una operación y que su hueco desaparezca hay un rato en el que el almacén dice que
     * esa referencia sigue reclamada. Leyendo sin eso, una anotación que acabara de resolverse en
     * este mismo turno se resucitaría desde su propio hueco y la pulsación siguiente saldría con
     * una clave ya consumida. Va aquí, en el único sitio que lee el grupo para decidir, en vez de
     * repartido por cada camino que toca el mapa —que es la razón por la que guardar vive en un
     * observador y no en cinco llamadas—.
     */
    incorporarElGrupoDelAlmacen: function(tipo, idFactura) {
      const self = this;
      this.guardarDudas();
      const prefijo = this.prefijoDeLasDudas() + this.grupoDeLaFactura(tipo, idFactura);
      this.huecosGuardados().forEach(function(hueco) {
        if (hueco.indexOf(prefijo) !== 0) return;
        self.sincronizarHueco(hueco);
      });
    },
    /**
     * Suelta la reserva cuando la petición ha vuelto con un desenlace claro —guardada, o rechazada
     * por el servidor con una respuesta de verdad—: **el único sitio que la deshace**.
     *
     * Una respuesta del servidor dice qué pasó con ESA referencia, así que ya no hay nada que
     * guardar de ella: si la apuntó esta reserva, se quita; si ya estaba apuntada de antes —un
     * reintento sobre una duda que sigue abierta— se queda **tal como estaba**, porque lo que no se
     * sabía de ella sigue sin saberse.
     *
     * **Y la que ya estaba RECONCILIADA se suelta también.** Es la otra mitad de lo mismo: de una
     * operación que el servidor ya contestó como «de eso no hay nada» no queda nada por saber, así
     * que cuando su reintento vuelve con un desenlace claro —guardada, o rechazada de verdad— su
     * referencia no protege ya ninguna escritura y conservarla deja la pantalla atascada: el botón
     * se enciende porque no hay duda que bloquee, pero el borrador sigue congelado y el reintento
     * sigue saliendo con esa misma clave y ese mismo cuerpo rechazado, pulsación tras pulsación y
     * también después de recargar, sin que la persona pueda corregir los datos (revisión CODEX,
     * ronda 15, hallazgo `:2540`). Soltándola, la anotación siguiente sale con una referencia nueva,
     * que es lo correcto: de la anterior consta que no escribió nada.
     *
     * Si lo que se perdió fue la respuesta del reintento, esto no decide nada: `anotarEnDuda` la
     * vuelve a apuntar con **su misma clave** justo después, y vuelve a ser una duda sin resolver.
     *
     * No hace nada si otro camino la ha liquidado ya: terminar bien la quita (`resolverOperacion`) y
     * perder la respuesta la convierte en duda (`anotarEnDuda`), y los dos pueden correr antes que
     * esto según el orden de los manejadores del carril.
     */
    liquidarReserva: function(reserva) {
      if (!reserva) return;
      const operacion = this.operacionDe(reserva.tipo, reserva.idFactura, reserva.clave);
      if (!operacion || !operacion.enVuelo) return;
      if (reserva.nueva || reserva.resueltaAntes) {
        this.resolverOperacion(reserva.tipo, reserva.idFactura, reserva.clave);
        return;
      }
      operacion.enVuelo = false;
      operacion.resuelta = reserva.resueltaAntes;
      operacion.bloquea = reserva.bloqueabaAntes;
    },
    /**
     * Deja la escritura **en duda** si su respuesta se perdió, y dice si lo ha hecho.
     *
     * Un POST que acaba con timeout de pasarela o con la conexión cortada (`respuestaPerdida`, la
     * marca que pone `DatabaseModel.sendRequest` —aquí no se vuelven a enumerar los estados HTTP—)
     * no dice que la escritura haya fallado: **dice que no se sabe**.
     *
     * Lo que se guarda de ella es **su clave**, la que se mandó con la escritura, y no una foto de
     * la ficha. Esa es la diferencia que cierra la familia de las rondas 7 y 8: con la foto, la
     * misma lectura se quedaba bloqueada para siempre si la petición no llegó a salir y daba por
     * buena la propia escritura cuando lo que había cambiado era la de otra sesión. Con la clave la
     * pregunta es «¿se hizo ESTO?», y la contesta el servidor (`reconciliarEscrituraEnDuda`).
     *
     * El botón se bloquea **solo cuando hace falta**: en la promesa sí, hasta saber en qué quedó;
     * en la gestión no, porque el reintento lleva la misma clave y no puede crear dos. Mientras
     * está bloqueado, el aviso dice las tres cosas que pide la regla de pantalla de dirección
     * —qué pasa, quién lo desbloquea y dónde— y el «dónde» es un botón de verdad, al lado.
     */
    anotarEnDuda: function(e, tipo, clave, idFactura, codigoFactura, cuerpo) {
      if (!e || !e.respuestaPerdida) return false;
      // Una por OPERACIÓN, y **las otras se quedan**: con una sola ranura la segunda borraba a la
      // primera y la primera se quedaba sin nadie que la reconciliara (ronda 9, `:1440`); con la
      // ranura por `tipo|idFactura` se las pisaban igual en cuanto las dos eran de la misma factura,
      // que es lo que pasa con dos pestañas abiertas (ronda 12, `:1702`).
      //
      // Y la operación se queda **en el mapa y fuera de vuelo**, que es lo que mantiene el botón
      // apagado sin que nadie lo apague: el bloqueo se deriva de aquí (`guardandoPromesa`), no se
      // asigna al terminar cada escritura.
      this.$set(this.escriturasEnDuda, this.llaveDeOperacion(tipo, idFactura, clave),
        this.operacionApuntada(tipo, clave, idFactura, codigoFactura, cuerpo, false));
      this.ultimaEscritura = {
        resumen: 'No se sabe si ' + this.loQueSeEscribia(tipo) + ' de la factura '
          + this.texto(codigoFactura) + ' ha quedado guardada: la petición se cortó sin respuesta y '
          + 'el servidor puede haberla escrito. Se está comprobando en el servidor por la '
          + 'referencia con la que se mandó.',
        avisos: [],
        mal: true
      };
      return true;
    },
    /**
     * La forma de una operación apuntada: **un solo sitio la escribe**, la reserva y la duda.
     *
     * Son el mismo dato en dos momentos de la misma operación —en vuelo y sin desenlace conocido—,
     * así que un campo que se añada aquí no puede faltarle a una de las dos: ésa es la juntura por
     * la que se cuela que `restaurarDudas` no sepa leer lo que `reservarOperacion` guardó.
     */
    operacionApuntada: function(tipo, clave, idFactura, codigoFactura, cuerpo, enVuelo) {
      return {
        // Ésta la manda esta pestaña, así que su aviso sí puede decir que la petición se cortó.
        deOtraPestana: false,
        tipo: tipo,
        clave: clave,
        // En qué lugar reclamó esta operación su grupo. Lo primero que se calcula, porque se lee del
        // almacén y hay que leerlo lo más tarde posible: ver `turnoDelGrupo`.
        turno: this.turnoDelGrupo(tipo, idFactura, clave),
        idFactura: idFactura,
        codigoFactura: codigoFactura || '',
        // El cuerpo que se mandó, para que el reintento mande **ese** y no el del formulario de
        // después: con la misma referencia, el servidor contesta con lo que quedó escrito, así que
        // mandar otros datos con ella hacía que la pantalla anunciara algo distinto de lo guardado
        // (ronda 10). La gestión no manda cuerpo: su petición es la factura y nada más.
        cuerpo: cuerpo || null,
        // Cuándo salió la petición que lleva esta referencia, y se renueva en cada reintento: lo
        // necesita `restaurarDudas` para no resucitar la de hace tres semanas que ya está
        // reconciliada, y para no tirar la que acaba de volver a salir.
        fecha: new Date().toISOString(),
        // Si hay una petición con esta referencia en el aire. Mientras lo haya no es una duda —no
        // se pregunta ni se pinta—, pero su referencia ya está guardada por si la pestaña se va.
        enVuelo: !!enVuelo,
        bloquea: tipo === 'PROMESA',
        resuelta: false,
        comprobando: false,
        // Si lo único que se puede hacer es mirar el historial de esa factura. Lo dice el servidor
        // cuando no ha podido comprobarlo o cuando ha encontrado más de una gestión que podía ser
        // ésta (decisión de dirección del 10/10/2026).
        revisaElHistorial: false
      };
    },
    /**
     * **En qué lugar reclamó su grupo esta operación**: el turno que ya tenía si es una que vuelve a
     * salir, y uno nuevo —el siguiente del grupo, contando lo que hay en el almacén— si es la
     * primera vez.
     *
     * ## Por qué un turno y no la fecha
     *
     * Es lo que decide quién manda cuando dos pestañas reclaman la misma escritura
     * (`operacionComprometidaDe` → `operacionesDeLaFactura`), y con la fecha de la petición esa
     * decisión no era de fiar: la fecha se pone **al crear** la operación y la reclamación se publica
     * un poco después, así que las dos pestañas podían ordenar distinto. La B crea su clave, A crea
     * la suya un instante más tarde, la publica, relee el grupo —todavía sin la de la B—, se cree la
     * única y manda; cuando la B publica, su fecha es la más antigua de las dos, así que se cree ella
     * la que manda y manda también: dos referencias y dos promesas de la misma llamada. **No hacía
     * falta que cayeran en el mismo milisegundo**, que es lo que este comentario afirmaba (revisión
     * CODEX, ronda 2 de esta vuelta, hallazgo `:2973`).
     *
     * El turno se calcula **leyendo el almacén en el momento de reclamar**, que es lo que lo arregla:
     * si cuando esta pestaña reclama ya hay una reclamación publicada de ese grupo, el turno que sale
     * es MAYOR, y entonces esta pestaña cede en el paso 3 de `reservarOperacion`. Y no depende de la
     * resolución del reloj, que es de lo que dependía la fecha.
     *
     * ## Lo que queda, dicho
     *
     * Dos pestañas pueden empatar a turno: solo si **ninguna de las dos había publicado todavía**
     * cuando la otra calculó el suyo. Entonces las dos ven el empate, lo desempatan por la clave
     * menor —el mismo criterio en las dos— y **las dos salen con la misma referencia**, así que el
     * servidor agrupa las dos peticiones y queda una sola promesa. El único resto es que la que
     * pierde el desempate haya releído el grupo antes de que la otra publicara: ahí salen dos
     * referencias. Para que ocurra hacen falta las dos pulsaciones intercaladas instrucción a
     * instrucción, en ese orden exacto.
     *
     * Cerrar también ese resto no se puede desde aquí: `localStorage` no tiene escritura condicional.
     * Pide **un mecanismo atómico o serializar en el servidor** —un candado por tipo y factura al
     * lado del acuse de `FactCobroOperaciones`, o la reclamación dentro de `navigator.locks`, que
     * obliga a que reclamar deje de ser síncrono y a poner un freno propio para las dos pulsaciones
     * seguidas de la misma pestaña—. Las dos son decisiones de diseño con su coste y su propia
     * comprobación, no un cambio de ronda de revisión: queda propuesto como tarea aparte en la #190.
     */
    turnoDelGrupo: function(tipo, idFactura, clave) {
      const yaApuntada = this.operacionDe(tipo, idFactura, clave);
      if (yaApuntada && this.turnoDe(yaApuntada) > 0) {
        return this.turnoDe(yaApuntada);
      }
      const self = this;
      let mayor = 0;
      this.operacionesDeLaFactura(tipo, idFactura).forEach(function(operacion) {
        mayor = Math.max(mayor, self.turnoDe(operacion));
      });
      // Y además lo que haya en el ALMACÉN de este grupo, que es lo que otra pestaña puede haber
      // reclamado sin que esta se haya enterado: es por esto por lo que el turno sirve de algo.
      const prefijo = this.prefijoDeLasDudas() + this.grupoDeLaFactura(tipo, idFactura);
      this.huecosGuardados().forEach(function(hueco) {
        if (hueco.indexOf(prefijo) !== 0) return;
        const guardado = self.leerHueco(hueco);
        const duda = guardado && guardado.duda;
        if (!self.esDeEstaPersona(guardado) || !self.esUnaDudaGuardada(duda)) return;
        mayor = Math.max(mayor, self.turnoDe(duda));
      });
      return mayor + 1;
    },
    /** Cómo se nombra lo que se estaba escribiendo, para no escribir dos frases por desenlace. */
    loQueSeEscribia: function(tipo) {
      return tipo === 'GESTION' ? 'la gestión de cobro' : 'la promesa';
    },
    /**
     * Pregunta por **todas** las escrituras que han quedado en duda, no solo por la última.
     *
     * Cuelga de la LECTURA, así que la hacen por igual la carga de la pantalla, el botón de recargar
     * y el selector de gestor. Y recorre el mapa entero porque si no, una duda que se quedara atrás
     * no se resolvería nunca: su clave seguiría ahí, el reintento generaría otra y podría duplicar
     * (revisión CODEX, ronda 9, hallazgo `:1440`).
     */
    reconciliarLasDudas: function() {
      const self = this;
      self.dudasPendientes.forEach(function(duda) { self.reconciliarEscrituraEnDuda(duda); });
    },
    /**
     * Si la operación que está en el mapa sigue siendo **ESA** y no otra del mismo grupo.
     *
     * Se compara el objeto y no la llave: un reintento sobre una duda la sustituye por otra
     * operación apuntada con la misma clave (`anotarEnDuda`), y la respuesta de la consulta anterior
     * no habla de esa segunda.
     */
    sigueSiendoLaMismaOperacion: function(operacion) {
      return this.operacionDe(operacion.tipo, operacion.idFactura, operacion.clave) === operacion;
    },
    /**
     * Resuelve **una** escritura en duda **preguntando por ella**, no mirando si algo ha cambiado.
     *
     * Cuatro desenlaces, los cuatro del servidor y ninguno por omisión (ver
     * `FactCobro.operacionTrabajoHoy`):
     *
     *  1. `HECHA` → se escribió: se dice, se desbloquea y la duda **se quita**;
     *  2. `NO_ESTA` → no se escribió: se desbloquea y se dice que se puede volver a anotar, porque
     *     el reintento lleva **la misma referencia** y no puede guardar dos;
     *  3. `EN_CURSO` → está dentro todavía: se queda como está y se vuelve a comprobar;
     *  4. `NO_SE_SABE` → no se ha podido comprobar: no se desbloquea nada y se ofrece lo único que
     *     esta persona sí puede hacer, que es mirar el historial de esa factura.
     *
     * Y si la comprobación misma falla, no se inventa ninguno de los cuatro: se dice que no se ha
     * podido comprobar y se deja el control para volver a intentarlo.
     *
     * @param {Object} [duda] la duda por la que se pregunta. Sin ella, la que bloquea el botón de
     *        anotar, que es desde donde pulsa la persona que tiene el formulario delante.
     */
    reconciliarEscrituraEnDuda: function(duda) {
      const self = this;
      const esta = duda || self.dudaPromesaPendiente;
      // Ni de una que está en vuelo: de ella no hay nada que preguntar todavía —su petición no ha
      // contestado— y la respuesta llegaría justo a tiempo de cerrar algo que está ocurriendo.
      if (!esta || esta.resuelta || esta.comprobando || esta.enVuelo) return;
      esta.comprobando = true;
      FactCobro.operacionTrabajoHoy(esta.clave).then(function(respuesta) {
        // La respuesta solo escribe sobre SU operación, y solo si sigue siendo la que está en el
        // mapa: se busca por su clave exacta —no por «la duda de esa factura»—, porque con dos
        // operaciones del mismo tipo sobre la misma factura la respuesta de una caería sobre la
        // otra.
        if (!self.sigueSiendoLaMismaOperacion(esta)) return;
        esta.comprobando = false;
        // Y SU DESENLACE NO SE APLICA SI ESA REFERENCIA VOLVIÓ A SALIR. Entre que se preguntó y que
        // se contesta, la persona puede haber reintentado —en la gestión el botón no se bloquea— y
        // entonces hay un POST en el aire con esta misma clave: un `HECHA` borraría la operación y
        // con ella la única referencia con la que ese POST no duplica. Esto es lo que se contesta de
        // una operación que ya ha terminado, no de una viva (decisión técnica del 15/10/2026).
        if (esta.enVuelo) return;
        self.aplicarDesenlace(esta, respuesta);
      }, function(e) {
        if (!self.sigueSiendoLaMismaOperacion(esta)) return;
        esta.comprobando = false;
        if (esta.enVuelo) return;
        self.ultimaEscritura = {
          resumen: 'No se ha podido comprobar si ' + self.loQueSeEscribia(esta.tipo)
            + ' de la factura ' + self.texto(esta.codigoFactura) + ' quedó guardada: '
            + self.textoDelFallo(e, 'el servidor no ha contestado')
            + '. Vuelve a pulsar «Comprobar si se guardó» en el aviso de arriba, o mira el '
            + 'historial de esa factura.',
          avisos: [],
          // El control de verdad, al lado del aviso: la instrucción sola es lo que el hallazgo
          // `:1496` señalaba —mandaba pulsar un botón que en una gestión no se dibujaba—.
          verHistorialDe: { id: esta.idFactura, codigo: esta.codigoFactura },
          mal: true
        };
      });
    },
    /**
     * La persona ha mirado el historial de esa factura y no está: se suelta esa duda.
     *
     * **Lo decide ella y no la pantalla**, y por eso existe este control en vez de un plazo o un
     * descarte automático: mientras la duda esté puesta, la referencia sigue reservada en el
     * servidor —que es lo que impide que esa anotación se escriba dos veces— y volver a pulsar en
     * esa factura contesta «se está escribiendo ahora mismo» sin escribir nada. Es el caso en el
     * que el servidor **no puede** cerrar el asunto: la T0045 no lleva la referencia dentro
     * (D-COB-3), así que una gestión que no se reconozca no demuestra que no se escribiera
     * (API#2050, ronda 10). Quien sí puede decidirlo es quien ha visto el historial.
     *
     * Soltarla no borra nada: la anotación siguiente sale con una referencia nueva y, si la de
     * antes llegara a aparecer, se ve en el historial de la factura. Eso es exactamente el resto
     * que dirección aceptó el 10/10/2026 con la condición de decirlo, y aquí se dice.
     */
    descartarDudaTrasElHistorial: function(duda) {
      // Y no de una que está en vuelo: su referencia la lleva un POST que está ocurriendo ahora, así
      // que soltarla aquí es lo que permitiría una segunda escritura de la misma pulsación. No es un
      // control mudo: este botón se dibuja con las dudas pendientes (`dudasPendientes`), que dejan
      // fuera las que están en vuelo, así que desaparece mientras lo esté.
      if (!duda || duda.enVuelo) return;
      this.resolverOperacion(duda.tipo, duda.idFactura, duda.clave);
      this.ultimaEscritura = {
        resumen: 'Has dado por no guardada ' + this.loQueSeEscribia(duda.tipo) + ' de la factura '
          + this.texto(duda.codigoFactura) + ', así que la siguiente sale con una referencia nueva. '
          + 'Si la de antes llegara a aparecer, estará en el historial de esa factura.',
        avisos: [],
        verHistorialDe: { id: duda.idFactura, codigo: duda.codigoFactura },
        mal: true
      };
    },
    /** Qué se hace con cada uno de los cuatro desenlaces. La frase la escribe el servidor. */
    aplicarDesenlace: function(duda, respuesta) {
      const estado = respuesta && respuesta.estado;
      const queEra = this.loQueSeEscribia(duda.tipo) + ' de la factura '
        + this.texto(duda.codigoFactura);
      // El historial se ofrece cuando el servidor dice que es lo que hay que revisar: cuando no ha
      // podido comprobarlo, y cuando ha encontrado más de una gestión que podía ser ésta. Es la
      // condición con la que dirección aceptó ese resto el 10/10/2026: decirlo, no quedarse mudo.
      const historial = respuesta && respuesta.revisaElHistorial
        ? { id: duda.idFactura, codigo: duda.codigoFactura }
        : null;
      // **Y QUIÉN TIENE QUE MIRAR EL HISTORIAL LO DECIDE ESTA RESPUESTA, NO LA ANTERIOR.** Se
      // escribe aquí, una sola vez y antes de ramificar, en vez de en las ramas que lo encienden:
      // así ninguna rama puede olvidarse de apagarlo. Con el `true` puesto por una comprobación que
      // dijo `NO_SE_SABE`, la siguiente que contestara `EN_CURSO` lo dejaba encendido y la pantalla
      // seguía ofreciendo «He mirado el historial y no está: empezar de nuevo» sobre una escritura
      // que el servidor acababa de confirmar que se está ejecutando; pulsarlo suelta la referencia
      // con la que esa escritura no se duplica, y la anotación siguiente sale con una nueva
      // (revisión Codex, ronda 3 del 19/10). Y se queda encendido donde toca: cuando el servidor no
      // ha podido mirarlo, y cuando ha contestado algo que esta pantalla no sabe leer —ahí mirar el
      // historial es lo único que se puede hacer—.
      const conocido = estado === 'EN_CURSO' || estado === 'NO_SE_SABE' || estado === 'HECHA'
        || estado === 'NO_ESTA';
      duda.revisaElHistorial = !!historial || estado === 'NO_SE_SABE' || !conocido;
      if (estado === 'EN_CURSO') {
        this.ultimaEscritura = {
          resumen: 'De ' + queEra + ': ' + this.texto(respuesta.explicacion),
          avisos: [],
          verHistorialDe: historial,
          mal: true
        };
        return;
      }
      if (estado === 'NO_SE_SABE') {
        // No se desbloquea nada y la duda se queda: el servidor NO ha dicho que no se escribiera,
        // ha dicho que no ha podido mirarlo, y tratar eso como un `NO_ESTA` autorizaría un
        // reintento que puede duplicar. Lo que sí se hace es ofrecer lo que la persona puede hacer,
        // y el control de la duda ya lo ha encendido el único sitio que lo decide (arriba).
        this.ultimaEscritura = {
          resumen: 'De ' + queEra + ': ' + this.texto(respuesta.explicacion),
          avisos: [],
          verHistorialDe: historial || { id: duda.idFactura, codigo: duda.codigoFactura },
          mal: true
        };
        return;
      }
      if (!conocido) {
        // Un estado que esta pantalla no conoce no se trata como ninguno de los otros: lo que no se
        // puede hacer es desbloquear afirmando algo que el servidor no ha dicho.
        this.ultimaEscritura = {
          resumen: 'No se ha podido saber qué pasó con ' + queEra + ': el servidor ha contestado '
            + 'algo que esta pantalla no sabe leer. Mira el historial de esa factura antes de '
            + 'volver a anotarla.',
          avisos: [],
          verHistorialDe: { id: duda.idFactura, codigo: duda.codigoFactura },
          mal: true
        };
        return;
      }
      if (estado === 'HECHA') {
        // De quién es el formulario que hay delante se mira ANTES de quitar la duda, porque es la
        // duda la que lo dice: quitada, ya no se podría saber si era suyo.
        const eraSuFormulario = this.dudaDeEstaPromesa === duda;
        this.resolverOperacion(duda.tipo, duda.idFactura, duda.clave);
        // Y su formulario se va de delante, **solo si el de delante es el de esta operación**: la
        // duda ya no está, así que una pulsación más saldría con una referencia nueva y guardaría
        // una segunda promesa —el caso que toda la reconciliación existe para evitar— (revisión
        // CODEX, ronda 11). Y solo el suyo: el borrador de otra factura, o el de otra operación de
        // esta misma, se queda donde está (decisión técnica del 15/10/2026).
        this.cerrarElFormularioDe(duda, eraSuFormulario);
        this.ultimaEscritura = {
          resumen: 'De ' + queEra + ': ' + this.texto(respuesta.explicacion),
          avisos: [],
          verHistorialDe: historial,
          // Que se haya resuelto por una búsqueda con más de un candidato no es un «todo bien»:
          // la gestión está, pero puede no ser la de esta pulsación.
          mal: !!historial
        };
        this.cargar();
        return;
      }
      // NO_ESTA. La duda NO se borra, y eso es a propósito: su clave es la que tiene que llevar el
      // reintento. Si la primera petición llegara con retraso, esa clave ya estaría reclamada y no
      // habría dos anotaciones; con una clave nueva sí las habría. Lo que sí se hace es dejar de
      // pedir que se compruebe —ya está comprobado— y desbloquear el botón.
      // Y basta con marcarla: el botón se enciende porque deja de haber una duda que bloquee, no
      // porque nadie lo encienda (`guardandoPromesa`).
      duda.resuelta = true;
      duda.bloquea = false;
      this.ultimaEscritura = {
        resumen: 'De ' + queEra + ': ' + this.texto(respuesta.explicacion),
        avisos: [],
        verHistorialDe: historial,
        mal: true
      };
    },
    /**
     * Quita de delante el formulario de **esa operación**, y solo si es el que hay delante.
     *
     * Pasa por el dueño del formulario como todos los demás caminos (`formularioEnUso`), con la
     * condición que dice de qué operación habla esta respuesta: así un borrador de **otra** factura
     * que alguien haya abierto entretanto se queda donde está, que es lo que pidió dirección el
     * 15/10/2026. Y no se toca nada más del formulario —ni se limpian sus campos— porque lo que hay
     * escrito en él ya no es de nadie en cuanto deja de estar delante: lo vuelve a volcar
     * `abrirFormularioPromesa` la próxima vez que se abra.
     *
     * **La condición es la operación, no la factura.** `esSuFormulario` lo decide quien llama antes
     * de quitar la duda —es la duda la que dice de quién es el borrador—, porque con dos operaciones
     * de la misma factura y del mismo tipo (dos pestañas) «el formulario de esa factura» no distingue
     * una de otra, y cerrar el de la otra se llevaría por delante lo que esa esté enseñando.
     *
     * Solo las de la promesa tienen formulario; una duda de la gestión no abre ninguno.
     */
    cerrarElFormularioDe: function(duda, esSuFormulario) {
      const self = this;
      if (!duda || duda.tipo !== 'PROMESA' || !esSuFormulario) return;
      self.formularioPromesa.cerrar({
        siEsDe: function() { return self.promesa.idFactura === duda.idFactura; }
      });
    },
    /** Qué se ha anotado, con el importe y la fecha **que ha devuelto el servidor**. */
    resumenDeLaPromesa: function(respuesta, codigoFactura) {
      const comentario = this.comentarioDe(respuesta && respuesta.comentario);
      return 'Promesa anotada en la factura ' + this.texto(codigoFactura) + ': '
        + this.formatEurosExactos(respuesta && respuesta.importeComprometido)
        + ' € para el ' + this.formatFecha(respuesta && respuesta.fechaComprometida) + ' ('
        + this.texto(respuesta && respuesta.rotuloResultado) + ').'
        // El comentario va en el resumen y no solo en la confirmación del formulario: esta frase es
        // la que sobrevive a recargar la pantalla (se guarda en `sessionStorage`), así que sin él la
        // confirmación de dirección se perdería justo al pulsar F5 —que es la mitad del fallo 2 de
        // ABM—. Con un guion cuando no hay ninguno: el campo es opcional y «sin comentario» es un
        // dato, no un hueco.
        + ' Comentario: ' + (comentario === null ? 'ninguno' : '«' + comentario + '»');
    },
    /**
     * Lo que se acaba de anotar, **tal como lo devuelve el servidor**, para enseñarlo en el
     * formulario sin cerrarlo (dirección, 19/10/2026, punto 3).
     *
     * Sale de la respuesta y no de los campos: en un reintento el servidor contesta con la promesa
     * que ya estaba guardada, y eso es lo que hay que leer —no lo que hubiera en el formulario—.
     * Los cuatro datos que pidió dirección, ya rotulados aquí para que el popup solo pinte.
     */
    confirmacionDeLaPromesa: function(respuesta) {
      const promesa = respuesta || {};
      return {
        importe: this.formatEurosExactos(promesa.importeComprometido),
        fecha: this.formatFecha(promesa.fechaComprometida),
        resultado: this.texto(promesa.rotuloResultado),
        explicacionResultado: this.texto(promesa.explicacionResultado),
        // `null` cuando no hay ninguno, para poder decir «no has escrito ninguno» en vez de
        // pintar una raya suelta debajo de un rótulo. Ver `comentarioDe`.
        comentario: this.comentarioDe(promesa.comentario),
        gestion: this.texto(promesa.codigoTarea),
        avisos: this.avisosDe(respuesta)
      };
    },
    /**
     * Los avisos que trae una respuesta de escritura, **como lista y nunca como nulo**.
     *
     * Está aparte porque lo preguntan los dos sitios que cuentan una promesa anotada —la
     * confirmación del formulario y «Lo último que has hecho»— y porque lo que llega es un dato del
     * servidor: una lista, o nada si esa respuesta no los lleva (las promesas del historial no son
     * el resultado de ninguna escritura y no los traen).
     */
    /**
     * El comentario de una promesa, **o `null` si no hay ninguno**.
     *
     * Existe en vez de reutilizar `texto` porque `texto` devuelve un guion cuando no hay nada, y
     * comparar después contra ese guion confundiría un comentario que FUERA un guion con la ausencia
     * de comentario. Aquí hay que distinguir las dos cosas: el campo es opcional y la pantalla dice
     * algo distinto en cada caso.
     */
    comentarioDe: function(valor) {
      if (valor === null || valor === undefined) return null;
      const limpio = String(valor).trim();
      return limpio === '' ? null : limpio;
    },
    avisosDe: function(respuesta) {
      const avisos = respuesta && respuesta.avisos;
      return Array.isArray(avisos) ? avisos.filter(function(a) { return !!a; }) : [];
    },
    /**
     * El importe que el formulario propone: el saldo pendiente, con dos decimales y punto decimal.
     *
     * Punto y no coma porque va en un `<input type="number">`, que solo acepta el punto como
     * separador decimal: con la coma el campo saldría vacío y la propuesta no se vería.
     */
    importePropuesto: function(saldo) {
      if (saldo === null || saldo === undefined || saldo === '') return '';
      const numero = Number(saldo);
      if (isNaN(numero) || numero <= 0) return '';
      return numero.toFixed(2);
    },
    /**
     * El texto de un fallo de la API.
     *
     * El error llega **aplanado** en `e.message`, no dentro de un cuerpo con estructura, así que lo
     * que el servidor ha escrito para la persona —«pon el importe», «esa factura no está en tu
     * lista»— se lee de ahí. El 403 se distingue porque su mensaje es el motivo de no entrar y
     * conviene enseñarlo tal cual.
     */
    textoDelFallo: function(e, porDefecto) {
      if (!e) return porDefecto;
      if (typeof e == 'string') return e;
      return e.message || e.error || e.error_description || porDefecto;
    },
    /**
     * Una fecha del servidor (`2026-10-02`) como se escribe aquí: `02/10/2026`. Sin `new Date()`,
     * que interpreta la cadena en UTC y en Valladolid puede devolver el día de antes.
     */
    formatFecha: function(valor) {
      if (!valor) return '—';
      const partes = String(valor).substring(0, 10).split('-');
      if (partes.length !== 3) return String(valor);
      return partes[2] + '/' + partes[1] + '/' + partes[0];
    },
    /** Un instante del servidor como `02/10/2026 17:40`. */
    formatFechaHora: function(valor) {
      if (!valor) return '—';
      const texto = String(valor);
      const dia = this.formatFecha(texto);
      const hora = texto.length >= 16 ? texto.substring(11, 16) : '';
      return hora ? dia + ' ' + hora : dia;
    },
    /**
     * Euros enteros, que es como se leen **los saldos**. Un hueco es un guion, nunca un cero.
     *
     * Con el punto de los miles puesto a mano y sin `toLocaleString('es-ES')`, que depende del ICU
     * del navegador y en algunos deja las cifras de cuatro dígitos sin agrupar: «6301 €» al lado de
     * «12.400 €» se lee como dos formatos distintos en la misma lista.
     *
     * **No vale para la promesa de pago**: ésa la teclea el gestor con céntimos y tiene que volver a
     * leerse igual que se guardó. Para eso está `formatEurosExactos`.
     */
    formatEuros: function(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      const numero = Math.round(Number(valor));
      if (isNaN(numero)) return '—';
      return (numero < 0 ? '-' : '') + this.conMiles(Math.abs(numero));
    },
    /**
     * Euros **con sus céntimos**: `1000.5` → «1.000,50».
     *
     * Hace falta para el importe de la promesa de pago y solo para él. Es el único importe de esta
     * pantalla que una persona ha **teclado** —el campo admite `step="0.01"`— y el criterio 9 pide
     * que al volver a abrir la pantalla se lea *lo que se guardó*: redondeándolo, una promesa de
     * 1.000,50 € se enseñaría como «1.001 €» en la ficha, en el historial y en el aviso de después
     * de guardar, o sea una cantidad que el cliente no ha prometido y que no está en la base.
     *
     * Los saldos siguen en euros enteros (`formatEuros`): son cifras leídas, no escritas, y así se
     * leen en toda la cartera del Centro de Cobros y en el ejemplo que fijó dirección —«6.301 € · 7
     * días vencida · 4 días sin gestión»—.
     */
    formatEurosExactos: function(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      const numero = Number(valor);
      if (isNaN(numero)) return '—';
      // `toFixed(2)` antes de separar: es lo que fija los dos decimales y además redondea el tercero
      // si la base trajera más, que es lo mismo que hace `conDosDecimales` en la API.
      const fijo = Math.abs(numero).toFixed(2);
      const corte = fijo.indexOf('.');
      return (numero < 0 ? '-' : '')
        + this.conMiles(fijo.substring(0, corte)) + ',' + fijo.substring(corte + 1);
    },
    /**
     * Las cifras enteras con el punto de los miles. Un solo sitio: los dos formateadores de euros
     * agrupan igual, y tenerlo escrito dos veces es cómo acaban agrupando distinto.
     */
    conMiles: function(entero) {
      const cifras = String(entero);
      let salida = '';
      for (let i = 0; i < cifras.length; i++) {
        if (i > 0 && (cifras.length - i) % 3 === 0) salida += '.';
        salida += cifras.charAt(i);
      }
      return salida;
    },
    /**
     * Un número, con el hueco como guion.
     *
     * D-COB-8 en una línea: una factura sin fecha de vencimiento no tiene «0 días de retraso», tiene
     * «no se sabe», y un cero ahí se lee como que está al día.
     */
    numero: function(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      const numero = Number(valor);
      return isNaN(numero) ? '—' : String(numero);
    },
    /** Un texto, con el hueco como guion. Mismo motivo que `numero`. */
    texto: function(valor) {
      return valor === null || valor === undefined || valor === '' ? '—' : String(valor);
    },
    /**
     * Abre la ficha de la factura **en una pestaña nueva**, en modo solo lectura.
     *
     * Pestaña nueva y no `$f7router.navigate` por lo mismo que en la bandeja de #188: lo que hay
     * escrito en el formulario de la promesa es estado de esta pantalla y salir de ella lo tira.
     *
     * Con `window.open` y no con un `<a target="_blank">` porque el router de Framework7 intercepta
     * los href internos y se quedaría en la misma pestaña. La URL va relativa al fragmento, que es
     * lo que funciona también si la aplicación se sirve bajo un subcamino.
     */
    abrirFicha: function(ficha) {
      if (!ficha || !ficha.id) return;
      window.open('#!/facturas/view/' + encodeURIComponent(ficha.id) + '/', '_blank', 'noopener');
    }
  }
};
</script>
